import ukExplanation from './uk/uk.explanation'
import certificationNewKtz from './uk/certificationNewKtz'

export default {
  ...ukExplanation,
  ...certificationNewKtz,
  error: {
    notfound: 'Сторінку не знайдено',
    other: 'Виявлено помилку'
  },
  login: {
    title: 'Увійти',
    email: 'Електронна адреса',
    password: 'Пароль',
    button: 'Увійти',
    orsign: 'Або увійти за допомогою',
    forgot: 'Забули пароль?',
    noaccount: 'Не маєте облікового запису?',
    create: 'Створити тут',
    error: 'Введено неправильний логін / пароль'
  },
// Vuetify components translations
  $vuetify: {
    loading: 'Завантаження',
    badge: 'Значок',
    close: 'Закрити',
    dataIterator: {
      noResultsText: 'Відповідних записів не знайдено',
      loadingText: 'Завантаження елементів...'
    },
    dataTable: {
      itemsPerPageText: 'Рядки на сторінці:',
      ariaLabel: {
        sortDescending: 'Відсортовано за спаданням.',
        sortAscending: 'Відсортовано за зростанням.',
        sortNone: 'Не відсортовані.',
        activateNone: 'Активуйте, щоб прибрати сортування.',
        activateDescending: 'Активуйте, щоб сортувати за спаданням.',
        activateAscending: 'Активуйте, щоб сортувати за зростанням.'
      },
      sortBy: 'Сортувати за'
    },
    dataFooter: {
      itemsPerPageText: 'Елементів на сторінці:',
      itemsPerPageAll: 'Усі',
      nextPage: 'Наступна сторінка',
      prevPage: 'Попередня сторінка',
      firstPage: 'Перша сторінка',
      lastPage: 'Остання сторінка',
      pageText: '{0}-{1} of {2}'
    },
    datePicker: {
      itemsSelected: '{0} вибрано',
      nextMonthAriaLabel: 'Наступний місяць',
      nextYearAriaLabel: 'Наступний рік',
      prevMonthAriaLabel: 'Попередній місяць',
      prevYearAriaLabel: 'Попередній рік',
      dateStart: 'Дата початку',
      dateEnd: 'Дата кінця'
    },
    noDataText: 'Дані відсутні',
    carousel: {
      prev: 'Previous visual',
      next: 'Next visual',
      ariaLabel: {
        delimiter: 'Carousel slide {0} of {1}'
      }
    },
    calendar: {
      moreEvents: '{0} більше'
    },
    fileInput: {
      counter: '{0} файли',
      counterSize: '{0} файлів ({1} загалом)'
    },
    timePicker: {
      am: 'AM',
      pm: 'PM'
    },
    pagination: {
      ariaLabel: {
        wrapper: 'Навігація пагінацією',
        next: 'Наступна сторінка',
        previous: 'Попередня сторінка',
        page: 'Перейти на сторінку {0}',
        currentPage: 'Поточна сторінка, Сторінка {0}'
      }
    }
  },
  mainInfo: 'Загальна інформація',
  welcome: 'Вхід до застосунку',
  welcome2: 'Щоб розпочати роботу у застосунку, виконайте вхід у свій акаунт.',
  signBy2F: 'Введіть код двухфакторної авторизації',
  createBy2F: 'Відскануйте QR-код та введіть код двухфакторної авторизації',
  code: 'Код',
  // project: 'Проект',
  btn: {
    ok: 'OK',
    no: 'Ні',
    add: 'Додати',
    remove: 'Видалити',
    open: 'Відкрити',
    close: 'Закрити',
    back: 'Назад',
    sign: 'Увійти',
    approve: 'Схвалити',
    reject: 'Відхилити',
    rejectStatement: 'Відхилити заявку',
    save: 'Зберегти',
    saveAndContinue: 'Зберегти і продовжити',
    detail: 'Деталі',
    edit: 'Редагувати',
    restore: 'Відновити',
    editMTZ: 'Редагувати МТЗ',
    addMTZ: 'Додати МТЗ',
    saveAndNext: 'Зберегти та продовжити',
    clear: 'Очистити',
    clearForm: 'Очистити форму',
    find: 'Шукати',
    next: 'Далі',
    previous: 'Попередня',
    cancel: 'Скасувати',
    choose: 'Обрати',
    uploadProofs: 'Завантаження доказової бази',
    saveDecision: 'Переглянути рішення',
    viewStatement: 'Переглянути заявку',
    viewIdentificationAct: 'Переглянути акт ідентифікації',
    startInspection: 'Почати огляд',
    connectToStand: 'Підключитися до стенду',
    startMeasurement: 'Почати вимірювання',
    startWarmingUp: 'Почати прогрівання',
    stopMeasurement: 'Зупинити вимірювання',
    repeatMeasurement: 'Повторне вимірювання',
    chooseCertificationLaboratory: 'Обрати ОС',
    setCategory: 'Виставити категорію',
    createBranch: 'Додати філію',
    start: 'Почати',
    reboot: 'Перезапусти',
    check: 'Перевірити',
    createStatement: 'Створити заявку',
    createLaboratory: 'Додати лабораторію',
    selectLaboratory: 'Вибрати лабораторію',
    addTire: 'Додати колесо',
    removeTire: 'Видалити колесо',
    addAxis: 'Додати вісь',
    addWindow: 'Додати вікно',
    addSeatBelt: 'Додати ремінь',
    addHeadlight: 'Додати фару',
    previousStep: 'Повернутись назад',
    reset: 'Скинути',
    setSign: 'Підписати',
    setSignStatement: 'Підписати заяву',
    setSignStatementDecision: 'Підписати рішення по заяві',
    addSignature: 'Додати підпис або печатку',
    deleteSignature: 'Видалити підпис або печатку',
    read: 'Зчитати',
    show: 'Показати',
    hide: 'Сховати',
    closeSession: 'Завершити сеанс',
    cardInspection: 'Картка огляду',
    setCompliance: 'Виставити відповідності',
    addMore: 'Додати ще',
    viewProtocolCompliance: 'Протокол відповідностей',
    lightInspection: 'Випробування світловипромінення',
    lightTransmissionInspection: 'Випробування світлопроникності',
    brakeInspection: 'Випробування гальмівних систем',
    gasInspection: 'Випробування газоаналізатор',
    smokeInspection: 'Випробування димомір',
    noiseInspection: 'Випробування шуму',
    decisionIssuing: 'Рішення про ймовірність видачі сертифікату',
    certificate: 'Сертифікат',
    addonCertificate: 'Додаток до сертифікату',
    toStatement: 'До заявки',
    confirm: 'Підтвердити',
    printPdf: 'Друк PDF',
    registrationOC: 'Реєстрація ОС',
    registrationVL: 'Реєстрація ВЛ',
    toComplete: 'Завершити реєстрацію',
    update: 'Оновити',
    addContract: 'Додати договір',
    set: 'Встановити',
    addEmployee: 'Додати працівника',
    verificationOfPersonalDataFromEDS: 'Перевірка персональних даних з ЕЦП',
    paid: 'Оплачено',
    view: 'Переглянути',
    statementsOfCooperation: 'Заяви на співпрацю',
    cooperationAgreements: 'Угоди про співпрацю',
    updateAgreement: 'Оновити угоду',
    createAgreement: 'Створити нову угоду',
    selectAllCategories: 'Обрати всі категорії',
    readMore: 'Читати більше',
    backToInspection: 'Повернутись до огляду',
    deactivate: 'Деактивувати',
    activate: 'Активувати',
    standRelease: 'Відключитись від стенду',
    matchesDocuments: 'Відповідає',
    notMatchesDocuments: 'Не відповідає',
    setSignIdentificationAct: 'Підписати акт ідентифікації',
    download: 'Завантажити',
    saveWorkLine: 'Відправити лінію на перевірку',
    sendMTZToModeration: 'Відправити МТЗ на перевірку',
    sendToRecheck: 'Відправити на перевірку',
    confirm: 'Затвердити',
    goToMeasurement: 'Перейти до вимірювання',
    goToHeadlightList: 'Перейти до вибору фари',
    getResults: 'Отримати результати',
    addValue: 'Додати значення',
    toHeadlightList: 'До списку фар',
    completeMeasurementGoToStatement: 'Завершити випробування та повернутися до заявки',
    terminateEquipment: 'Звільнити прилад',
    setCharacteristics: 'Виставити характеристики',
    addNewBranch: 'Додати нову дільницю',
    collapse: 'Згорнути',
    showDetailedStatementInfo: 'Детальна інформація по заявці',
    addNewRuleBase: 'Додати Технічний припис',
    toFillCharacteristics: 'До заповнення характиристик КТЗ',
    goToCharacteristics: 'Характиристики КТЗ'
  },
  clientAddress: {
    index: 'Індекс',
    region: 'Область',
    city: 'Місто/Село',
    typeAddress: 'Тип адреси',
    typeCity: 'Тип населеного пункта',
    nameCity: 'Назва населеного пункта',
    street: 'Вулиця',
    house: 'Дім',
    flat: 'Квартира',
    flatRooms: 'Квартира/Приміщення',
    typesStreet: {
      street: 'Вулиця',
      lane: 'Провулок',
      prospectus: 'Проспект',
      square: 'Площа',
      boulevard: 'Бульвар',
      trunk: 'Магістраль',
      maidan: 'Майдан',
      highway: 'Шосе',
      alley: 'Алея',
      pickUp: 'Узвіз',
      nameAddress: 'Назва адреси'
    }
  },
  addNewCity: {
    title: 'Додати населений пункт',
    noInList: "Немає в списку",
    successAddNewCity: 'Нове місто успішно додано',
    errorAddNewCity: 'Сталась помилка при додаванні міста'
  },
  lightMeasurement: {
    title: 'Випробування світловипромінення',
    instruction: {
      title: 'Інструкція',
      dipped: `<li>Встановіть прилад паралельно вісі автомобіля, на відстані 25-50 см від лівої(правої) фари, що працює у режимі ближнє світло так, щоб джерело світла фари чи позначка центру фари, знаходилося по центру лінзи реглоскопа.</li>
              <li>Почніть вимірювання в режимі "ближнє світло".</li>
              <li>Очікуйте відображення данних на екрані приладу. Оберіть характеристику, що вимірюється у таблиці Результатів. Очікуйте відображення результату у таблиці.</li>
              <li>Перемкніть вимикач у інший режим вимірювань.</li>
              <li>Очікуйте відображення данних на екрані приладу. Оберіть характеристику, що вимірюється у таблиці Результатів. Очікуйте відображення результату у таблиці.</li>
              <li>Зазначте кут нахилу фари.</li>`,
      high: `<li>Встановіть прилад паралельно вісі автомобіля, на відстані 25-50 см від лівої(правої) фари, що працює у режимі дальнього світла так, щоб джерело світла фари чи позначка центру фари, знаходилося по центру лінзи реглоскопа.</li>
             <li>Почніть вимірювання в режимі "дальнє світло".</li>
             <li>Очікуйте відображення данних на екрані приладу. Оберіть характеристику, що вимірюється у таблиці Результатів. Очікуйте відображення результату у таблиці.</li>`,
      fog: `<li>Встановіть прилад паралельно вісі автомобіля, на відстані 25-50 см від лівої(правої) протитуманної фари так, щоб джерело світла фари чи позначка центру фари, знаходилося по центру лінзи реглоскопа.</li>
            <li>Почніть вимірювання в режимі "дальнє світло".</li>
            <li>Очікуйте відображення данних на екрані приладу. Оберіть характеристику, що вимірюється у таблиці Результатів. Очікуйте відображення результату у таблиці.</li>
            <li>Зазначте кут нахилу фари.</li>`,
    },
    alert: {
      text: 'Для того щоб завершити випробування - зробіть всі виміри на усіх фарах.'
    },
    headlightList: 'Список фар для вимірювання',
    distanceForNormative: 'Відстань від нижнього краю видимої поверхні фари до опорної поверхні',
    leftLightPower: 'Дальня сила світла ліва фара',
    rightLightPower: 'Дальня сила світла права фара',
    headlightType: 'Тип фари',
    cornerInclinationLeft: 'Кут нахилу ближнього світла лівої фари',
    cornerInclinationRight: 'Кут нахилу ближнього світла правої фари',
    lowLightPowerBeamLeft: 'Ліва фара, ближне світло у зоні малої освітленості',
    lowLightPowerBeamRight: 'Права фара, ближне світло у зоні малої освітленості',
    highLightPowerBeamLeft: 'Ліва фара, ближне світло у зоні інтенсивної освітленості',
    highLightPowerBeamRight: 'Права фара, ближне світло у зоні інтенсивної освітленості',
    minHighLightPowerBeam: 'Ближне світло у зоні інтенсивної освітленості не менше {value}',
    missingFogLight: 'Протитуманні фари відсутні',
    fogLightCornerLeft: 'Ліва фара нахил до низу променя протитуманної фари',
    fogLightCornerRight: 'Права фара нахил до низу променя протитуманної фари',
    fogLightLeft: 'Сила світла ліва протитуманна фара',
    fogLightRight: 'Сила світла права протитуманна фара',
    maxLowLightPowerBeam: 'Ближнє світло у зоні малої освітленості не більше {value}',
    fogLightHint: 'Не більше 625 кд (протитуманні фари у т. О)',
    fullLightPower: 'Сумарна сила дальнього світла',
    // MinMaxFullLightPower: 'Сумарна сила дальнього світла повинная бути 20000 - 225000',
    cornerInclination: 'Кут нахилу фари',
    // cornerInclinationHint: 'Кут нахилу фар повинен бути {0} - {1}',
    fogDistanceForNormative: 'Відстань від нижнього краю видимої поверхні протитуманні фари до опорної поверхні',
    // start for l category
    distanceForNormativeForLCategory: 'Відстань від нижнього нижнього краю видимої поверхні',
    cornerInclinationLeftForLCategory: 'Кут нахилу променя ближнього світла',
    lowLightPowerBeamLeftForLCategory: 'Сила фари ближньго світла у зоні малої освітленності',
    highLightPowerBeamLeftForLCategory: 'Сила фари ближньго світла у зоні значної освітленності',
    leftLightPowerForLCategory: 'Сила світла фари дальнього світла',
    fogLightCornerLeftForLCategory: 'Кут нахилу протитуманної фари',
    fogLightLeftForLCategory: 'Сила світла протитуманної фари',
    // end for l category
    // name group
    group: {
      lowLightPowerBeamLeft: 'Ліва фара у режимі ближнє світло:',
      lowLightPowerBeamRight: 'Права фара у режимі ближнє світло:',
      hightLightPowerBeamLeft: 'Ліва фара у режимі дальнє світло:',
      hightLightPowerBeamRight: 'Права фара у режимі дальнє світло:',
      hightBeam: 'Дальнє світло:',
      fogLights: 'Протитуманні фари:',
      fogLightLeft: 'Ліва протитуманна фара:',
      fogLightRight: 'Права протитуманна фара:'
    }
  },
  lightTransmissionMeasurement: {
    title: 'Вимірювання світопропускання скла',
    instruction: {
      title: 'Інструкція',
      text: `
        <li>Виконайте вимір в умовній середній точці вікна.</li>
        <li>Виконайте вимір у верхній тонованій частині вікна.</li>
        <li>Виконайте вимір у нижній тонованій частині скла.</li>
        <li>Ознайомтесь з результатом вимірювань.</li>
        <li>Перейдіть до вибору іншого вікна.</li>
      `
    },
    alert: {
      text: 'Для того щоб завершити випробування - зробіть виміри на усіх вікнах.'
    },
    resultMeasurementWindow: 'Результат вимірювання скла',
    sample1: 'Вимір у перщій точці',
    sample2: 'Вимір у другій точці',
    sample3: 'Вимір у третій точці',
    avg: 'Зведений показник тонування',
    getAvg: 'Отримати зведений показник тонування',
    toWindowList: 'До списку вікон',
    windowList: 'Список вікон для вимірювання',
    thereIsNoMeasurement: 'Вимірювання відсутнє',
    startMeasurement: 'Зробити вимір',
    waitForTheMeasurementToFinish: 'Зачекайте завершення виміру'
  },
  brakeMeasurement: {
    title: 'Випробування гальмів',
    alert: {
      text: 'Для того щоб завершити випробування - зробіть виміри на усіх вісях.'
    },
    axesList: 'Список вісей для вимірювання',
    axis: 'Вісь',
    toAxesList: 'До списку вісей',
    typesMeasurement: 'Тип вимірювання',
    resultMeasurementAxis: 'Результат вимірювання вісі',
    axisWeight: 'Вага вісі',
    leftBrakeForce: 'Гальмівне зусилля на лівій стороні',
    rightBrakeForce: 'Гальмівне зусилля на правій стороні',
    wheelBrakingForce: 'Гальмівне зусилля колеса',
    irregularityCoeff: 'Коефіцієнт нерівномірності гальмівних зусиль',
    triggeringTime: 'Тривалість спрацювання гальмівної системи',
    controlBrakeForce: 'Зусилля на органі керування',
    runSGS: 'Для завершення вимірюваннь, проведіть вимірювання стояночної гальмівної системи (СГС)',
    parameters: {
      title: 'Внесення характеристик',
      typeWorkingBrakingSystem: 'Тип гальмівних систем',
      controlBrakeForceType: 'Тип органу управління стояночної тормозної системи (СГС)',
      antiBlockingSystem: 'КТЗ обладнано антиблокувальною системою АВS',
      RGSActivatedWithoutTheForceOfTheDriver: 'РГС спрацьовує без силового впливу водія',
      inertiaBrakingSystem: 'КТЗ обладнано інерційною гальмівною системою',
      ktzDoesNotRequireMeasurementSGS: 'КТЗ не потребує випробувань СГС'
    },
    zigbee: {
      motorStartDelay: {
        title: 'Затримка старту випробування',
        selectMotorStartDelay: `Зазначте тривалість затримки ввімкнення моторів стенду з моменту появи КТЗ на стенді в секундах"`,
        bookedMotorStartDelay: `Зазначена тривалість затримки ввімкнення моторів стенду з моменту появи КТЗ на стенді`,
        beforeToMotorStartRemains: `Запуск моторів стенду через`
      },
      statuses: {
        waitingForVehicle: 'Встановіть КТЗ на роликовий стенд',
        waitingForBrake: 'Почніть випробування гальм',
        equipmentIsBusy: 'Прилад зайнятий, виберіть інший прилад'
      },
      axleWithOneWheel: 'Вісь з одним колесом',
      emergencyStop: 'Екстренна зупинка'
    }
  },
  calibrationBrakeStandMQTT: {
    title: 'Тарування гальмівного стенду MQTT',
    selectEquipmentForCalibration: 'Виберіть прилад для калібрування',
    startCalibration: 'Провести тарування',
    startCalibrationAllTypes: 'Провести тарування усіх датчиків',
    valueOnTheSensor: 'Значення на датчику',
    successCalibration: 'Калібрування успішно завершено',
    types: {
      title: 'Типи датчиків для тарування',
      AW: 'Датчик ваги',
      LBF: 'Датчик гальмівного зусилля зліва',
      RBF: 'Датчик гальмівного зусилля справа',
      BS: 'Показник педометра'
    }
  },
  smokeMeasurement: {
    title: 'Випробування димомір',
    alert: {
      text: 'Для того щоб завершити випробування - зробіть виміри на усіх глушниках.',
      description: 'Випробування проводяться після продувки системи, що складається з 6 циклів'
    },
    silencersList: 'Список глушників для вимірювання',
    toSilencersList: 'До списку глушників',
    silencer: 'Глушник',
    measurement1: 'Натуральний коефіцієнт поглинання 3 вимір',
    measurement2: 'Натуральний коефіцієнт поглинання 4 вимір',
    measurement3: 'Натуральний коефіцієнт поглинання 5 вимір',
    measurement4: 'Натуральний коефіцієнт поглинання 6 вимір',
    absorptionLevels: 'Натуральні коефіцієнти поглинання проведених вимірювань',
    oilTemperature: 'Температура масла',
    waitForTheMeasurementToFinish: 'Зачекайте завершення виміру',
    addOilTemperature: 'Додайте теспературу масла',
    resultMeasurementSilencer: 'Результат вимірювання глушника',
    smokinessLimitIndicator: 'Скориговане значення натурального показника поглинання згідно познаки',
    setSmokinessLimitIndicator: `Внести скориговане значення натурального показника поглинання згідно познаки (за наявності)`,
    addSmokinessLimitIndicator: 'Додати скориговане значення',
    successAddSmokinessLimitIndicator: 'Скориговане значення додано',
    successRemovedSmokinessLimitIndicator: 'Скориговане значення видалено',
    proofSmokinessLimitIndicator: 'Познака скоригованого значення'
  },
  gasMeasurement: {
    title: 'Випробування газоаналізатор',
    alert: {
      text: 'Для того щоб завершити випробування - зробіть виміри на усіх глушниках.',
      description: 'Випробування проводяться на мінімальних та максимальних обертах'
    },
    silencersList: 'Список глушників для вимірювання',
    toSilencersList: 'До списку глушників',
    silencer: 'Глушник',
    excessAirFactor: 'Коефіцієнт надлишку повітря',
    rMinLambda: 'Коефіцієнт надлишку повітря, мінімальні оберти двигуна',
    rMaxLambda: 'Коефіцієнт надлишку повітря, підвищені оберти двигуна',
    rMinCoLevel: 'Рівень вмісту СО, мінімальні оберти двигуна',
    rMinChLevel: 'Рівень вмісту СН, мінімальні оберти двигуна',
    rMinTemperature: 'Температура охолоджувальної рідини / моторної оливи, мінімальні оберти двигуна',
    rMinRpm: 'Частота обертання двигуна, мінімальні оберти двигуна',
    rMaxCoLevel: 'Рівень вмісту СО, підвищені оберти двигуна',
    rMaxChLevel: 'Рівень вмісту СН, підвищені оберти двигуна',
    rMaxTemperature: 'Температура охолоджувальної рідини / моторної оливи, підвищені оберти двигуна',
    rMaxRpm: 'Частота обертання двигуна, підвищені оберти двигуна',
    waitForWarmingUpTheEngine: 'Зачекайте завершення прогрівання двигуна',
    waitForTheMeasurementToFinish: 'Зачекайте завершення виміру',
    resultMeasurementSilencer: 'Результат вимірювання глушника',
    resultMeasurementSilencerRMin: 'На мінімальних обертах двигуна',
    resultMeasurementSilencerRMax: 'На максимальних обертах двигуна',
    addRpm: 'Додайте частоту обертання двигуна',
    addTemperature: 'Додайте температуру охолоджувальної рідини / моторної оливи',
    savingRpm: 'Частоту обертання двигуна збережено',
    savingTemperature: 'Температура охолоджувальної рідини / моторної оливи збережено',
    endMeasurementMinRpm: 'Вимірювання на обертах від 700 до 900 об/хв завершено',
    endMeasurementMaxRpm: 'Вимірювання на обертах від 2000 до 2400 об/хв завершено',
    endWarmingUp: 'Прогрівання двигуна на обертах від 2000 до 2400 об/хв завершено'
  },
  measurementTable: {
    mode: 'Режим вимірювання',
    result: 'Результат виміру',
    action: 'Дія',
  },
  countMeasurements: 'Кількість вимірювань',
  measurementAlreadyCompleted: 'Вимірювання вже завершено',
  measurementCornerAlreadyCompleted: 'Кут нахилу вже зазначено',
  currentGasInspection: 'Випробування газоаналізатор',
  selectLaboratoryTitle: 'Вибір філіалу вимірювальної лабораторії',
  laboratorySelectLabel: 'Філіал вимірювальної лабораторії',
  reasonDiscrepancy: 'Причина невідповідності',
  reasonDiscrepancyTitle: 'Вкажіть причину невідповідності',
  clientSignature: 'Підпис клієнта',
  setYourSignature: 'Поставте свій підпис вище',
  inputLabel: {
    availabilitySensorLeft: 'Сенсор Наявності, Лівий',
    availabilitySensorRight: 'Сенсор Наявності, Правий',
    brakingForceLeft: 'Тормозне зусилля, Лівий',
    brakingForceRight: 'Тормозне зусилля, Правий',
    coefficientWeight: 'Коеф. Ваги',
    diametrLeft: 'Діаметр, Лівий',
    diametrRight: 'Діаметр, Правий',
    holesLeft: 'Отворів, Лівий',
    holesRight: 'Отворів, Правий',
    minSpeed: 'Мін швидкість',
    minWeight: 'Мін вага',
    regloscopeCoefficient: 'Коефіціент реглоскопа',
    maxWeight: 'Макс вага',
    rotationSensorLeft: 'Сенсор оберту, Лівий',
    rotationSensorRight: 'Сенсор оберту, Правий',
    armForceFactor: 'Коефіціент зусилля датчика стоянкового гальма',
    pedalForceFactor: 'Коефіціент зусилля датчика  гальма'
  },
  profile: {
    profile: 'Профіль',
    name: 'Ім\'я',
    key: 'Ключ U2F',
    security: 'Безпека'
  },
  main: 'Головна',
  settings: 'Налаштування',
  authTOTP: 'Двухфакторна авторизація TOTP',
  authU2F: 'Двухфакторна авторизація U2F',
  notes: 'Примітки',
  note: 'Примітка',
  no: 'Ні',
  notUseForVehicle: 'Не застосовано',
  noNeed: 'Не передбачено проектом',
  unit: 'Одиниця виміру',
  size: 'Розмір',
  units: {
    format: 'ДД.ММ.РРРР',
    formatRange: 'ДД.ММ.РРРР ~ ДД.ММ.РРРР',
    year: 'рік',
    years: 'рік(ів)',
    ton: 'т',
    kg: 'кг',
    people: 'чоловік',
    pieces: 'шт',
    meter: 'м',
    cubicMeter: 'м³',
    cubicSM: 'cм³',
    knot: 'узел',
    mm: 'мм',
    speed: 'км/г',
    hP: 'к.с.',
    kw: 'кВт',
    power: 'В',
    horsepower: 'к.с',
    miles: 'Милі',
    squareMeter: 'м²',
    volt: 'В',
    mile: 'мілі',
    km: 'км',
    litre: 'л',
    megaPascal: 'мПа',
    kiloPascal: 'кПа',
    pascal: 'Па',
    newton: 'Н',
    kilonewton: 'кН',
    rpm: 'об/хв',
    tpm: 'разів/хв',
    c: '°C',
    degree: '°',
    percent: '%',
    second: 'c',
    naturCoef: 'К, м<sup>-1</sup>',
    linrCoef: 'N, %',
    coef: 'K',
    dB: 'дБ',
    radius: 'R',
    volume: 'млн-1',
    kd: 'кд',
    inch: 'Дюйми',
    kwKg: 'кВт/кг',
    number: '№',
    miles: 'мл',
    lambda: 'λ',
    ms: 'м/с',
    kiloPascal: 'kPa'
  },
  chooseProject: 'Оберіть поект, що відповідає параметрам судна.',
  orAddNew: 'або створіть новий',
  action: 'Дія',
  fullName: 'ПІБ',
  region: 'Область',
  shipCount: 'Кількість суден',
  createAt: 'Дата створення',
  legalType: 'Тип',
  individual: 'Фіз. особа',
  // owner: 'Судоавласник',
  menu: {
    main: 'Головна',
    statements: 'Заяви',
    certification: 'Сертифікація',
    newCertification: 'Нові заявки на сертифікацію',
    newTechnicalControl: 'Нові заявки на ОТК',
    certificationForSign: 'Очікує підписання',
    measurements: 'Вимірювання',
    users: 'Користувачі',
    branches: 'Випробувальна лабораторія',
    settings: 'Налаштування',
    stands: 'Стенди',
    cabinet: 'Кабінет',
    techControl: 'ОТК',
    certificationManual: 'Сертифікація нових КТЗ',
    certificationManualSubtitle: 'ручне внесення'
  },
  status: 'Статус',
  statusWorkLine: 'Статус робочої лінії',
  statuses: {
    default: '-',
    rejected: 'Відкликанний',
    clientWaitReview: 'Очікує перегляду',
    clientWaitReviewTransport: 'Очікує ТЗ для огляду',
    completed: 'Завершено',
    createByLaboratory: 'Створено випробувальною лабораторією',
    waitForClientSignature: 'Очікує підпису клієнтом',
    statementWaitForCategoryChoices: 'Очікує вибору категорії КТЗ',
    statementWaitForDecision: 'Очікує рішення',
    statementReject: 'Відхилено',
    statementAllowedForInspection: 'Допущено до огляду',
    statementWaitSignature: 'Очікує підпису',
    defaultWaitSignature: 'Очікує підписання',
    decisionStatusWaitForSignature: 'Очікує підписання',
    statementDecisionWaitForDecision: 'Очікує рішення',
    statementDecisionValid: 'Дійсний',
    decisionDecisionApproved: 'Схвалено',
    decisionDecisionReject: 'Відхилено',
    decisionDecisionWaitChoice: 'Очікує вибору',
    inspectionWaitComplianceCompleted: 'Очікує заповнення відповідностей до правових актів',
    inspectionUploadProofs: 'Завантаження доказової бази',
    inspectionWaitForDecision: 'Очікує рішення щодо можливості видачі сертифіката',
    inspectionConsideration: 'На огляді ОС',
    inspectionProcessing: 'Перепрацювання',
    statementDecisionWaitSignature: 'Очікує підписання рішення',
    statementInProgressInspection: 'Проводиться перевірка відповідності',
    statementCertificateInProgress: 'Проводиться видача сертифікату',
    statementCertificateIssued: 'Сертифікат видано',
    statementCertificateNotIssued: 'Сертифікат не видано',
    statementWaitForLaboratory: 'Очікує вибору філії лабораторії',
    statementWaitForCertificationAgency: 'Очікує вибору органу сертифікації',
    inspectionWaitStand: 'Очікує проведення випробування',
    statementDecisionWaitForSignatureAuditor: 'Очікує підписання Аудитором ОС',
    statementDecisionWaitForSignatureDireector: 'Очікує підписання Керівника ОС',
    statementWaitSignatureAuditor: 'Очікує підписання Аудитором ОС',
    statementWaitSignatureManager: 'Очікує підписання менеджера ВЛ',
    statementWaitReprocessing: 'Проводиться доопрацювання Протоколу',
    inspectionWitSignatureLabExpert: 'Очікує підписання лаборанта ВЛ',
    inspectionWitSignatureLabChief: 'Очікує підписання керівника дільниці ВЛ',
    inspectionWaitReprocessing: 'Проводиться доопрацювання Протоколу',
    waitingAddInspectionProtocolNumber: 'Очікує внесення номеру Протоколу огляду КТЗ',
    statementProcessMTIFinished: 'Процедуру ОТК завершено',
    inspectionIssueCertificate: 'Видача сертифіката відповідності',
    inspectionRejected: 'Відхилено',
    decisionIssueCertificateWaitDecision: 'Очікує вибору',
    decisionIssueCertificateValid: 'Дійсний',
    decisionIssueCertificateWaitSignatureAuditor: 'Очікує підписання Аудитора ОС',
    decisionIssueCertificateWaitSignatureDirector: 'Очікує підписання Директора ОС',
    certificateWaitSignatureDirector: 'Очікує підписання Директора ОС',
    certificateWaitSignatureAuditor: 'Очікує підписання Аудитора ОС',
    certificateValid: 'Дійсний',
    statementDecisionWaitForSignatureDirector: 'Очікує підписання Директора ОС',
    decisionIssueCertificateWaitReprocessing: 'Переоформлення',
    identificationActWaitDecisionAuditor: 'Очікує рішення по акту ідентифікації',
    identificationActWaitSignatureForAuditor: 'Акт очікує підпису аудитора ОС',
    identificationActWaitSignatureForManager: 'Очікує підписання менеджера ВЛ',
    contractAwaitingDecision: 'Очікує рішення',
    contractValid: 'Дійсний',
    contractInvalid: 'Недійсний',
    contractNeedsExtension: 'Потребує пролонгації',

    statementManualWaitForClientSignature: 'Очікує підписання клієнтом',
    statementManualWaitSignatureAuditor: 'Очікує підписання аудитора ОС',
    statementManualWaitSignatureManager: 'Очікує підписання менеджера ВЛ',
    statementManualWaitActIdentificationDecision: 'Очікує рішення по акту ідентифікації',
    statementManualActIdentificationWaitSignatureAuditor: 'Акт очікує підпису аудитора ОС',
    statementManualActIdentificationWaitSignatureManager: 'Очікує підписання менеджера ВЛ',
    statementManualWaitForCertificationAgencyChoices: 'Очікує вибору ОС',
    statementManualWaitChoiceLegalActs: 'Очікує вибору нормативної бази',
    statementManualCharacterizationVehicle: 'Заповнення хараектеристик КТЗ',
    statementManualWaitSignatureCertAuditor: 'Очікує підписання Аудитора ОС',
    statementManualWaitSignatureCertDirector: 'Очікує підписання Директора ОС',
    statementManualCertificateIssued: 'Сертифікат видано',
    statementManualRejected: 'Відхилено',

    active: 'Активна',
    expired: 'Термін дії минув',
    agreementHasExpired: 'Термін дії угоди минув',

    identificationActWaitDecision: 'Очікує рішення',
    identificationActWaitClientSignature: 'Акт очікує підпису клієнта',
    identificationActWaitSignatureAuditor: 'Очікує підписання аудитором ОС',
    identificationActWaitSignatureManager: 'Очікує підписання менеджером ВЛ',
    identificationActValid: 'Дійсний',
    identificationActRejected: 'Відхилено',

    employeeActive: 'Активний',
    employeeDeactivated: 'Деактивований',
    employeeSuspended: 'Призупинено, в результаті перевірки зовнішніх органів',
    employeeOutOfSystem: 'Не системний',
    employeeNotActivated: 'Не активовано',
    inspectionMTIDecision: {
      title: 'Рішення прийняте за результатами проходження ОТК',
      inspectionDecisionValid: 'Відповідає',
      inspectionDecisionTinyDiscrepancy: 'Незначна невідповідність',
      inspectionDecisionSignificantDiscrepancy: 'Істотна невідповідність',
      inspectionDecisionDangerousDiscrepancy: 'Небезпечна невідповідність',
      inspectionDecisionWaitAnswer: 'Очікує вибору'
    },
    workLineApproved: 'Схвалено',
    workLineWaitRefinement: 'На доопрацюванні',
    workLineWaitFilling: 'Заповнення МТЗ',
    workLineModeration: 'На огляді техпідтримки',

    laboratoryBranchWaitForModeration: 'Модерація дільниці',
    laboratoryBranchReprocessing: 'Дільниця на доопрацюванні',
    laboratoryBranchApproved: 'Дільниці прийнято в роботу',
    laboratoryBranchWaitAddMtz: 'Очікує заповнення МТЗ на дільниці',

    inquiryNew: 'Нове звернення',
    inquiryReviewed: 'Переглянуто',
    inquiryInProgress: 'Взято на розгляд',
    inquiryProcessed: 'В роботі',
    inquiryDone: 'Вирішено',
    inquiryClosed: 'Закрито',

    statementBranchWaitTechSupportReview: 'Перевірка техпідримки',
    statementBranchWaitNaauReview: 'Перевірка НААУ',
    statementBranchApproved: 'Активна',
    statementBranchRejected: 'Відхилено',
    statementBranchTechSentForReprocessing: 'На доопрацюванні, Техпідтримка',
    statementBranchSentForReprocessing: 'На доопрацюванні',
    statementBranchModeration: 'Додавання дільниці'
  },
  statement: 'Заява',
  documents: 'Документи',
  legalEntityDocuments: 'Документи, що підтверджують юридичну особу',
  documentsEmpty: 'Документи відсутні',
  notify: {
    success: 'Виконано успішно',
    warning: 'Зверніть увагу',
    error: 'Помилка виконання',
    info: 'Повідомлення',

    shipAdded: 'Судно додано',
    shipAddingNow: 'Судно додається, зачекайте',
    shipNotAdded: 'Судно не додано, перевірте дані або мережу інтернет',
    projectAdded: 'Проект додано',
    projectEdited: 'Проект змінено',
    projectEditError: 'Редагувати проект неможливо. Вже є судно пов\'язане с цим проектом',
    projectAddingNow: 'Проект додається, зачекайте',
    projectNotAdded: 'Проект не додано, перевірте дані або мережу інтернет',
    serverError: 'Помилка серверу (500)',
    projectLoadError: 'Помилка завантаження даних проекту, спробуйте пізніше',
    invalidNumeric: 'Тільки цифри',
    requiredAllFiles: 'Завантажте усі типи файлів',
    requiredFiles: 'Завантажте файли',
    errorRemove: 'Помилка видалення',
    statusStatementWasChangedSuccess: 'Статус заяви був успішно змінений',
    requestErrors: {
      Not_Found: 'Не знайдено',
      Not_found: 'Не знайдено',
      API_key_exists: 'Такий API-ключ вже доданий',
      API_key_is_invalid_or_inactive: 'Введений не валідний API-ключ',
      Incorrect_email_or_password: 'Невірна електронна адреса або пароль',
      Measuring_laboratory_with_that_EDPROU_not_found: 'Лабораторію з таким ЄДРПОУ не знайдено',
      Measuring_laboratory_with_that_EDPROU_already_has_contract: 'Лабораторія з таким ЄДРПОУ вже має договір',
      user_with_this_email_already_exists: 'Користувач із цією електронною адресою вже існує',
      Certification_agency_with_that_EDPROU_not_found: 'Орган сертифікації з таким ЄДРПОУ не знайдено',
      This_field_must_be_unique: 'ЄДРПОУ має бути унікальним. З таким ЄДРПОУ вже зареєстрована лабораторія',
      Measuring_laboratory_already_has_contract_with_certification_agency: `З цією вимірювальною лабораторією вже
        'є існуючий договір`,
      Certification_Agency_with_that_EDPROU_not_found: 'Орган сертифікації з цим EDPROU не знайдено',
      Laboratory_branch_already_has_section_chief: 'У цій філії вже назначено Керівника дільниці лабораторії',
      You_choices_invalid_insurance_type_for_this_field: 'Не вірний тип страхування',
      The_stand_is_busy_with_other_activities_clibrating: 'Стенд зайнятий клібруванням',
      User_with_this_email_already_exists: 'Користувач із цією електронною адресою вже існує',
      Laboratory_branch_already_has_active_section_chief: 'У філії вже є активний Керівник дільниці',
      Permission_is_not_enough: 'Недостатньо дозволу',
      Statement_certification_employee_with_this_email_already_exists: `Співробітник органу сертифікації
        із цією електронною адресою вже існує`,
      You_have_awaiting_filling_or_refinement_statement_working_lines: 'Заповніть МТЗ на усіх робочих лініях у усіх філіях',
      This_field_is_required: 'Увага! Заповніть обов\'язкові поля',
      Inspection_already_exists: 'Огляд вже пройдений. Змінити дані неможливо',
      The_equipment_is_busy: 'Обладнання зайняте',
      The_stand_is_busy_with_other_activities_gas: 'Стенд зайнятий, спробуйте трохи пізніше',
      The_stand_is_busy_with_other_activities_smoke: 'Стенд зайнятий, спробуйте трохи пізніше',
      The_stand_is_busy_with_other_activities_stand_status: 'Стенд зайнятий, спробуйте трохи пізніше',
      You_cant_change_statement_step_when_you_have_rejected_answers: 'Потрібно виправити всі невірні дані',
      The_stand_is_busy_with_other_activities_measurements: 'Стенд зайнятий, спробуйте трохи пізніше',
      Stand_is_offline: 'Стенд офлайн і потребує підключення',
      Equipment_is_not_busy: 'Прилад не зайнятий',
      A_valid_integer_is_required: 'Введіть ціле число',
      Selected_vehicle_certificate_can_not_send_to_UAS_service: `Сертифкат не дійсний або опублікований у відкритому реєстрі зі стандартизації України`,
      Selected_valid_vehicle_certificate_does_not_exist: 'Не знайдено дійсного сертифікату зі введеним id',
      Certificate_Agency_API_key_from_UAS_does_not_exists: `Відсутність API-ключа для передачі Сертифікатів до Відкритого реєстра зі стандартизації України`,
      Certificate_Agency_active_API_key_from_UAS_is_not_found: `Відсутність активного API-ключа для передачі Сертифікатів до Відкритого реєстра зі стандартизації України`,
      API_key_is_invalid_or_inactive: 'Відсутність активного API-ключа у Відкритому реєстрі зі стандартизації України',
      UAS_service_is_not_available_now: 'Відсутність з`єднання з Відкритим реєстром зі стандартизації України',
      You_can_not_set_this_status: 'Ви не можете змінювати статус заяви',
      This_number_is_already_in_use: 'Цей номер вже використовується'
    },
    validation: {
      required: 'Поле обов\'язкове', // vuelidate method name (email, minLength, ...)
      sameAs: 'Має бути таким же, як {eq}', // eq - имя переменной с которой мы сравниваем
      invalidEmail: 'Невірна електронна адреса',
      length: 'Довжина поля не вдповдає допустимому',
      minLength: 'Довжина поля замала',
      maxLength: 'Довжина поля завелика',
      numeric: 'Тільки цифри',
      integer: 'Тільки ціле число',
      regexNumericComma: 'Тільки цифри',
      regexLetters: 'Тільки українська',
      minValue: 'Замале значення',
      maxValue: 'Завелике значення',
      greatEffort: 'Занадто велике зусилля, проведіть замір ще раз',
      regexLetterNumber: 'Тільки українські букви та цифри',
      regexLetterNumberEng: 'Тільки латинські букви та цифри',
      letterNumber: 'Тільки цифри та крапка',
      email: 'Email не коректний, приклад example@domain.com',
      checkAvailable: 'Поле обов\'язкове до заповнення',
      innLength: '10 або 12 символів',
      countWheels: 'Кількість коліс повинна бути не менше кількості вісей',
      regexNumericDot: 'Тільки ціле число або число з плаваючою крапкою',
      invalidPassport: 'Недійсний паспорт',
      invalidPhoneFormat: 'Невірний номер телефону',
      alphaNum: 'Тільки букви та цифри',
      invalidFormat: 'Невірний формат',
      address: 'Невірний формат адреси',
      orderNumber: 'Невірний формат',
      accreditationCertificateNumber: 'Невірний формат',
      registrationNumber: 'Невірний формат реєстраційного номеру',
      nameOrganization: 'Невірний формат назви',
      regexVinCode: 'Невірний формат',
      seatBeltMarking: 'Невірний формат',
      url: 'Невірний формат посилання на веб-ресурс',
      serial: 'Невірний формат',
      multipleFive: 'Має бути кратне 5',
      textNote: 'Невірний формат',
      declaration: 'Невірний формат. Введіть 111111 або 111111_mti',
      oneDecimalPlaces: 'Тільки ціле число або число з одним знаком після плаваючої точки',
      floatNumber: 'Тільки ціле число або число з плаваючою крапкою',
      samePassword: 'Паролі мають співпадати',
    },
    statement: {
      create: {
        success: 'Заявка успішно створена',
        warning: 'Заявка створена, але файли не збережено',
        warningPassport: 'Паспортні дані не збережено',
        error: 'Заявка не створена'
      },
      category: {
        selected: 'Категорія успішно виставлена',
        success: 'Категорія успішно змінена',
        error: 'Категорія не змінена'
      },
      sign: {
        success: 'Заявка успішно підписана',
        error: 'Заявка не підписана'
      }
    },
    techControlStatement: {
      create: {
        success: 'Заявка на ОТК успішно створена',
        warning: 'Заявка на ОТК створена, але файли не збережено',
        warningPassport: 'Паспортні дані не збережено',
        error: 'Заявка на ОТК не створена'
      },
      category: {
        success: 'Категорія успішно змінена',
        error: 'Категорія не змінена'
      },
      sign: {
        success: 'Заявка на ОТК  успішно підписана',
        error: 'Заявка на ОТК не підписана'
      }
    },
    credentialsError: 'Невірний логін або пароль',
    signature: {
      success: 'Підписано успішно',
      error: 'Не підписано',
      saveKey: {
        success: 'Ключ збережено успішно',
        error: 'Ключ не збережено'
      }
    },
    decision: {
      approve: {
        success: 'Схвалено успішно',
        error: 'Не схвалено'
      },
      error: {
        success: 'Відхилено успішно',
        error: 'Не відхилено'
      },
      sign: {
        success: 'Рішення успішно підписано',
        error: 'Рішення не підписано'
      },
      reject: {
        success: 'Заявка відхилена'
      }
    },
    inspection: {
      save: {
        success: 'Огляд збережено успішно',
        error: 'Огляд не збережено'
      },
      proof: {
        success: 'Доказова база збережена успішно',
        error: 'Доказова база не збережена'
      },
      sign: {
        success: 'Протокол відповідності успішно підписано',
        error: 'Протокол відповідності не підписано'
      }
    },
    decisionIssue: {
      sign: {
        success: 'Рішення щодо видачі сертифікату успішно підписано',
        error: 'Рішення щодо видачі сертифікату не підписано'
      }
    },
    certificate: {
      create: {
        success: 'Рішення щодо видачі сертифікату підписано успішно',
        error: 'Рішення щодо видачі сертифікату не підписано'
      }
    },
    measurement: {
      save: {
        success: 'Випробування збережено успішно',
        error: 'Випробування не збережено'
      },
      testNotYetAvailable: 'Випробування ще недоступне'
    },
    accountVL: {
      vl: {
        success: 'Випробувальну лабораторію успішно збережено'
      },
      contract: {
        success: 'Договір успішно збережений'
      },
      branch: {
        success: 'Дільниця успішно збережена'
      },
      equipment: {
        success: 'Матеріально-технічне забезпечення успішно збережене'
      }
    },
    requiredSignature: 'Будь ласка, спочатку поставте свій підпис',
    emptyQuestionnaireProps:
      'Будь ласка, перевірте чи всі поля заповнені. Потрібно вказати номер та пункт документу для кожного питання',
    identificationAct: {
      decision: {
        success: 'Рішення по Акту ідентифікації успішно збережене'
      },
      sign: {
        success: 'Акт успішно підписаний',
        error: 'Акт не підписаний'
      }
    },
    measurementCornerSaved: 'Кут нахилу фари успішно збережено',
    equipmentTerminated: 'Прилад звільнено. Продовжіть вимірювання',
    fixErrorsAndTryAgain: 'Виправте всі помилки і спробуйте знову',
    ruleBaseGeneratedSuccess: 'Нормативна база згенерована успішно',
    updateDateInspectionInconsistenciesSuccess: 'Не відповідність {value} була збережена успішно'
  },
  to: 'до',
  yes: 'Так',
  other: 'інших',
  SRU: 'SRU',
  UA: 'UA',
  available: 'Наявне',
  notAvailable: 'Не наявне',
  number: 'Номер',
  mark: 'Марка',
  model: 'Модель',
  modification: 'Модифікація',
  vinCode: 'VIN код',
  vinCodeNonStandardLength: 'Внести VIN код нестандартної довжини',
  filterByTypeOfVehicleType: 'Фільтрувати за типом транспорту',
  ktzWithoutModel: 'КТЗ не має позначення Моделі',
  client: 'Клієнт',
  infoVehicle: 'Інформація про КТЗ',
  infoOwner: 'Інформація про власника',
  yearProduction: 'Рік виробництва',
  vehicleCondition: 'Стан',
  vehicleType: 'Тип транспорту',
  vehiclePurpose: 'Призначення КТЗ',
  vehicleCategory: 'Категорія транспорту',
  vehicleCategoryModalTitle: 'Виставлення характеристик',
  selectCategory: 'Оберіть категорію',
  vehicleChasis: 'Кількість осей',
  vehicleMass: 'Вага транспорту',
  vehicleColor: 'Колір транспорту',
  vehicleOdometr: 'Показник одометра',
  lastName: 'Прізвище',
  firstName: 'Ім\'я',
  middleName: 'По батькові',
  trusteeLastName: 'Прізвище на кого видано довіреність',
  trusteeFirstName: 'Ім\'я на кого видано довіреність',
  trusteeMiddleName: 'По батькові на кого видано довіреність',
  dateBirth: 'Дата народження',
  serial: 'Номер паспорта',
  serialPassportCreateAccount: 'Серія та номер паспорту',
  serialIDCard: 'Номер ID картки або закордонного паспорту',
  documentNumber: 'Номер документу',
  serialPassport: 'Серія та номер паспорта',
  isNewPassport: 'Маю ID картку',
  itn: 'РНОКПП (ІПН)',
  confidantItn: 'РНОКПП (ІПН) довіреної особи',
  diploma: 'Документи про вищу освіту',
  certificationTraining: 'Документи про підвищення кваліфікації',
  dateStart: 'Дата видачі',
  dateEnd: 'Дата закінчення дії',
  indexPost: 'Індекс',
  city: 'Місто/Село',
  street: 'Вулиця',
  house: 'Дім',
  flat: 'Квартира',
  flatRooms: 'Квартира/Приміщення',
  passport: 'Паспорт',
  idCard: 'ID картка',
  internationalPassport: 'Закордонний паспорт',
  paperPassport: 'Паспорт-книжка',
  permitForResidence: 'Посвідка на постійне проживання',
  numberPermitForResidence: 'Номер посвідки',
  providePassport: 'Паспорт довіреної особи',
  customDocuments: 'Митні документи',
  registrationCertificate: 'Свідоцтво про реєстрацію',
  fileUploader: 'Виберіть файл',
  additionalDocuments: 'Додаткові документи',
  fileAlreadySelected: 'Документи вибрані',
  fileHasAnyError: 'Помилка! Перевірте документи',
  fileHasCrashError: 'або файл пошкоджений',
  placeRegistration: 'Адреса прописки',
  detail: 'Детально',
  New: 'Новий',
  Used: 'Був у користуванні',
  laboratory: 'Лабораторія',
  legalActs: 'Вимоги',
  declarationHint: '111111 або 111111_mti',
  selectOrganization: {
    organization: 'Організація',
    selectButtonOC: 'Виберіть орган сертифікації',
    selectButtonVL: 'Виберіть випробувальну лабораторію',
    selectBranchInLaboratory: 'Виберіть філію випробувальної лабораторії',
    certificationAgency: 'Орган сертифікації',
    certificationLaboratory: 'Випробувальна лабораторія',
  },
  titles: {
    stands: 'Вимірювальні стенди',
    makeMeasurements: 'Проведення вимірювань',
    brakeStand: 'Тормозний стенд',
    brakeStands: 'Тормозні стенди',
    makeMeasurement: 'Провести вимірювання',
    historyMeasurement: 'Історія вимірювань',
    gasAnalyzer: 'Газоаналізатор',
    smokeAnalyzer: 'Димоаналізатор',
    lightTransmission: 'Світлопроникність',
    light: 'Світловипромінення',
    noise: 'Шумоаналізатор'
  },
  descriptions: {
    loadBrakingForceAndSet: 'Навантажте тормозне зусилля, та задайте значення на скільки ви його навантажили',
    loadStandAndSet: 'Навантажте стенд, та задайте на скільки ви його навантажили'
  },
  measurementResult: 'Результати вимірювання',
  chooseStand: 'Оберіть стенд',
  chooseEquipment: 'Оберіть прилад',
  equipmentExist: 'Дані про обладнання вже заповнені. Перейдіть до вимірювань.',
  headlightDistributionType: 'Тип світлорозподілу фари',
  testingFogLights: 'Тестування протитуманних фар',
  chooseStandDescription: 'Виберіть стенд, щоб розпочати роботу з клієнтом',
  active: 'Активний',
  deactivated: 'Деактивований',
  notActive: 'Не активний',
  lastIP: 'Останній IP',
  standSettings: {
    calibrateBrakeForce: 'Калібрувати тор. зусилля',
    calibrateHandbrakeSensor: 'Калібрувати датчик ручника',
    calibratePedalSensor: 'Калібрувати датчик педалі',
    calibrateWeight: 'Калібрувати ваги',
    calibrationBrakeForce: 'Калібрування тормозного зусилля',
    calibrationEffortSuccess: 'Калібрування зусилля пройшло успішно',
    calibrationHandbrakeSensor: 'Калібрування датчика ручника',
    calibrationHandbrakeSuccess: 'Калібрування датчика ручника пройшло успішно',
    calibrationPedalSensor: 'Калібрування датчика педалі',
    calibrationPedalSuccess: 'Калібрування датчика педалі пройшло успішно',
    calibrationWeight: 'Калібрування ваги',
    calibrationWeightSuccess: 'Калібрування ваги пройшло успішно',
    checkConnectStand: 'Перевірити під. до стенду',
    departure: 'Виїзд вантажного авто',
    settingsCharacteristics: 'Налаштування стенду',
    standCheckSuccess: 'Перевірка стенду пройшов успішно',
    standEdits: 'Редагування стенду',
    standReboot: 'Перезапуск стенду',
    standRebootNotPossible: 'Стенд виконує іншу задачу, перезапуск неможливий',
    standRebootSuccess: 'Перезапуск стенду пройшов успішно',
    standSettingsSuccess: 'Налаштування стенду пройшло успішно',
    testingSensor: 'Тестування датчиків'
  },
  left: 'Ліва',
  right: 'Права',
  numberDeclaration: 'Номер декларації',
  chooseSide: 'Оберіть вісь для тестування',
  selectSideLoad: 'Виберіть сторону навантаження',
  effort: 'Зусилля',
  burden: 'Навантаження',
  nameStand: 'Назва стенду',
  uniqueIdentifier: 'Унікальний ідентифікатор',
  detailInformation: 'Загальна інформація',
  calibrationWeight: 'Калібрувати ваги',
  calibrationBrakeForce: 'Калібрувати тор. зусилля',
  calibrationPedalSensor: 'Калібрувати датчик педалі',
  calibrationHandBrake: 'Калібрувати датчик ручника',
  standReboot: 'Перезапуск стенду',
  checkConnect: 'Перевірити під. до стенду',
  characteristics: 'Налаштування стенду',
  standEdit: 'Редагування стенду',
  departure: 'Виїзд вантажного авто',
  isDoneTask: 'Задача успішно виконана',
  isErrorTask: 'Задача виконана з помилкою, спробуйте ще або зверніться до адміністратора',
  countDoors: 'Кількість дверей',
  countSeats: 'Кількість місць для сидіння (включаючи місце водія)',
  seats: {
    totalCountSeats: 'Кількість сидінь',
    countRows: 'Кількість рядів',
    inspectionSeats: 'Огляд сидінь',
    firstAddCountSeats: 'Спочатку додайте кількість сидінь',
    row: 'Ряд',
    addRow: 'Додати ряд',
    removeRow: 'Видалити ряд',
    seat: 'Сидіння',
    addSeat: 'Додати сидіння',
    removeSeat: 'Видалити сидіння',
    notAllAddedSeats: 'Не всі місця для сидіння було додано',
    positionSeat: 'Розположення сидіння'
  },
  countSeatsAll: 'Кількість місць для сидіння (включаючи місце водія, місця членів екіпажу, пріоритетні місця)',
  countCrewMembersSeats: 'Кількість місць членів екіпажу',
  countPrioritySeats: 'Кількість пріоритетних місць',
  countStationarySeats: 'Місця, призначені для використання тільки на нерухомому КТЗ',
  countUpperTierSeats: 'Кількість місць для сидіння (верхній ярус) (включаючи водія)',
  countLowerTierSeats: 'Кількість місць для сидіння (нижній ярус)(включаючи водія)',
  countPassengersWheelchairsSeats: 'Кількість місць, призначених для перевезення пасажирів на інвалідних візках',
  countAxles: 'Кількість осей',
  countWheels: 'Кількість коліс',
  length: 'Довжина',
  width: 'Ширина',
  height: 'Висота',
  equippedWeight: 'Маса КТЗ у спорядженому стані',
  equippedWeightForAxles: 'Розподіл маси КТЗ у спорядженому стані за осями',
  axisTrack: 'Колія осі',

  internationalPermissibleWeight: 'Вибір правила для припустимих мас',
  registrationPermissibleWeight: 'Вибір Реєстраційна/експлуатаційна для припустимої маси',

  registrationPermissibleTitle: 'Реєстраційні/експлуатаційні максимально припустимі маси в ' +
    'національному/міжнародному дорожньому русі',

  registrationAxisPermissibleWeight: 'Вибір Реєстраційна/експлуатаційна для припустимої маси на осі',
  registrationGroupMaxWeightPermissible: 'Вибір Реєстраційна/експлуатаційна для припустимої маси на групі осей',
  registrationMaxCombineWeightLegal: 'Вибір Реєстраційна/експлуатаційна для макс. припустимої маси комбінації КТЗ',

  displacementSaddleCouplingDeviceMax: 'Зміщення сідельно-зчіпного пристрою відносно заднього мосту, макс',
  displacementSaddleCouplingDeviceMin: 'Зміщення сідельно-зчіпного пристрою відносно заднього мосту, мін',
  distanceBetweenFrondAndCouplingDevice: 'Відстань між переднім габаритом КТЗ та центром зчіпного пристрою',
  twinWheels: 'Вісь з здвоєними колесами',
  driveAxlesNumbers: 'Рушійні осі номер',
  countDriveAxles: 'Рушійні осі кількість',
  countControlledAxles: 'Керуючі осі кількість',
  posteriorOverhang: 'Задній звис',
  groupWeightDistribution: 'Технічно припустима маса на кожній групі осей:',
  permissibleWeight: 'Реєстраційна/експлуатаційна максимально припустима повна маса',
  ownWeight: 'Маса КТЗ у спорядженому стані',
  axisPermissibleWeight: 'Реєстраційна/експлуатаційна максимально припустима маса на кожній осі',
  groupMaxWeightPermissible: 'Реєстраційна/експлуатаційна максимально припустима маса на кожній групі осей',
  maxCombineWeightLegal: 'Реєстраційна/експлуатаційна максимально припустима маса комбінації КТЗ',
  axisDrivePneumaticSuspension: 'На осі (осях) застосовано пневматичну підвіску або еквівалентні пристрої',
  driveAxisDrivePneumaticSuspension: 'На рушійній(их) осі (осях) застосовано пневматичну підвіску або еквівалентні пристрої',
  pressureInBrakeTrailer: 'Тиск у магістралі гальмівної системи причепа',
  vehicleClass: 'Клас КТЗ',
  countStandingPlaces: 'Кількість місць для пасажирів, які стоять',
  couplingDeviceNumber: 'Номер затвердження або знак затвердження зчіпного пристрою (у разі нанесення)',
  couplingDeviceNumberAnother: 'Знак затвердження пристрою для буксирування',
  canTransportDangerousGood: 'Затвердження конструкції щодо перевезення небезпечних вантажів',

  grossWeight: 'Максимальна технічно припустима повна маса',
  controlledAxles: 'Керуючі осі',
  locationControlledAxles: 'Керуючі осі розташування',
  driveAxles: 'Рушійні осі взаємозв’язок',
  engineCapacity: `Робочий об'єм`,
  carEngineCapacity: `Об'єм двигуна`,
  enginePower: 'Максимальна потужність',
  convertHorsePowerToKw: 'Конвертувати кінські сили (к.с.) у кіловати (кВт)',
  electricEnginePower: 'Максимальна потужність електродвигуна',
  engineLocation: 'Тип розміщення двигуна',
  engineWorkingPrinciple: 'Робочий принцип:',
  countCylinders: 'Кількість циліндрів',
  cylinderArrangement: 'Розташування циліндрів',
  carcassType: 'Тип кузова',
  carcass: 'Кузов',
  manufacturerCountry: 'Найменування і місцезнаходження виробника',
  transmissionType: 'Тип трансмісії',
  steeringBoostMethod: 'Метод посилення кермового колеса',
  engineRpm: 'За частоти обертання',
  enginePollutionReduction: 'Система зниження забруднення двигуна',
  engineCoolingSystem: 'Система охолодження двигуна',
  weightDistribution: 'Технічно припустима маса осі',
  certificationDepartment: 'Відділ сертифікації',
  wheelFormula: 'Колісна формула',
  engineCode: 'Код двигуна',
  engineType: 'Тип двигуна (позначений на двигуні)',
  engineEuroRate: 'Євро клас',
  euroCode: 'Євро код',
  maxSpeed: 'Максимальна швидкість',
  noiseStandard: 'Рівень шуму',
  steeringWheelLocation: 'Розташування рульового колеса',
  countFuelTanks: 'Кількість паливних баків',
  countSilencers: 'Кількість глушників',
  bootSpaceLength: 'Довжина завантажувального простору',
  locationOfAxes: 'Розташування підйомної(их) осі (осей)',
  locationOfAxlesUnderLoad: 'Розташування осі (осей), яка (які) постійно сприймає(ють) навантаження',
  distanceBetweenBackAndCouplingDevice: 'Відстань між центром зчіпного пристрою та заднім габаритом КТЗ',
  equippedWeightDistribution: 'Розподіл цієї маси за осями',
  couplingDeviceStaticWeight: 'Технічно припустима максимальна статична маса, що припадає на зчіпний пристрій',
  trailerTypeBrakeConnector: 'Тип гальмівних з’єднувачів причепа',
  fuelType: 'Тип палива',
  deviceInfo: 'Пристрій',
  sessions: 'Сесії',
  createdAt: 'Дата створення',
  modifiedAt: 'Дата змінення',
  expiry: 'Дата закінчення терміну дії',
  lastActivity: 'Дата останньої активності',
  ipAddress: 'IP адреса',
  isCurrentSession: 'Поточна сесія',
  delete: 'Видалити',
  name: 'Назва',
  address: 'Адреса',
  tireWidth: 'Ширина шини',
  tireHeight: 'Висота шини',
  discDiameter: 'Діаметр диска',
  diameter: 'Діаметр',
  enterAllData: 'Заповніть усі дані',
  carInspection: 'Огляд авто',
  inspection: {
    card: 'Картка огляду',
    i1: 'Погодні умови',
    i2: 'Ідентифікаційні ознаки',
    i3: 'Загальні конструктивні характеристики',
    i4: 'Основні розміри',
    i5: 'Маси',
    i6: 'Силова установка',
    i7: 'Системи',
    i8: 'Розміри'
  },
  tire: 'Колесо',
  windowType: 'Тип вікна',
  serialNumber: 'Серійний номер',
  window: 'Вікно',
  numberStand: 'Номер стенда',
  version: 'Версія',
  carriedMeasurments: 'Провів вимірювання',
  measurementAddress: 'Адреса вимірювання',
  declarationNumber: 'Декларація №',
  customer: 'Замовник',
  signNumber: 'Номерний знак',
  brakingForce: 'Питома гальмівна сила',
  brakingForceLeft: 'Гальмівна сила ліва(Pr1)',
  brakingForceRight: 'Гальмівна сила права(Pr2)',
  coefficientNonUniformity: 'Коефіціент нерівномірності, %',
  totalBrakingForce: 'Питома гальмівна сила',
  durationOperationLeft: 'Тривалість спрацьовування, с. ліва',
  durationOperationRight: 'Тривалість спрацьовування, с. права',
  side: 'Вісь',
  evaluation: 'Оцінка результатів розрахунку',
  chooseDeclaration: 'Оберіть декларацію',
  setParameters: 'Внесення характеристик випробувань',
  enterDeclaration: 'Введіть номер декларації',
  measurementIsDone: 'Вимірювання проведено успішнно',
  warmingUpEngine: 'Прогрівання двигуна пройдено успішно',
  measurementIsFail: 'Вимірювання проведено не вдало, спробуйте ще раз, або зверніться за допомогою',
  measurementIsFailed: 'Помилка вимірювання',
  chooseShaftMeasurement: 'Оберіть вісь',
  chooseTypeMeasurement: 'Оберіть тип вимірювання',
  typeMeasurement: 'Тип вимірювання',
  chooseType: 'Оберіть тип',
  shaft: 'Вісь',
  leftShaft: 'Ліва вісь',
  rightShaft: 'Права вісь',
  handBreak: 'Ручне гальмо',
  goToDeclaration: 'Перейти до декларації',
  invoiceCopy: 'Копія інвойсу',
  online: 'Онлайн',
  offline: 'Офлайн',
  waitFinishOperation: 'Зачекайте завершення операції',
  calibrationSensors: 'Калібрування датчиків',
  arduinoLogs: 'Arduino logs',
  changeCurrentShaft: 'Ви впевнені що хочете змінити вісь?',
  changeCurrentShaftHandBrake: 'Ви впевнені що хочете перейти до тестування ручного тормозу?',
  clientNotUseItn: 'Клієнт не має РНОКПП (ІПН)',
  clientPassportBook: 'Маю паспорт-книжку',
  permitResidenceDateEnd: 'Дата закінчення строку дії',
  permitResidenceNumber: 'Номер запису',
  nationality: 'Громадянство',
  trusteeIDCard: 'ID картка або Закордонний паспорт',
  codeUKTZED: 'Код УКТЗЕД',
  mediaPassportHelp: 'Паспорт-книжка: завантажте 1-6 та 11 сторінки паспорту',
  mediaIDCardHelp: 'ID картка: завантажте обидві сторони та справку про місце проживання',
  legalDocuments:
    `Правовстановлюючі документи: Довідка платника НДС для ТОВ або витяг з реєстру платників єдиного податку для ФОП`,
  powerOfAttorney:
    `Доручення: 1-2х сторінковий документ з реквізитами та документами особи,
    на яку очолюються функції тимчасового представництва`,
  info: 'Інфо',
  mainBrakeSpecificForce: 'Питома гальмівна сила РГС',
  hintMainBrakeSpecificForce: 'Питома гальмівна сила не менше {0}',
  parkBrakeSpecificForce: 'Загальна питома гальмівна сила СГС',
  mainBrakeMaxForce: 'Максимальна гальмівна сила РГС',
  parkBrakeMaxForce: 'Максимальна гальмівна сила СГС',
  mainTriggeringTime: 'Час спрацьовування РГС',
  hintMainTriggeringTime: 'Час спрацьовування не більше {0}',
  parkTriggeringTime: 'Тривалість спрацьовування СГС',
  mainIrregularity: 'Коефіціент нерівномірності РГС',
  parkIrregularity: 'Коефіціент нерівномірності СГС',
  mainBrakeControlForce: 'Зусилля на органі керування РГС',
  maxMainBrakeControlForce: 'Максимальне зусилля на органі керування РГС {value}',
  parkBrakeControlForce: 'Зусилля на органі керування СГС',
  maxParkBrakeControlForce: 'Максимальне зусилля на органі керування СГС {value}',
  totalWeight: 'Статична вага',
  rMinCoLevel: 'Рівень вмісту СО, мінімальні оберти двигуна',
  rMinChLevel: 'Рівень вмісту СН, мінімальні оберти двигуна',
  rMinCo2Level: 'Рівень вмісту СО2, мінімальні оберти двигуна',
  rMinO2Level: 'Рівень вмісту О2, мінімальні оберти двигуна',
  rMinTemperature: 'Температура охолоджувальної рідини / моторної оливи, мінімальні оберти двигуна',
  rMinRpm: 'Частота обертання двигуна, мінімальні оберти двигуна',
  rMaxCoLevel: 'Рівень вмісту СО, підвищені оберти двигуна',
  rMaxChLevel: 'Рівень вмісту СН, підвищені оберти двигуна',
  rMaxCo2Level: 'Рівень вмісту СО2, підвищені оберти двигуна',
  rMaxO2Level: 'Рівень вмісту О2, підвищені оберти двигуна',
  levelValue: 'Рівень вмісту не більше {0}',
  rotationFrequency: 'Частота обертання двигуна {0} - {1}',
  excessAirFactorMinMax: 'Коефіцієнт надлишку повітря {0} - {1}',
  rMinMaxTemperature: 'Температура охолоджувальної рідини / моторної оливи {0} - {1}',
  coLevel: 'Рівень вмісту СО',
  co2Level: 'Рівень вмісту СО2',
  chLevel: 'Рівень вмісту CH',
  o2Level: 'Рівень вмісту O2',
  rpm: 'Частота обертання двигуна',
  engineRotationalSpeed: 'Частота обертів двигуна',
  externalNoise: 'Фоновий шум',
  targetEngineRpm: 'Цільова частота обертання повинна бути {0} - {1}',
  rMaxTemperature: 'Температура охолоджувальної рідини / моторної оливи, підвищені оберти двигуна',
  rMaxRpm: 'Частота обертання двигуна, підвищені оберти двигуна',
  temperature: 'Температура',
  currentSmokeMeasurement: 'Випробування димомір',
  oilTemperature: 'Температура масла',
  hintTemperature: 'Температура масла має бути 60 - 100 °C',
  firstMeasurementAbsorptionLevel: 'Натуральний коефіцієнт поглинання 1 вимір',
  secondMeasurementAbsorptionLevel: 'Натуральний коефіцієнт поглинання 2 вимір',
  thirdMeasurementAbsorptionLevel: 'Натуральний коефіцієнт поглинання 3 вимір',
  fourthMeasurementAbsorptionLevel: 'Натуральний коефіцієнт поглинання 4 вимір',
  fifthMeasurementAbsorptionLevel: 'Натуральний коефіцієнт поглинання 5 вимір',
  sixthMeasurementAbsorptionLevel: 'Натуральний коефіцієнт поглинання 6 вимір',
  firstOpacityLevel: 'Лінійний коефіцієнт поглинання 1 вимір',
  secondOpacityLevel: 'Лінійний коефіцієнт поглинання 2 вимір',
  thirdOpacityLevel: 'Лінійний коефіцієнт поглинання 3 вимір',
  fourthOpacityLevel: 'Лінійний коефіцієнт поглинання 4 вимір',
  absorptionLevel: 'Натуральний коефіцієнт поглинання',
  hintAbsorptionLevels: 'Відмінність між вимірами не повинна перевищувати різницю в 0,25',
  hintAbsorptionLevel: 'Натуральний коефіцієнт поглинання не більше {value}',
  absorptionLevels: 'Натуральні коефіцієнти поглинання проведених вимірювань',
  opacityLevel: 'Лінійний коефіцієнт поглинання N',
  decisionInfo: 'Інформація по рішенню',
  document: 'Документ',
  key: 'Ключ',
  password: 'Пароль',
  newKey: 'Новий ключ',
  typeKey: 'Тип ключа',
  issuedBy: 'Видано',
  edrpou: 'ЄДРПОУ',
  drfo: 'ДРФО',
  statusesForStand: {
    standOffline: 'Стенд офлайн і потребує перезавантаженню',
    standNotReadyForMeasurement: 'Стенд не готовий до випробуваннь, спробуйте ще раз почати вимірювання',
    ktzMissingOnStand: 'Ктз відсутнє на стенді',
    otherError: 'На стені сталась помилка, спробуйте ще раз почати вимірювання'
  },
  standOccupied: 'Підключення зі стендом буде створено',
  standNotRspond: 'Стенд не відповідає, спробуйте пізніше',
  standConnect: 'Підключення зі стендом',
  connectToStand: 'Підключитися до стенду',
  disconnectToStand: 'Відключитися від стенду',
  connectStandSuccessful: 'Ви підключились до стенду',
  turnedOffStandSuccessful: 'Ви відключились від стенду',
  operator: 'Оператор',
  decision: 'Рішення',
  filesDocuments: 'Файли',
  clientFilesDocuments: 'Файли завантажені клієнтом',
  notFound: 'не знайдено',
  clickFileForView: 'Натисніть на зображення, щоб переглянути',
  clickFileForViewShort: 'Натисніть для перегляду',
  fileNotFound: 'Файл відсутній',
  headlight: 'Фара',
  headlights: 'Фари',
  count: 'Кількість',
  inStock: 'Присутність',
  headlightCountHint: 'Максимум {count} фар',
  color: 'Колір',
  windows: 'Вікна',
  tires: 'Колеса',
  vehicleVariant: 'Варіант',
  vehicleVersion: 'Версія',
  distanceBetweenAxles: 'Відстані між осями',
  maxCombineWeight: 'Технічно припустима максимальна маса комбінації',
  identificationMethod: 'Місце розміщення обов’язкових табличок',
  identificationMethodAnother: 'Розміщення ідентифікаційного номера на шасі',
  identificationPlace: 'Розміщення ідентифікаційного номера',
  engineManufacturer: 'Виробник двигуна',
  totalAngularDistance: 'Сумарний кутовий проміжок люфта руля',
  maxTotalAngularDistance: 'Максимальний сумарний кутовий проміжок люфта руля, не більше ніж {value}',
  vehicleMileage: 'Пробіг',
  convertMilesToKilometers: 'Конвертувати милі (mi) у кілометри (км)',
  close: 'Закрити',
  analyzerType: 'Тип аналізатора',
  analyzerGasType: 'Тип газо-аналізатора',
  analyzerSmokeType: 'Тип димо-аналізатора',
  chooseAnalyzerGasType: 'Оберіть тип газо-аналізатора',
  updatedAnalyzerGasType: 'Тип газо-аналізатора оновлено',
  chooseAnalyzerSmokeType: 'Оберіть тип димо-аналізатора',
  updatedAnalyzerSmokeType: 'Тип димо-аналізатора оновлено',
  file: 'Файл',
  fileTooLarge: 'Розмір файлу завеликий',
  maxFileSize: 'Максимальний розмір файлу',
  fileCorrupted: 'Файл пошкоджений',
  goTo: 'Перейти на',
  toStatement: 'заяву',
  resBrakeMeasurement: 'Вимірювання гальм',
  resGasMeasurement: 'Вимірювання газо-аналізатором',
  resultSmokeMeasurement: 'Вимірювання димо-аналізатором',
  dateMeasurement: 'Дата та час вимірювання',
  measurementNotFound: 'Результатів вимірювання не існує',
  noData: 'Немає даних',
  areYouHere: 'Ви ще тут?',
  areYouSure: 'Ви впевнені?',
  questions: 'Питання',
  questionsSaved: 'Питання за пунктами на які дано відповіді збережено',
  compliance: 'Відповдає?',
  notUseForThisVehicle: 'Цей припис не стосується конструкції даного КТЗ',
  rule: 'Правило',
  vehicleAll: 'Фото КТЗ',
  vinCodeImg: 'VIN код (підкапотний простір та лобове скло)',
  vinCodeImgOCategory: 'VIN код',
  markTable: 'Маркувальна табличка',
  markTable2: 'Бічна стійка авто',
  markGlass: 'Маркування скла',
  markLight: 'Маркування світлових пристроїв',
  proof: 'Доказова база',
  answerText: 'Текст відповіді',
  isWindowInDriverOverview: 'Чи входить це вікно до оглядової зони водія',
  windowInDriverOverview: 'Вікно входить до оглядової зони водія',
  notWindowInDriverOverview: 'Вікно не входить до оглядової зони водія',
  hintLightTransmission: 'Світлопроникність повинна бути не менше {0}%',
  waitDecisionResponsiblePerson: 'Очікує рішення/Відповідальна особа',
  changeResponsiblePerson: 'Змінити відповідальну особу/підписанта',
  replacementResponsiblePerson: 'Зміна відповідальної особи',
  currentResponsiblePerson: 'Діюча відповідальна особа',
  selectAnotherResponsiblePerson: 'Виберіть іншу відповідальну особу',
  checkEquipment: {
    title: 'Перевірка наявності засобів вимірювальної техніки',
    subTitle: 'Перелік обладнання, необхідного для проведення обов\'язкового технічного контролю транспортних засобів',
    equipmentAvailability: 'Є в наявності',
    equipmentName: 'Назва обладнання',
    equipmentCountry: 'Країна виробник',
    equipmentCalibration: 'Обладнання відкаліброване?',
    calibrationDate: 'Дата калібрування',
    calibrationInterval: 'Міжкалібрувальний інтервал',
    calibrationNote: 'За посиланням на офіційному сайті НААУ можна',
    calibrationPass: 'пройти калібрування',
    liftingDevices:
      '1. Пристрої для підйому транспортного засобу, його складових частин та (або) оглядова канава та (або) естакада.',
    brakeStand:
      `2. Роликовий гальмівий стенд для контролю функціонування гальмових систем з датчиками контролю тиску для
      пневматичних гальмівних систем (з фіксацією результатів випробувань).`,
    decelerometer:
      `3. Деселерометр (пристрій для визначення сповільнення та гальмівного шляху транспортного засобу) та відповідна
      ділянка дороги для проведення дорожніх випробувань гальмових систем (у разі застосування методу дорожніх
      випробувань).`,
    brakeSystemsPressure: '4. Обладнання для вимірювання тиску повітря в пневматичних гальмівих системах.',
    tirePressure: '5. Обладнання для вимірювання тиску в пневматичних шинах.',
    loadAxle: `'6. Обладнання для визначення вагового навантаження на вісь за умови інтеграції в програмне забезпечення
      стенда для контролю характеристик гальмових систем, якщо таке обладнання не є складовою стенда для контролю
      характеристик гальмових систем.`,
    suspensionControl: `'7. Обладнання для контролю підвіски (детектор люфту коліс) без підіймання осі
      (у разі відсутності підйомних пристроїв транспортного засобу, його складових частин), яке відповідає таким
      вимогам:\n а) пристрій повинен бути обладнаний щонайменше двома тяговими елементами, що виконують
      зворотно-поступальний рух у двох напрямках ‒ поздовжньому і поперечному;\n б) рух цих елементів
      повинен контролюватися оператором з місця виконання випробовувань.`,
    noiseMeter: '8. Шумомір 1 класу.',
    gasAnalyzer:
      '9. Багатоканальний газоаналізатор для двигунів з іскровим запалюванням (з фіксацією результатів випробувань).',
    smokeAnalyzer: '10. Димомір для двигунів з запалюванням від стиснення (з фіксацією результатів випробувань).',
    lightTransmissionGlass: '11. Обладнання для вимірювання коефіцієнта світлопропускання скла.',
    angleInclinationRay: '12. Обладнання для вимірювання кутів нахилу променів, світлорозподілу, сили світла фар.',
    treadPatternHeight: '13. Обладнання для вимірювання висоти рисунка протектора шин.',
    diagnosticSystem: '14. Обладнання для сканування системи бортової діагностики колісних транспортних засобів (OBD).',
    gasLeak: '15. Обладнання для виявлення витоку газів ЗНГ/СПГ/ЗПГ (за умови перевірки відповідних транспортних засобів).',
    controlLinearDimensions: '16. Обладнання для контролю лінійних розмірів відповідно до застосовуваних методів контролю.',
    crankshaftSpeed: `17. Обладнання для вимірювання частоти обертання колінчастого валу двигуна (з можливістю
      визначення обертів бензинових та дизельних двигунів без демонтажу комплектуючих).'`,
    adjustablePressure: `18. Обладнання для регульованого натиску на механізм управління інерційною гальмовою системою
      причепа (за умови перевірки відповідних транспортних засобів).`,
    angularIntervalSteering: '19. Обладнання для вимірювання сумарного кутового проміжку рульового керування.',
    busInspection: `20. Шаблони для перевірки автобусів: \n а) шаблони для перевірки відстані між сидіннями; \n б)
      шаблони для перевірки доступу до аварійних дверей; \n в) шаблони для перевірки аварійного люку.`

  },
  sendDocumentToNAAU: 'Подача документів в НААУ',
  commonNAAU: {
    nameCAB: 'Назва ООВ',
    nameApplicant: 'Назва заявника',
    position: 'Посада',
    phone: 'Телефон',
    email: 'Електронна адреса',
    fax: 'Факс',
    testName: 'Назва випробувань та(або) характеристик(параметрів), що визначаються',
    address: 'Адреса',
    organization: 'Організація',
    name: 'Назва'
  },
  letterNAAU: {
    letterTitle: 'Лист на заявку про акредитацію Ф-08.00.72',
    legalName: 'Назва юридичної особи',
    typeCAB: 'Вид ООВ',
    registerNumber: 'Реєстраційний номер',
    name: 'Реєстраційний номер',
    accreditationCertificateNumber: 'Номер атестату про акредитацію',
    accreditationCertificateValidity: 'Термін дії атестата про акредитацію'
  },
  statementNAAU: {
    statementTitle: 'Заявка на акредитацію ВЛ Ф-08.00.02 ДСТУ EN ISO/IEC 17025',
    numberCAB: 'Реєстраційний номер ООВ',
    fullNameDirectorNAAU: 'ПІБ Директора НААУ',
    complianceRequirements: 'Акредитація відповідно до вимог:',
    typeAccreditation: 'Тип акредитації:',
    fullNameCAB: `Повна назва ООВ – юридичної особи. Якщо ООВ є структурним підрозділом юридичної особи,
      вказати її назву та назву ООВ`,
    shortNameLegal: 'Офіційна скорочена назва юридичної особи згідно зі статутними документами та ООВ за наявності',
    legalAddress: 'Місцезнаходження юридичної особи',
    actualLocationLegal: 'Фактичне місцезнаходження юридичної особи (якщо вони відрізняються)',
    actualLocationCAB: 'Фактичне місцезнаходження ООВ (якщо вони відрізняються)',
    separateCABUnit: 'Якщо ООВ є окремим підрозділом',
    nameSeparateDivision: 'Назва підрозділу',
    edrpouSeparateDivision: 'Код ЄДРПОУ відокремленого підрозділу',
    headApplicant: 'Керівник заявника',
    headCAB: 'Керівник ООВ',
    staffCount: 'Кількість фахівців, залучених до діяльності у сфері оцінки відповідності',
    employee: 'Штатних',
    freelance: 'Позаштатних',
    separateDivisions: 'Наявність відокремлених підрозділів юридичної особи',
    availabilityStations: 'Наявність дільниць',
    separateDivisionsAddress: 'Адреса відокремленого підрозділу',
    availabilityStationsAddress: 'Адреса дільниці',
    availabilityAccreditedCAB: 'Наявність у структурі заявника акредитованих ООВ за іншими стандартами:',
    accreditationCertificateNumber: 'Номер атестата акредитації',
    validity: 'Термін дії',
    detailsApplicant: 'Реквізити заявника',
    iban: 'IBAN',
    bankName: 'Назва банку',
    edrpou: 'ЄДРПОУ',
    ipn: 'Індивідуальний податковий номер',
    incomeTaxPayer: 'Платник податку на прибуток (на загальних підставах або інше)'
  },
  surveyNAAU: {
    surveyTitle: 'Опитувальна анкета Ф-08.17.15',
    inUkrainian: 'Українською мовою',
    inEnglish: 'Англійською мовою',
    statutoryDocument: 'Статутний документ, на підставі якого діє керівник заявника',
    contactPersonCAB: 'ПІБ та посада контактної(их) особи(осіб) ООВ',
    legalAddress: 'Адреса місцезнаходження головного офісу юридичної особи',
    legalLocation: 'Адреса місцезнаходження юридичної особи',
    ownership: 'Форма власності',
    governingBody: 'Орган управління',
    addressCABs: 'Адреси місцезнаходження приміщень ООВ, у тому числі усіх віддалених підрозділів, дільниць',
    addressCAB: 'Адреси місцезнаходження приміщень ООВ',
    separateCABorPart: 'ООВ є окремою організацією чи частиною більшої організації?',
    separateOrganization: 'Окрема організація',
    partLargerOrganization: 'Частина більшої організації',
    ownTechnicalBase: 'ООВ для випробувань застосовує тільки власну технічну базу?',
    qualityPerson: 'Ім\'я та посада особи, відповідальної за внутрішню систему управління якістю (за наявності)',
    accountantPerson: 'Контактна інформація бухгалтерії заявника (посада, прізвище, ім\'я та по батькові)',
    laboratoryTitle: `Якщо ООВ співпрацює з іншими лабораторіями на основі субпідрядних угод, наведіть перелік таких
      лабораторій, з  якими є  угоди на проведення випробувань (за потреби використайте додатковий лист).`,
    nameLaboratory: 'Назва лабораторії',
    address: 'Адреса лабораторії',
    district: 'Номер дільниці',
    certificate: 'Атестат акредитації',
    expirationDate: 'Термін дії',
    validCertificatesAccreditation: `Чи має ООВ чинні атестати про акредитацію, уповноваження та таке інше по
      заявленій сфері робіт в інших системах акредитації (уповноваження)?`,
    accreditationBody: 'Орган з акредитації',
    dateStartCertification: 'Дата видачі атестату акредитації',
    dateEndCertification: 'Термін дії атестату акредитації (уповноваження)',
    typeWorkCertificate: 'Вид робіт, на який виданий атестат (сфера акредитації, уповноваження)',
    amountWork: `Наведіть кількість робіт (випробувань/відбирання зразків) за напрямками діяльності ООВ, проведених
      протягом одного року до оформлення заявки`,
    preliminaryEstimation:
      'Чи є необхідним проведення попередньої оцінки з метою визначення готовності заявника до акредитації?'
  },
  passportNAAU: {
    passportTitle: 'Паспорт ВЛ Ф-08.17.19',

    passportSubTitle1: 'Форми паспорту випробувальної лабораторії',
    passportSubTitle21: 'Номенклатура продукції, що випробовується лабораторією',
    passportSubTitle22: 'Види випробувань, що проводяться лабораторією',
    passportSubTitle3: 'Оснащення випробувальним устаткованням (ВУ)',
    passportSubTitle4: 'Відомості про засоби вимірювальної техніки (ЗВТ)',
    passportSubTitle5: 'Оснащення стандартними зразками (СЗ) для аналітичного контролю',
    passportSubTitle6: 'Персонал лабораторії',
    passportSubTitle7: 'Стан виробничих приміщень',
    passportSubTitle8: 'Перелік методик випробувань, розроблених лабораторією',
    passportSubTitle9: 'Перелік робочих інструкцій',
    passportSubTitle10: 'Субпідрядні організації',
    passportSubTitle11: 'Дані про участь у програмах міжлабораторних порівнянь',

    passportFormNumber1: 'Форма 1',
    passportFormNumber2: 'Форма 2',
    passportFormNumber3: 'Форма 3',
    passportFormNumber4: 'Форма 4',
    passportFormNumber5: 'Форма 5',
    passportFormNumber6: 'Форма 6',
    passportFormNumber7: 'Форма 7',
    passportFormNumber8: 'Форма 8',
    passportFormNumber9: 'Форма 9',
    passportFormNumber10: 'Форма 10',
    passportFormNumber11: 'Форма 11',

    laboratoryName: 'Назва випробувальної лабораторії',
    laboratoryLocation: 'Місцезнаходження випробувальної лабораторії',
    subLaboratoryName: 'Назва підрозділу',
    subLaboratoryLocation: 'Місцезнаходження підрозділу',
    addSubLaboratoryButton: 'Додати адресу підрозділу',
    subLaboratory: 'Підрозділи',
    headApplicantInfo:
      'Прізвище, ім\'я, по батькові, посада, номера телефонів та електронна пошта керівника організації заявника',
    headTestingLaboratory:
      'Прізвище, ім\'я, по батькові, посада, номера телефонів та електронна пошта керівника випробувальної лабораторії',
    otherContactPersons: 'Прізвище, ім\'я, по батькові, посада, номера телефонів та електронна пошта інших контактних осіб',

    nomenclatureName: 'Назва продукції (об’єкту, матеріалу, речовини і т.п.)',
    codeDKPP: 'Код ДКПП',
    nomenclatureDesignation: 'Позначення і назва нормативних документів на продукцію (об’єкт, матеріал, речовину і т.п.)',

    testMethodDesignation: 'Позначення і назва нормативних документів на методи випробувань',

    equipmentName: 'Назва ВО, тип (марка), заводський та інвентарний номери',
    equipmentTestName: 'Назва випробувань та(або) характеристик(параметрів) продукції, матеріалу, що визначаються',
    manufacturer: 'Виробник (країна, підприємство, фірма)',
    technicalCharacteristics: 'Основні технічні характеристики',
    commissioningYear: 'Рік введення в експлуатацію',
    calibrationInterval: 'Міжкалібрувальний інтервал',

    measuringName: 'Назва ЗВТ, тип (марка), заводський та інвентарний номери',
    characteristicName: 'Назва характеристики (параметра) продукції, матеріалу, що визначаються (вимірюються)',
    measuringTechnicalCharacteristics:
      'Основні технічні характеристики (діапазон вимірювань, похибка, розширенаневизначеність вимірювання)',

    standardName: 'Назва СЗ',
    standardMarking: 'Позначення СЗ',
    minCalibrationValue: 'Номінальне значення відкаліброваної характеристики',
    toleranceCalibration: 'Допустиме відхилення від номінального значення відкаліброваної характеристики',
    nameRegulatoryDocument: 'Позначення та назва нормативного документа, в якому встановлено застосування СЗ',
    expirationDate: 'Термін придатності (наявність та термін дії свідоцтва про калібрування)',

    education: 'Освіта і спеціальність за дипломом',
    typeWork: 'Види робіт або діяльності, що проводять',

    purposePremises: 'Призначення приміщення (в т.ч. види випробувань, що проводяться)',
    specialCustom: 'Приміщення спеціальне чи пристосоване?',
    special: 'Спеціальне',
    custom: 'Пристосоване',
    square: 'Площа',
    temperature: 'Температура',
    humidity: 'Вологість, %',
    lighting: 'Освітлення робочих місць',
    gassiness: 'Рівень загазованості',
    noise: 'Рівень шуму',
    obstacle: 'Рівень завад',
    specialEquipment: 'Наявність спеціального обладнання (вентиляція, захист від завад та ін.)',
    easeDelivery: 'Зручність доставки об\'єктів випробувань',
    acceptanceAndStorage: 'Умови приймання та зберігання зразків',

    methodName: 'Назва методики',
    approvalDate: 'Дата затвердження',
    lastUpdateDate: 'Дата останньої актуалізації',
    createDate: 'Дата розробки',

    instructionName: 'Назва інструкції',

    subOrganizationsName: 'Назва субпідрядної організації',
    subOrganizationsTypeTest: 'Види випробувань',

    provider: 'Провайдер, координатор програми перевірки кваліфікації',
    testNameCompare: 'Назва випробувань та(або) характеристик(параметрів), що порівнювались',
    date: 'Дата',
    result: 'Результат'

  },
  scopeAccreditation: {
    scopeAccreditationTitle: 'Сфери Акредитації ВЛ Ф-08.17.17',
    laboratoryName: 'Назва випробувальної лабораторії, центру',
    expansionTypeNote: 'Заповніть тільки ті сфери акредитації, які ви хочете добавити.',

    objectName: 'Назва об\'єкта (продукції, матеріалу, речовини і т.п.)',
    nomenclatureDesignation: 'Позначення нормативних документів на методи випробувань',
    testingLaboratory: `Для випробувальних лабораторій, що претендують на призначення та/або нотифікацію з
      урахуванням положень документа ЕА-2/17 М:2020`,

    nameAndDesignationRegulations: 'Назва та позначення технічного регламенту',
    designationModules: 'Позначення модулів оцінки відповідності, статей або додатків',
    nameTypeProducts: 'Назва виду продукції, процесів, послуг',
    namesAndDesignationsDocuments: `Назви і позначення нормативних документів, де встановлені показники продукції,
      на відповідність яким проводиться оцінювання`
  },
  questionnaire: {
    questionnaireTitle: 'Системи управління ВЛ ДСТУ EN ISO/IEC 17025:2019',
    informationApplicant: 'Відомості про заявника',
    questionnairePersonSubTitle: 'Дані про особу, що склала опитувальний лист',
    generalizedAccreditation: 'Узагальнена сфера акредитації',

    questionnaireItemTitle: 'Номер пункту ДСТУ ISO/IEC 17025:2017',
    questionnaireValueTitle: 'Вказати номер та пункт документу, який реалізує вимогу стандарту',
    questionnaireValueTitleShort: 'Номер та пункт документу',

    '4': '4 Загальні вимоги',
    '4-1': '4.1 Неупередженість',
    '4-1-1': `4.1.1 Діяльність лабораторії повинна здійснюватися неупереджено, управління та структура лабораторії
      повинні бути направлені на забезпечення неупередженості.`,

    '4-1-2': '4.1.2 Управління лабораторією повинно здійснюватися неупереджено.',
    '4-1-3': `4.1.3 Лабораторія повинна нести відповідальність за неупередженість своєї діяльності і не повинна
      допускати комерційного, фінансового або іншого впливу, що становлять загрозу неупередженості.`,
    '4-1-4': `4.1.4 Лабораторія повинна постійно визначати ризики щодо своєї неупередженості, охоплюючи такі ризики,
      що виникають внаслідок діяльності або внаслідок взаємовідносин чи стосунків власного персоналу. Однак такі
      взаємовідносини не обов\'язково є ризиком щодо неупередженості лабораторії.`,
    '4-1-5': `4.1.5 Якщо виявлено ризик щодо неупередженості, лабораторія повинна мати можливість продемонструвати,
      яким чином вона усуває або мінімізує такий ризик.`,
    '4-2': '4.2 Конфіденційність',
    '4-2-1': `4.2.1 Лабораторія повинна нести відповідальність за зобов\'язаннями, що мають юридичну силу, щодо
      управління всією інформацією, отриманою або створеною під час виконання діяльності лабораторією.
      Лабораторія повинна заздалегідь інформувати замовника про інформацію, яку вона має намір зробити
      загальнодоступною. За винятком інформації, яку замовник робить загальнодоступною, або за згодою між
      лабораторією та замовником (наприклад, з метою відповіді на скарги), вся інша інформація вважається
      закритою та повинна вважатися конфіденційною.`,
    '4-2-2': `4.2.2 Якщо відповідно до законодавства або договірних зобов’язань від лабораторії вимагається надати
      конфіденційну інформацію, замовник або особа, яких це стосується, якщо це не заборонено законом, повинні бути
      сповіщені про надану інформацію.`,
    '4-2-3': `4.2.3 Інформація про замовника, що отримана з джерел, відмінних від замовника (наприклад, скаржника,
      регуляторних органів), повинна бути конфіденційною між замовником та лабораторією.`,
    '4-2-3-1': `Джерело цієї інформації повинно бути конфіденційним у лабораторії та не повинно розкриватися замовнику,
      якщо тільки це не узгоджено із джерелом.`,
    '4-2-4': `4.2.4 Персонал, включаючи членів комітетів, підрядників, працівників зовнішніх органів або осіб,
      які діють від імені лабораторії, повинен зберігати конфіденційність інформації, отриманої або створеної під
      час проведення діяльності лабораторією, за винятком випадків, передбачених законодавством.`,
    '5': '5 Вимоги до керування',
    '5-1': `5.1 Лабораторія повинна бути юридичною особою або визначеною частиною юридичної особи, що несе юридичну
      відповідальність за свою діяльність.`,
    '5-2': '5.2 Лабораторія повинна визначити керівництво, яке несе загальну відповідальність за лабораторію.',
    '5-3': `5.3 Лабораторія повинна визначити та задокументувати область своєї діяльності, щодо якої вона відповідає
      цьому документу.`,
    '5-3-1': `Лабораторія повинна заявляти про свою відповідність цьому документу для зазначеної області діяльності
      лабораторії, яка виключає діяльність лабораторії, що надається ззовні на постійній основі.`,
    '5-4': `5.4 Діяльність лабораторії повинна виконуватися таким чином, щоб відповідати вимогам цього документа,
      вимогам замовників лабораторії, регуляторних органів та організацій, що надають визнання.`,
    '5-4-1': `Зазначене повинно включати діяльність лабораторії, яка виконується в її постійних приміщеннях, на
      віддалених від її постійних приміщень ділянках, на тимчасових або мобільних об\'єктах чи в приміщенні замовника.`,
    '5-5': '5.5 Лабораторія повинна:',
    '5-5-a': `a) визначити організаційну структуру та структуру управління лабораторією, її місце в організації, до
      складу якої вона входить, а також взаємозв’язки між управлінням, технічними підрозділами та допоміжними службами;`,
    '5-5-b': `b) визначити відповідальність, повноваження та взаємовідносини всього персоналу, який управляє, виконує
      або перевіряє роботу, що впливає на результати діяльності лабораторії;`,
    '5-5-c': `c) задокументувати свої процедури в обсязі, необхідному для забезпечення послідовного виконання
      діяльності лабораторією та отримання достовірних результатів.`,
    '5-6': `5.6 Лабораторія повинна мати персонал, який, незалежно від інших обов\'язків, має повноваження та ресурси,
      необхідні для виконання своїх обов\'язків, що включають:`,
    '5-6-a': 'a) впровадження, підтримання та вдосконалення системи управління;',
    '5-6-b': 'b) виявлення відхилень від системи управління або процедур виконання діяльності лабораторії;',
    '5-6-c': 'c) ініціювання заходів щодо запобігання або мінімізації таких відхилень;',
    '5-6-d': 'd) звітування керівництву лабораторії про дієвість системи управління та будь-які потреби у вдосконаленні;',
    '5-6-e': 'e) забезпечення результативності діяльності лабораторії.',
    '5-7': '5.7 Керівництво лабораторії повинно гарантувати:',
    '5-7-a': `a) обмін інформацією стосовно результативності системи управління та важливості виконання вимог
      замовників та інших вимог;`,
    '5-7-b': `b) забезпечення цілісності функціонування системи управління, коли планують та здійснюють зміни до
      системи управління.`,
    '6': '6 Вимоги до ресурсів',
    '6-1': '6.1 Загальні положення',
    '6-1-1': `Лабораторія повинна мати персонал, приміщення, обладнання, системи та допоміжні служби, необхідні для
      управління та виконання лабораторією своєї діяльності.`,
    '6-2': '6.2 Персонал',
    '6-2-1': `6.2.1 Увесь персонал лабораторії, внутрішній та зовнішній, який може вплинути на діяльність лабораторії,
      повинен діяти неупереджено, бути компетентнм та працювати у відповідності до системи управління лабораторії.`,
    '6-2-2': `6.2.2 Лабораторія повинна задокументувати вимоги до компетентності для кожної функції, яка впливає на
      результати діяльності лабораторії, включаючи вимоги до освіти, кваліфікації, підготовки, технічних знань,
      навичок та досвіду.`,
    '6-2-3': `6.2.3 Лабораторія повинна забезпечити, щоб персонал мав компетентність для виконання своєї діяльності,
      за яку він несе відповідальність, та для оцінювання значимості відхилень.`,
    '6-2-4': '6.2.4 Керівництво лабораторії повинно довести до персоналу його обов\'язки, відповідальність та повноваження.',
    '6-2-5': '6.2.5 Лабораторія повинна мати процедуру (процедури) та підтримувати записи для:',
    '6-2-5-a': 'a) визначення вимог до компетентності;',
    '6-2-5-b': 'b) підбору персоналу;',
    '6-2-5-c': 'c) навчання персоналу;',
    '6-2-5-d': 'd) нагляду за персоналом;',
    '6-2-5-e': 'e) уповноваження персоналу;',
    '6-2-5-f': 'f) моніторингу компетентності персоналу.',
    '6-2-6': `6.2.6 Лабораторія повинна уповноважити персонал для виконання конкретної діяльності лабораторії,
      що включає, але не обмежується, наступним.`,
    '6-2-6-a': 'a) розроблення, модифікацію, верифікацію та валідацію методів;',
    '6-2-6-b': 'b) аналізування результатів, включаючи заяви про відповідність або думки та тлумачення;',
    '6-2-6-c': 'c) звітування, аналіз та затвердження результатів.',
    '6-3': '6.3 Приміщення та умови довкілля',
    '6-3-1': `6.3.1 Приміщення та умови довкілля повинні бути придатними для здійснення діяльності лабораторією та не
      повинні негативно впливати на достовірність результатів.`,
    '6-3-2': `6.3.2 Вимоги до приміщень та умов довкілля, необхідні для виконання діяльності лабораторією, повинні
      бути задокументовані.`,
    '6-3-3': `6.3.3 Лабораторія повинна відстежувати, контролювати та реєструвати умови довкілля відповідно до
      визначених специфікацій, методів або процедур чи якщо вони впливають на достовірність результатів.`,
    '6-3-4': `6.3.4 Заходи з контролю приміщень повинні впроваджуватися, контролюватися та періодично переглядатися,
      і включати, але не обмежуватися, наступне:`,
    '6-3-4-a': 'a) доступ до/та використання ділянок, що впливають на діяльність лабораторії;',
    '6-3-4-b': 'b) запобігання забрудненню, втручанням або негативним впливам на діяльність лабораторії;',
    '6-3-4-c': 'c) ефективне розмежування ділянок з несумісними видами діяльності лабораторії.',
    '6-3-5': `6.3.5 Якщо лабораторія проводить діяльність поза межами своїх приміщень або на ділянках, що не
      перебувають під її постійним контролем, вона повинна пересвідчитися, що вимоги цього документа стосовно
      приміщень та умов довкілля виконуються.`,
    '6-4': '6.4 Обладнання',
    '6-4-1': `6.4.1 Лабораторія повинна мати доступ до обладнання (включаючи, але не обмежуючись, засобами вимірювання,
      програмним забезпеченням, еталонами, стандартними зразками, стандартними довідковими даними, реагентами,
      витратними матеріалами або допоміжними засобами), що вимагається для правильного здійснення діяльності
      лабораторії та що може вплинути на результати.`,
    '6-4-2': `6.4.2 Якщо лабораторія використовує обладнання, що не перебуває під її постійним контролем, вона
      повинна переконатися, що вимоги цього документа для обладнання виконуються.`,
    '6-4-3': `6.4.3 Лабораторія повинна мати процедуру поводження, транспортування, зберігання, використання та
      планового технічного обслуговування обладнання у спосіб, що дає впевненість у його правильному функціонуванні
      та запобігає забрудненню чи зношенню.`,
    '6-4-4': `6.4.4 Лабораторія повинна перевірити обладнання на відповідність визначеним вимогам, перш ніж вводити чи
      повертати його в експлуатацію.`,
    '6-4-5': `6.4.5 Обладнання, що використовується для вимірювання, повинно забезпечувати точність вимірювання
      та/або невизначеність вимірювання, які необхідні для забезпечення достовірності результату.`,
    '6-4-6': '6.4.6 Вимірювальне обладнання повинно бути відкалібровано, якщо.',
    '6-4-6-1': '- точність вимірювання або невизначеність вимірювання впливає на достовірність отриманих результатів, і/або',
    '6-4-6-2': '- калібрування обладнання необхідне для встановлення метрологічної простежуваності отриманих результатів.',
    '6-4-7': `6.4.7 Лабораторія повинна встановити програму калібрування, яка повинна переглядатися та при необхідності
      коригуватися для підтримання впевненості до статусу калібрування.`,
    '6-4-8': `6.4.8 Усе обладнання, що потребує калібрування або має обмежений термін використання, повинно бути
      марковане, кодоване чи в інший спосіб ідентифіковане для того, щоб користувачеві обладнання було легко визначити
      статус калібрування або термін придатності.`,
    '6-4-9': `6.4.9 Обладнання, яке піддавалось перенавантаженню або з яким неналежним чином поводилися, що показує
      сумнівні результати або виявилося дефектним, або є поза встановленими вимогами, повинно бути виведене з
      експлуатації.`,
    '6-4-9-1': `Воно повинно бути ізольоване, щоб запобігти його використанню, або чітко марковане чи позначене як таке,
      що виведене з експлуатації, поки воно не буде перевірено на предмет правильного функціонування.`,
    '6-4-9-2': `Лабораторія повинна дослідити вплив дефекту або відхилення від встановлених вимог та ініціювати дії,
      передбачені процедурою управління невідповідною роботою (див. 7.10)`,
    '6-4-10': `6.4.10 Якщо для підтримання довіри до працездатності обладнання необхідні проміжні перевіряння, то вони
      повинні проводитися відповідно до процедури.`,
    '6-4-11': `6.4.11 Коли дані щодо калібрування та стандартних зразків включають референтні значення або поправочні
      коефіцієнти, лабораторія повинна забезпечити, що референтне значення та поправочні коефіцієнти є актуалізованими
      та впровадженими належним чином відповідно до вимог.`,
    '6-4-12': `6.4.12 Лабораторія повинна вжити практичні заходи для того, щоб попередити виникнення недостовірних
      результатів через ненавмисне змінення налаштувань обладнання.`,
    '6-4-13': `6.4.13 Повинні зберігатися записи стосовно обладнання, яке може впливати на діяльність лабораторії.
      Ці записи повинні містити, коли застосовно:`,
    '6-4-13-a': 'a) ідентифікацію обладнання, включаючи версію програмного забезпечення та прошивки;',
    '6-4-13-b': 'b) найменування виробника, ідентифікацію типу, серійний номер або інше унікальне позначення;',
    '6-4-13-c': 'c) докази перевірки того, що обладнання відповідає зазначеним вимогам;',
    '6-4-13-d': 'd) поточне місцезнаходження;',
    '6-4-13-e': `e) дати калібрувань, результати калібрувань, коригувань, критерії прийнятності та терміни наступних
      калібрувань або міжкалібрувальні інтервали;`,
    '6-4-13-f': `f) документацію стосовно стандартних зразків, результатів, критеріїв прийнятності, доречних дат та
      терміну придатності;`,
    '6-4-13-g': `g) план технічного обслуговування та технічне обслуговування станом на сьогодні, де потрібно для
      роботи обладнання;`,
    '6-4-13-h': 'h) деталі про будь-які пошкодження, несправності, модифікації або ремонти обладнання',
    '6-5': '6.5 Метрологічна простежуваність',
    '6-5-1': `6.5.1 Лабораторія повинна встановити і підтримувати метрологічну простежуваність результатів вимірювань
      за допомогою задокументованого нерозривного ланцюга калібрувань, кожен з яких робить свій внесок у невизначеність
      вимірювання, пов\'язуючи їх з відповідним еталоном.`,
    '6-5-2': `6.5.2 Лабораторія повинна забезпечити простежуваність результатів вимірювань до Міжнародної системи
      одиниць (SІ) шляхом:`,
    '6-5-2-a': 'a) калібрування, наданого компетентною лабораторією; або',
    '6-5-2-b': `b) використання сертифікованих значень сертифікованих стандартних зразків, наданих компетентним
      постачальником із вказаною метрологічною простежуваністю до SІ; або`,
    '6-5-2-c': `c) безпосередньої реалізації одиниць SІ шляхом прямого або опосередкованого порівняння з
      національними чи міжнародними еталонами.`,
    '6-5-3': `6.5.3 Якщо метрологічна простежуваність до одиниць SІ технічно неможлива, лабораторія повинна
      продемонструвати метрологічну простежуваність до відповідного еталону, наприклад:`,
    '6-5-3-a': 'a) сертифікованих значень сертифікованих стандартних зразків, наданих компетентним постачальником;',
    '6-5-3-b': `b) результатів еталонних методик вимірювання, установлених методів або узгоджених еталонів, які
      детально описані та прийняті як такі, що забезпечують результати вимірювання, придатні для їх цільового
      використання, і забезпечені належним порівнянням.`,
    '6-6': '6.6 Продукція та послуги від зовнішніх постачальників',
    '6-6-1': `6.6.1 Лабораторія повинна забезпечити використання лише придатної продукції та послуг, що постачаються
      ззовні, та впливають на діяльність лабораторії, коли така продукція та послуги:`,
    '6-6-1-a': 'a) призначені для включення у власну діяльність лабораторії;',
    '6-6-1-b': 'b) частково або повністю надаються лабораторією замовнику як отримані від зовнішнього постачальника;',
    '6-6-1-c': 'c) використовуються для підтримання функціонування лабораторії.',
    '6-6-2': '6.6.2 Лабораторія повинна мати процедуру та зберігати записи для:',
    '6-6-2-a': 'a) визначення, аналізу та затвердження вимог лабораторії до продукції та послуг, що постачаються зовні;',
    '6-6-2-b': `b) визначення критеріїв для оцінки, вибору, моніторингу дієвості та повторної оцінки зовнішніх
      постачальників;`,
    '6-6-2-c': `c) гарантування того, що продукція та послуги зовнішнього походження, відповідають встановленим в
      лабораторії вимогам або, коли застосовно, відповідним вимогам цього документу, перш ніж вони будуть
      використані або безпосередньо надані замовнику;`,
    '6-6-2-d': `d) виконання будь-яких дій, що виникають внаслідок оцінки, моніторингу дієвості та повторної оцінки
      зовнішніх постачальників.`,
    '6-6-3': '6.6.3 Лабораторія повинна повідомляти  зовнішніх постачальників про свої вимоги щодо:',
    '6-6-3-a': 'a) продукції та послуг, які будуть надані;',
    '6-6-3-b': 'b) критеріїв прийнятності;',
    '6-6-3-c': 'c) компетентності, включаючи будь-які вимоги до кваліфікації персоналу;',
    '6-6-3-d': 'd) дій, які лабораторія або її замовник має намір виконати в приміщенні зовнішнього постачальника.',
    '7': '7 Вимоги до процесу',
    '7-1': '7.1 Аналіз запитів, тендерів та договорів',
    '7-1-1': '7.1.1 Лабораторія  повинна  мати  процедуру  для  аналізу  запитів,  тендерів  та  договорів.',
    '7-1-1-1': 'Процедура повинна забезпечити, щоб:',
    '7-1-1-a': 'a) вимоги були чітко визначені, задокументовані та зрозумілі;',
    '7-1-1-b': 'b) лабораторія мала можливість та ресурси для виконання вимог;',
    '7-1-1-c': `c) якщо залучаються зовнішні постачальники, то застосовуються вимоги розділу 6.6 та лабораторія
      схвалює із замовником конкретної діяльності лабораторії зовнішнього постачальника, що буде виконувати
      роботу для нього;`,
    '7-1-1-d': 'd) відповідні методи або процедури вибрані та здатні задовольнити вимоги замовника',
    '7-1-2': `7.1.2 Лабораторія повинна інформувати замовника, коли метод, який пропонує замовник, вважається
      невідповідним або неактуальним.`,
    '7-1-3': `7.1.3 Коли замовник вимагає від лабораторії заяву про відповідність специфікації або стандарту для
      випробовування (наприклад, відповідає/не відповідає, в допуску/поза допуском), то специфікація чи стандарт та
      правило прийняття рішення повинні бути чітко визначені.`,
    '7-1-3-1': `Якщо воно не зазначено у специфікації чи стандарті, щодо яких зроблено запит, то вибране правило
      прийняття рішення повинно бути доведено до відома і узгоджено із замовником.`,
    '7-1-4': `7.1.4 Будь-які розбіжності між запитом чи тендерною пропозицією та договором повинні бути вирішені до
      початку виконання діяльності лабораторією.`,
    '7-1-4-1': 'Кожен договір повинен бути прийнятний як для лабораторії, так і замовника.',
    '7-1-4-2': `Відхилення, що вимагаються замовником, не повинні впливати на цілісність функціонування лабораторії
      або достовірність результатів.`,
    '7-1-5': '7.1.5 Замовник повинен бути поінформований про будь-яке відхилення від договору.',
    '7-1-6': `7.1.6 Якщо договір потребує змін після того, як роботи розпочались, аналіз договору повинен бути
      повторений і всі зміни повинні бути доведені до відома причетного персоналу.`,
    '7-1-7': `7.1.7 Лабораторія повинна взаємодіяти із замовниками або їх представниками для роз’яснення запиту
      замовника та моніторингу дієвості лабораторії щодо виконаної роботи.`,
    '7-1-7-a': `a) надання доступу у розумних межах до відповідних ділянок лабораторії для спостереження за діяльністю
      лабораторії з урахуванням вимог замовника;`,
    '7-1-7-b': 'b) підготовку, упакування та відправлення зразків, необхідних для здійснення перевірки замовником',
    '7-1-8': '7.1.8 Записи щодо аналізу, включаючи будь-які суттєві зміни, повинні зберігатися.',
    '7-1-8-1': `Записи повинні бути доступними для відповідних обговорень із замовником стосовно вимог замовника або
      результатів діяльності лабораторії.`,
    '7-2': '7.2 Вибирання, верифікація та валідація методів',
    '7-2-1': '7.2.1 Вибирання та верифікація методів',
    '7-2-1-1': `7.2.1.1 Лабораторія повинна використовувати прийнятні методи та процедури для здійснення всієї
      діяльності і, де це доречно, для оцінювання невизначеності вимірювань а також статистичних методик аналізу даних.`,
    '7-2-1-2': `7.2.1.2 Усі методи, процедури та допоміжна документація, такі як інструкції, стандарти, настанови та
      довідкові дані, що стосуються діяльності лабораторії, повинні бути актуалізовані та доступні для персоналу
      (див. 8.3).`,
    '7-2-1-3': `7.2.1.3 Лабораторія повинна забезпечити, що вона використовує останню дійсну версію метода, за
      винятком, коли це недоречно або неможливо.`,
    '7-2-1-3-1': `Коли необхідно, застосування метода повинно бути доповнене додатковою інформацією для забезпечення
      послідовного застосування.`,
    '7-2-1-4': `7.2.1.4 Якщо замовник не зазначає метод для використання, лабораторія повинна вибрати відповідний метод
      та проінформувати замовника про вибраний метод.`,
    '7-2-1-4-1': `Методи, опубліковані у міжнародних, регіональних чи національних стандартах або видані авторитетними
      технічними організаціями, або видані у відповідній науковій літературі чи журналах, або ті, що зазначаються
      виробником обладнання, є рекомендованими.`,
    '7-2-1-4-2': 'Методи, розроблені та модифіковані лабораторією, можуть також використовуватися.',
    '7-2-1-5': `7.2.1.5 Лабораторія повинна перевірити, що вона може правильно виконувати методи до початку їх
      впровадження шляхом доведення того, що вона може досягнути необхідну результативність.`,
    '7-2-1-5-1': 'Записи про верифікацію мають зберігатися.',
    '7-2-1-5-2': 'Якщо метод переглянуто органом, який його розробляє, верифікацію потрібно повторити в необхідному обсязі.',
    '7-2-1-6': `7.2.1.6 Якщо необхідно розробити метод, то це повинно бути запланованою діяльністю, що доручається
      компетентному персоналу, забезпеченому відповідними ресурсами.`,
    '7-2-1-6-1': `У процесі розроблення методу повинен здійснюватися періодичний аналіз для підтвердження, що
      потреби замовника досі виконуються.`,
    '7-2-1-6-2': 'Будь-які модифікації до плану розроблення повинні бути схвалені та затверджені.',
    '7-2-1-7': `7.2.1.7 Відхилення від методів у всій діяльності лабораторії допускаються лише у тому випадку, якщо це
      відхилення задокументовано, технічно обґрунтовано, затверджено та прийнято замовником`,
    '7-2-2': '7.2.2 Валідація методів',
    '7-2-2-1': `7.2.2.1 Лабораторія повинна валідувати нестандартизовані методи, методи, розроблені лабораторією,
      та стандартизовані методи, які використовуються в інший ніж передбачено спосіб або модифіковані.`,
    '7-2-2-1-1': `Валідація має бути настільки масштабною, наскільки це необхідно для задоволення потреб даного
      застосування або області застосування.`,
    '7-2-2-2': `7.2.2.2 Якщо вносяться зміни до валідованого методу, вплив таких змін повинен бути визначений і там,
      де вони впливають на початкову валідацію, повинна бути проведена нова валідація методу.`,
    '7-2-2-3': `7.2.2.3 Робочі характеристики валідованих методів, що використовуються за призначенням, повинні
      відповідати потребам замовників та бути сумісними з визначеними вимогами.`,
    '7-2-2-4': '7.2.2.4 Лабораторія повинна зберігати наступні записи щодо валідації:',
    '7-2-2-4-a': 'a) процедуру валідації, що була використана;',
    '7-2-2-4-b': 'b) специфікацію вимог;',
    '7-2-2-4-c': 'c) визначення робочих характеристик методу;',
    '7-2-2-4-d': 'd) отримані результати;',
    '7-2-2-4-e': 'e) заяву про валідацію методу, що деталізує його придатність до застосування за призначенням.',
    '7-3': '7.3 Відбирання зразків',
    '7-3-1': `7.3.1 Лабораторія повинна мати план та метод відбирання зразків, якщо вона проводить відбирання проб
      речовин, матеріалів або продукції для подальшого випробування.`,
    '7-3-1-1': `Метод відбирання повинен вказувати на фактори, які треба контролювати для забезпечення впевненості в
      достовірності результатів випробування.`,
    '7-3-1-2': 'План та метод відбирання повинні бути доступними на місці, де проводиться відбирання зразків.',
    '7-3-1-3': 'Плани відбирання зразків повинні, де це доречно, базуватися на відповідних статистичних методах.',
    '7-3-2-4': '7.3.2 Метод відбирання зразків повинен описувати:',
    '7-3-2-a': 'a) вибір зразків або місць відбирання;',
    '7-3-2-b': 'b) план відбирання;',
    '7-3-2-c': `c) підготовку та обробку зразка(-ів) речовини, матеріалу або продукції для його передачі для подальшого
      випробування.`,
    '7-3-3': `7.3.3 Лабораторія повинна зберігати записи з даними щодо відбирання зразків, які є частиною роботи з
      випробування.`,
    '7-3-3-1': 'Записи повинні включати, якщо доречно:',
    '7-3-3-a': 'a) посилання на метод відбирання зразків, що використовується;',
    '7-3-3-b': 'b) дату та час відбирання зразків;',
    '7-3-3-c': 'c) ідентифікаційні дані та опис зразка (наприклад, номер, кількість, назва);',
    '7-3-3-d': 'd) ідентифікацію персоналу, що проводить відбирання;',
    '7-3-3-e': 'e) ідентифікацію обладнання, що використовується;',
    '7-3-3-f': 'f) умови навколишнього середовища та умови транспортування;',
    '7-3-3-g': 'g) діаграми або подібні засоби ідентифікації місць відбирання зразків, якщо необхідно;',
    '7-3-3-h': 'h) відхилення, доповнення або винятки з методу відбирання та плану відбирання.',
    '7-4': '7.4 Поводження зі зразками для випробування чи калібрування',
    '7-4-1': `7.4.1 Лабораторія повинна мати процедуру транспортування, отримання, обробки, захисту, поводження,
      зберігання, утримання та утилізації або повернення зразків для випробування, включаючи всі дії, необхідні для
      захисту цілісності зразка для випробування, а також захисту інтересів лабораторії та замовника.`,
    '7-4-1-1': `Повинні бути здійснені дії для запобігання погіршенню, забрудненню, втраті чи пошкодженню зразків під
      час обробки, транспортування, зберігання/очікування та підготовки до випробування.`,
    '7-4-1-2': 'Потрібно дотримуватися інструкцій з поводження, які додаються до зразків.',
    '7-4-2': '7.4.2 Лабораторія повинна мати систему однозначної ідентифікації зразків для випробування.',
    '7-4-2-1': 'Ідентифікація повинна зберігатися протягом часу перебування зразків під відповідальністю лабораторії.',
    '7-4-2-2': `Система повинна гарантувати, що зразки не будуть сплутані фізично або коли вони зазначаються в
      записах або інших документах.`,
    '7-4-2-3': 'Система повинна, якщо доречно, містити поділ зразка чи груп зразків та переміщення зразків.',
    '7-4-3': '7.4.3 Після отримання зразка для випробування повинні бути зареєстровані відхилення від встановлених умов.',
    '7-4-3-1': `Коли є сумніви щодо придатності зразка для випробування або якщо зразок не відповідає наданому опису,
      перед продовженням роботи лабораторія повинна проконсультуватися із замовником для отримання подальших
      інструкцій та зареєструвати результати цих консультацій.`,
    '7-4-3-2': `Якщо замовник вимагає випробування зразка, незважаючи на відхилення від визначених умов, лабораторія
      повинна включати у звіт застереження, у якому зазначається, на які результати може негативно вплинути це
      відхилення.`,
    '7-4-4': `7.4.4 Якщо зразки потребують зберігання або обробки в певних умовах, ці умови повинні підтримуватися,
      контролюватися та реєструватися.`,
    '7-5': '7.5 Технічні записи',
    '7-5-1': `7.5.1 Лабораторія повинна забезпечити, щоб технічні записи щодо кожної діяльності лабораторії містили
      результати, звіт та достатню інформацію, якщо можливо, для сприяння визначення чинників, що впливають на
      результат вимірювання та пов\'язану з ним невизначеність вимірювання, та робити можливим повторення діяльності
      лабораторії за умов максимально наближених до початкових.`,
    '7-5-1-1': `Технічні записи повинні включати дату та ідентифікацію персоналу, відповідального за кожну частину
      діяльності лабораторії, а також за перевірку даних та результатів.`,
    '7-5-1-2': `Первинні спостереження, дані та розрахунки повинні реєструватися під час їх отримання та повинні
      простежуватися до конкретних завдань.`,
    '7-5-2': `7.5.2 Лабораторія повинна забезпечити, щоб внесення змін в технічні записи простежувалися до попередніх
      версій або до первинних спостережень.`,
    '7-5-2-1': `Як первинні, так і виправлені дані та файли повинні зберігатися, включаючи дату внесення змін,
      позначення виправлень та персоналу, відповідального за внесення змін.`,
    '7-6': '7.6 Оцінювання невизначеності вимірювання',
    '7-6-1': '7.6.1 Лабораторія повинна ідентифікувати складові невизначеності вимірювання.',
    '7-6-1-1': `Під час оцінювання невизначеності вимірювання всі суттєві складові, включаючи ті, що виникають у
      процесі відбирання зразків, повинні бути враховані з використанням відповідних методів аналізу.`,
    '7-6-2': `7.6.2 Лабораторія, що здійснює калібрування, в тому числі власного обладнання, повинна оцінювати
      невизначеність вимірювання для усіх калібрувань.`,
    '7-6-3': '7.6.3 Лабораторія, що проводить випробування, повинна оцінювати невизначеність вимірювання.',
    '7-6-3-1': `Якщо метод випробування не допускає строгого оцінювання невизначеності вимірювання, оцінювання повинно
      проводитися на основі розуміння теоретичних принципів або практичного досвіду виконання методу.`,
    '7-7': '7.7 Забезпечення достовірності результатів',
    '7-7-1': '7.7.1 Лабораторія повинна мати процедуру для моніторингу достовірності результатів.',
    '7-7-1-1': `Дані результатів повинні бути записані таким чином, щоб тенденції можна було виявляти, та, по
      можливості, для аналізу результатів повинні застосовуватися статистичні методи.`,
    '7-7-1-2': 'Такий моніторинг повинен бути плановим і переглядатися та, де це доречно, включати, але не обмежуватися:',
    '7-7-1-a': 'a) використання стандартних зразків або матеріалів для контролювання якості;',
    '7-7-1-b': `b) використання альтернативного обладнання, яке повинно бути відкаліброване для забезпечення
      простежуваності результатів;`,
    '7-7-1-c': 'c) перевірку(-и) функціонування вимірювального та випробувального обладнання;',
    '7-7-1-d': 'd) використання еталону порівняння або робочого еталону з контрольними картами, де застосовно;',
    '7-7-1-e': 'e) проміжні перевіряння вимірювального обладнання;',
    '7-7-1-f': 'f) дублювання випробування за допомогою тих самих або інших методів;',
    '7-7-1-g': 'g) повторне випробування зразків, що зберігаються;',
    '7-7-1-h': 'h) кореляцію результатів щодо різних характеристик зразка;',
    '7-7-1-i': 'i) аналіз отриманих результатів;',
    '7-7-1-j': 'j) внутрішньолабораторні порівняння;',
    '7-7-1-k': 'k) випробування сліпої проби (проб).',
    '7-7-2': `7.7.2 Лабораторія повинна моніторити свої результати в порівняні з результатами інших лабораторій,
      де це можливо і доречно.`,
    '7-7-2-1': 'Цей моніторинг повинен плануватися та переглядатися, і включати, але не обмежуватись, наступним:',
    '7-7-2-a': 'a) участь у перевірках кваліфікації;',
    '7-7-2-b': 'b) участь у міжлабораторних порівняннях, відмінних від перевірок кваліфікації.',
    '7-7-3': `7.7.3 Дані моніторингу повинні бути проаналізовані, використані для контролю та, якщо застосовно,
      для вдосконалення діяльності лабораторії.`,
    '7-7-3-1': `Якщо результати аналізу даних моніторингу виявляються поза межами заздалегідь встановлених критеріїв,
      повинні вводитись відповідні дії для запобігання потраплянню неправильних результатів у звіт.`,
    '7-8': '7.8 Звітування про результати',
    '7-8-1': '7.8.1 Загальні положення',
    '7-8-1-1': '7.8.1.1 Результати повинні бути перевірені та затверджені до видання.',
    '7-8-1-2': `7.8.1.2 Результати повинні надаватися чітко, зрозуміло, однозначно та об\'єктивно, як правило,
      у вигляді звіту (наприклад, протокол випробування або звіту про відбирання зразків), і включати всю інформацію,
      погоджену із замовником та необхідну для тлумачення результатів, та всю інформацію, що вимагається використаним
      методом.`,
    '7-8-1-2-1': 'Усі видані звіти повинні зберігатися як технічні записи.',
    '7-8-1-3': '7.8.1.3 За погодженням із замовником звітувати про результати можна в спрощеному вигляді.',
    '7-8-1-3-1': `Будь-яка інформація, зазначена в пунктах 7.8.2-7.8.7, яка не надається замовнику, повинна
      бути легкодоступною.`,
    '7-8-2': '7.8.2 Загальні вимоги до протоколів (випробування або відбирання зразків)',
    '7-8-2-1': `7.8.2.1 Кожен протокол повинен включати щонайменше наступну інформацію, якщо тільки лабораторія не має
      підтвердженого обґрунтування не робити цього, щоб звести до мінімуму будь-яку можливість неправильного розуміння
      або неправильного використання:`,
    '7-8-2-1-a': 'a) заголовок (наприклад, "Протокол випробування" або "Протокол відбору зразків");',
    '7-8-2-1-b': 'b) назву та адресу лабораторії;',
    '7-8-2-1-c': `c) місце проведення діяльності лабораторії, в тому числі при її проведенні на території замовника
      або в місцях, віддалених від постійних приміщень лабораторії, або в пов’язаних тимчасових або мобільних об’єктах;`,
    '7-8-2-1-d': `d) чітку ідентифікацію, що всі компоненти є частинами повного протоколу та чітку ідентифікацію
      кінця звіту;`,
    '7-8-2-1-e': 'e) назву та контактну інформацію замовника;',
    '7-8-2-1-f': 'f) ідентифікацію використаного методу;',
    '7-8-2-1-g': 'g) опис, однозначну ідентифікацію та, у разі необхідності, стан зразка;',
    '7-8-2-1-h': `h) дату отримання зразка (зразків) для випробування, а також дату відбирання зразків, якщо це є
      критичним для достовірності та застосування результатів;`,
    '7-8-2-1-i': 'i) дату(-и) виконання роботи лабораторією;',
    '7-8-2-1-j': 'j) дату видання протоколу;',
    '7-8-2-1-k': `k) посилання на план та метод відбирання зразків, що використані лабораторією або іншими органами,
      якщо це стосується достовірності чи застосування результатів;`,
    '7-8-2-1-l': 'l) заяву про те, що результати стосуються зразків, що були випробувані або відібрані;',
    '7-8-2-1-m': 'm) результати, де застосовно, з одиницями вимірювання;',
    '7-8-2-1-n': 'n) доповнення, відхилення або винятки з методу;',
    '7-8-2-1-o': 'o) ідентифікацію особи (осіб), яка затверджує протокол;',
    '7-8-2-1-p': 'p) чітку ідентифікацію результатів, отриманих від зовнішніх постачальників.',
    '7-8-2-2': `7.8.2.2 Лабораторія повинна нести відповідальність за всю інформацію, надану в протоколі, крім випадків,
      коли інформація надана замовником.`,
    '7-8-2-2-1': 'Дані, надані замовником, мають бути чітко позначені.',
    '7-8-2-2-2': `Крім того, заява про відмову повинна бути включена до протоколу, коли інформація надана замовником
      може вплинути на достовірність результатів.`,
    '7-8-2-2-3': `Якщо лабораторія не була відповідальною за етап відбирання зразків
      (наприклад, зразки були надані замовником), у протоколі повинно бути зазначено, що результати стосуються зразка,
      у тому вигляді, у якому його було отримано.`,
    '7-8-3': '7.8.3 Спеціальні вимоги до протоколів випробування',
    '7-8-3-1': `7.8.3.1 У доповнення до вимог, зазначених у пункті 7.8.2, протокол випробування, де це необхідно для
      інтерпретації результатів випробувань, повинен включати наступне:`,
    '7-8-3-1-a': 'a) інформацію про спеціальні умови випробувань, такі як умови довкілля;',
    '7-8-3-1-b': 'b) де необхідно, заяву про відповідність вимогам або специфікаціям (див. 7.8.6);',
    '7-8-3-1-c': `c) де  застосовно,  невизначеність  вимірювання,  подану  в  тих  же  одиницях,  що  і вимірювана
      величина, або відносних одиницях (наприклад, у відсотках), коли:`,
    '7-8-3-1-c-1': '- це пов’язано з достовірністю чи застосуванням результатів випробувань;',
    '7-8-3-1-c-2': '- цього вимагає інструкція замовника, або',
    '7-8-3-1-c-3': '- невизначеність вимірювань впливає на відповідність встановленим межам специфікацій;',
    '7-8-3-1-d': 'd) де доречно, тлумачення та інтепретації (див. 7.8.7);',
    '7-8-3-1-e': `e) додаткову інформацію, яка може вимагатися конкретним методом, регуляторними органами,
      замовниками, або групами замовників.`,
    '7-8-3-2': `7.8.3.2 Якщо лабораторія відповідальна за відбирання зразків, протоколи випробувань повинні
      відповідати вимогам пункту 7.8.5, де це необхідно для інтерпретації результатів випробувань.`,
    '7-8-4': '7.8.4 Спеціальні вимоги до свідоцтв про калібрування (не відноситься до випробувальних лабораторій)',
    '7-8-5': '7.8.5 Протокол відбирання зразків - спеціальні вимоги',
    '7-8-5-1': `Якщо лабораторія відповідає за діяльність з відбирання зразків, на додаток до вимог, зазначених у
      пункті 7.8.2, у звіт, де це необхідно для інтерпретації результатів, повинно включатися наступне:`,
    '7-8-5-1-a': 'a) дата відбирання зразків;',
    '7-8-5-1-b': `b) чітка ідентифікація зразка або матеріалу, що відібраний (включаючи назву виробника, модель або
      тип позначення та серійні номери, за необхідності);`,
    '7-8-5-1-c': 'c) місце відбирання, включаючи будь-які діаграми, ескізи або фотографії;',
    '7-8-5-1-d': 'd) посилання на план відбирання зразків та метод відбирання;',
    '7-8-5-1-e': 'e) деталі будь-яких умов довкілля під час відбирання, які можуть вплинути на інтерпретацію результатів;',
    '7-8-5-1-f': 'f) інформація, необхідна для оцінювання невизначеності вимірювання при подальшому випробуванні.',
    '7-8-6': '7.8.6 Звітування щодо заяв про відповідність',
    '7-8-6-1': `7.8.6.1 Коли надається заява про відповідність специфікації або стандарту, лабораторія повинна
      документувати застосовне нею правило прийняття рішення з урахуванням рівня ризику (наприклад, помилкове
      прийняття та помилкове відхилення, статистичні припущення), пов\'язаного з правилом прийняття рішення,
      і застосувати правило прийняття рішення.`,
    '7-8-6-2': '7.8.6.2 Лабораторія повинна звітувати стосовно заяви про відповідність, щоб у ній чітко зазначалося:',
    '7-8-6-2-a': 'a) яких результатів стосується ця заява про відповідність;',
    '7-8-6-2-b': 'b) які специфікації, стандарти чи їх частини виконуються або не виконуються;',
    '7-8-6-2-c': 'c) застосоване правило прийняття рішення (якщо воно не відображене у вимогах специфікації або стандарту).',
    '7-8-7': '7.8.7 Включення до звіту думок та тлумачень',
    '7-8-7-1': `7.8.7.1 Якщо надаються думки та тлумачення, лабораторія повинна забезпечити, що відповідну заяву
      робить тільки персонал, уповноважений надавати думки та тлумачення. Лабораторія повинна документувати
      підстави, на яких базуються думки та тлумачення.`,
    '7-8-7-2': `7.8.7.2 Думки та тлумачення, викладені в звітах, повинні базуватись на результатах випробування
      об’єкта, і повинні бути чітко визначені як такі.`,
    '7-8-7-3': `7.8.7.3 Коли думки та тлумачення формуються на підставі обговорення із замовником, запис про
      обговорення повинен зберігатися.`,
    '7-8-8': '7.8.8 Зміни до звітів.',
    '7-8-8-1': `7.8.8.1 Якщо виданий звіт потребує заміни, внесення змін чи перевидання, будь-яка зміна інформації
      повинна бути чітко визначена та, у разі необхідності, причина змін включається до звіту.`,
    '7-8-8-2': `7.8.8.2 Зміни до звіту після випуску повинні подаватися у формі додаткового документа або внесення
      змін до даних, що включає в себе твердження "Зміни до звіту, серійний номер ... [або іншим чином визначений]",
      або еквівалентне формулювання.`,
    '7-8-8-2-1': 'Такі зміни повинні відповідати всім вимогам цього документу.',
    '7-8-8-3': `7.8.8.3 Коли необхідно видати повністю новий звіт, він повинен бути однозначно ідентифікований та
      повинен містити посилання на оригінал, який він замінює.`,
    '7-9': '7.9 Скарги',
    '7-9-1': '7.9.1 Лабораторія повинна мати задокументований процес отримання, розгляду та прийняття рішень щодо скарг.',
    '7-9-2': '7.9.2 Опис виконання процесів стосовно скарг має бути доступним для усіх зацікавлених сторін на їх вимогу.',
    '7-9-2-1': `Після отримання скарги лабораторія повинна підтвердити, що скарга стосується діяльності лабораторії,
      за яку вона несе відповідальність, і, якщо так, має її розглянути.`,
    '7-9-2-2': 'Лабораторія повинна нести відповідальність за всі рішення на усіх рівнях процесу опрацювання скарг.',
    '7-9-3': '7.9.3 Процес опрацювання скарг має включати принаймні наступні елементи та методи:',
    '7-9-3-a': `a) опис процесу отримання, перевірки, розслідування скарги та визначення того, які дії повинні бути
      виконані у відповідь;`,
    '7-9-3-b': 'b) відстеження та реєстрація скарг, включаючи дії, які будуть виконані для їх вирішення;',
    '7-9-3-c': 'c) гарантування, що всі необхідні дії виконані.',
    '7-9-4': `7.9.4 Лабораторія, отримуючи скаргу, повинна нести відповідальність за збір та перевірку всієї
      необхідної інформації для підтвердження обґрунтованості скарги.`,
    '7-9-5': `7.9.5 Коли можливо, лабораторія повинна підтверджувати отримання скарги та надавати скаржнику звіт
      про хід роботи й результати.`,
    '7-9-6': `7.9.6 Рішення, про яке буде повідомлено скаржнику, повинне бути прийнятим або проаналізованим та
      затвердженим особою (особами), не залученими до діяльності лабораторії, яка розглядається.`,
    '7-9-7': '7.9.7 Якщо можливо, лабораторія повинна офіційно повідомити скаржника про завершення опрацювання скарги.',
    '7-10': '7.10 Невідповідна робота',
    '7-10-1': `7.10.1 Лабораторія повинна мати процедуру, яка повинна застосовуватись, коли будь-який аспект її
      лабораторної діяльності або результати цієї роботи не відповідають власним процедурам чи узгодженим вимогам
      замовника (наприклад, обладнання або умови навколишнього середовища не перебувають в рамках встановлених меж,
      результати моніторингу вказують на порушення встановлених критеріїв).`,
    '7-10-1-1': 'Процедура повинна забезпечувати, щоб:',
    '7-10-1-a': 'a) визначалися обов\'язки та повноваження для управління невідповідною роботою;',
    '7-10-1-b': `b) дії (включаючи, коли необхідно, призупинення або повторення роботи та відкликання звітів)
      базувалися на ступенях ризику, встановлених лабораторією;`,
    '7-10-1-c': `c) проводилася оцінка значимості невідповідної роботи, включаючи аналіз впливу щодо
      попередніх результатів;`,
    '7-10-1-d': 'd) приймалося рішення про прийнятність невідповідної роботи;',
    '7-10-1-e': 'e) коли необхідно, замовник був повідомлений і робота відкликалась;',
    '7-10-1-f': 'f) встановлювалась відповідальність за дозвіл на відновлення роботи.',
    '7-10-2': `7.10.2 Лабораторія повинна зберігати записи стосовно невідповідної роботи та дій, зазначених у
      7.10.1 пунктів b) - f).`,
    '7-10-3': `7.10.3 Якщо оцінка вказує на те, що невідповідна робота може повторюватися, або що існують сумніви
      щодо відповідності діяльності лабораторії своїй власній системі управління, лабораторія повинна впроваджувати
      коригувальні дії.`,
    '7-11': '7.11 Управління даними та інформацією',
    '7-11-1': `7.11.1 Лабораторія повинна мати доступ до даних та інформації, необхідних для виконання діяльності
      лабораторією.`,
    '7-11-2': `7.11.2 Система (системи) управління інформацією в лабораторії, що використовується для збору, обробки,
      реєстрації, звітування, зберігання або відновлення даних, повинна бути перевірена на функціональність, включаючи
      правильне функціонування інтерфейсів в рамках системи (систем) управління інформацією з боку лабораторії перед
      запровадженням.`,
    '7-11-2-1': `Кожного разу, коли вносяться будь-які зміни, включаючи конфігурацію програмного забезпечення або
      модифікацію комерційного готового програмного забезпечення лабораторії, вони повинні бути дозволені до
      використання, задокументовані та перевірені перед впровадженням.`,
    '7-11-3': '7.11.3 Система (системи) управління інформацією в лабораторії повинна:',
    '7-11-3-a': 'a) бути захищеною від несанкціонованого доступу;',
    '7-11-3-b': 'b) бути захищеною від втручання та втрат;',
    '7-11-3-c': `c) експлуатуватись в умовах, що відповідають специфікаціям постачальника чи лабораторії, або, у
      випадку некомп\'ютеризованих систем, створювати умови, що забезпечують точність ведення записів та копіювання;`,
    '7-11-3-d': 'd) підтримуватися таким чином, щоб забезпечувати цілісність даних та інформації;',
    '7-11-3-e': 'e) включати запис збоїв в системі та відповідні термінові та коригувальні дії.',
    '7-11-4': `7.11.4 Якщо система управління інформацією в лабораторії управляється та обслуговується зовні або
      через зовнішнього постачальника, лабораторія повинна забезпечити, щоб постачальник, або оператор системи
      відповідали усім застосовним вимогам цього документу.`,
    '7-11-5': `7.11.5 Лабораторія повинна забезпечити, щоб інструкції, настанови та довідкові дані, що стосуються
      системи управління інформацією лабораторії, були доступні для персоналу.`,
    '7-11-6': '7.11.6 Розрахунки та пересилання даних повинні систематично належним чином перевірятися..',
    '8': '8 Вимоги до системи управління',
    '8-1': '8.1 Варіанти',
    '8-1-1': '8.1.1 Загальні положення',
    '8-1-1-1': `Лабораторія повинна встановити, задокументувати, впровадити та підтримувати систему управління,
      яка здатна демонструвати досягнення вимог цього документа та забезпечувати якість результатів лабораторії.`,
    '8-1-1-2': `На додачу до виконання вимог розділів 4-7 лабораторія повинна запровадити систему управління у
      відповідності до варіанту А чи варіанту B.`,
    '8-1-2': '8.1.2 Варіант А',
    '8-1-2-1': 'Як мінімум, система управління лабораторії повинна враховувати наступне:',
    '8-1-2-2': '- документацію системи управління (див. 8.2);',
    '8-1-2-3': '- управління документацією системи управління (див. 8.3);',
    '8-1-2-4': '- управління записами (див. 8.4);',
    '8-1-2-5': '- дії стосовно ризиків та можливостей (див. 8.5);',
    '8-1-2-6': '- вдосконалення (див. 8.6);',
    '8-1-2-7': '- коригувальні дії (див. 8.7);',
    '8-1-2-8': '- внутрішні аудити (див. 8.8);',
    '8-1-2-9': '- аналізування з боку керівництва (див. 8.9).',
    '8-1-3': '8.1.3 Варіант В',
    '8-1-3-1': `Лабораторія, яка впровадила та підтримує систему управління відповідно до вимог стандарту ISO 9001
      та здатна підтримувати і демонструвати послідовне виконання вимог розділів 4-7, та виконувати, як мінімум,
      суть вимог до системи управління, зазначених у пунктах 8.2-8.9.`,
    '8-2': '8.2 Документи системи управління (Варіант А)',
    '8-2-1': `8.2.1 Керівництво лабораторії повинно встановити, задокументувати і підтримувати політики та цілі
      для досягнення завдань цього документа, а також забезпечити визнання і реалізацію політики та цілей на
      усіх рівнях організації лабораторії.`,
    '8-2-2': `8.2.2 Політики та цілі повинні бути направлені на компетентність, неупередженість та послідовну
      діяльність лабораторії.`,
    '8-2-3': `8.2.3 Керівництво лабораторії повинно надавати докази виконання зобов’язань щодо розроблення і
      впровадження системи управління та постійного підвищення її результативності.`,
    '8-2-4': `8.2.4 Уся документація, процеси, системи, записи, пов\'язані з виконанням вимог цього документа,
      повинні бути включені в посилання або бути пов\'язані з системою управління.`,
    '8-2-5': `8.2.5 Увесь персонал, залучений до діяльності лабораторії, повинен мати доступ до тих частин
      документації системи управління та відповідної інформації, яка стосується його обов\'язків.`,
    '8-3': '8.3 Управління документами системи управління (Варіант А)',
    '8-3-1': `8.3.1 Лабораторія  повинна  управляти  документами  (внутрішніми пов’язані із виконанням
      вимог цього документа.`,
    '8-3-2': '8.3.2 Лабораторія повинна забезпечити, щоб:',
    '8-3-2-a': 'a) документи були затверджені на достатність перед виданням уповноваженим персоналом;',
    '8-3-2-b': 'b) документи періодично аналізувалась та актуалізовувалась, в разі необхідності;',
    '8-3-2-c': 'c) зміни та поточний статус перегляду документів були ідентифіковані;',
    '8-3-2-d': `d) дійсні версії застосовуваних документів були доступні в місцях використання та, де необхідно,
      здійснювався контроль їх розподілу;`,
    '8-3-2-e': 'e) документи були однозначно ідентифіковані;',
    '8-3-2-f': `f) були створені умови для запобігання ненавмисному використанню застарілих документів і для них
      застосовувалася відповідна ідентифікація, якщо вони зберігаються з будь-якою метою.`,
    '8-4': '8.4 Управління записами (Варіант А)',
    '8-4-1': `8.4.1 Лабораторія повинна встановити і зберігати розбірливі записи для демонстрування виконання
      вимог цього документа.`,
    '8-4-2': `8.4.2 Лабораторія повинна запровадити засоби контролю, необхідні для ідентифікації, зберігання,
      захисту, резервного копіювання, архівування, відновлення, дотримання часу зберігання та утилізації своїх записів.`,
    '8-4-2-1': 'Лабораторія повинна зберігати записи протягом часу, який відповідає її договірним зобов\'язанням.',
    '8-4-2-2': `Доступ до цих записів повинен відповідати зобов\'язанням щодо конфіденційності, а записи повинні
      бути доступними.`,
    '8-5': '8.5 Дії щодо ризиків та можливостей (Варіант А)',
    '8-5-1': `8.5.1 Лабораторія повинна приймати до уваги ризики та можливості, пов\'язані з діяльністю
      лабораторії, для того, щоб:`,
    '8-5-1-a': 'a) бути впевненою, що система управління здатна досягти своїх запланованих результатів;',
    '8-5-1-b': 'b) розширювати можливості для досягнення мети та цілей лабораторії;',
    '8-5-1-c': 'c) попереджувати або зменшувати небажані наслідки та можливий збій в діяльності лабораторії;',
    '8-5-1-d': 'd) досягти вдосконалення.',
    '8-5-2': '8.5.2 Лабораторія повинна планувати:',
    '8-5-2-a': 'a) дії щодо ризиків та можливостей;',
    '8-5-2-b': 'b) яким чином:',
    '8-5-2-b-1': '- включити та впровадити ці дії у свою систему управління;',
    '8-5-2-b-2': '- оцінювати результативність цих дій.',
    '8-5-3': `8.5.3 Дії щодо ризиків та можливостей повинні бути пропорційними потенційному впливу на
      достовірність результатів лабораторії.`,
    '8-6': '8.6 Вдосконалення (Варіант А)',
    '8-6-1': `8.6.1 Лабораторія повинна ідентифікувати та вибирати можливості для вдосконалення та
      здійснення будь-яких необхідних дій.`,
    '8-6-2': '8.6.2 Лабораторія повинна підтримувати зворотній зв’язок із замовниками, як позитивний, так і негативний.',
    '8-6-2-1': `Дані зворотнього зв\'язку повинні бути проаналізовані та використовуватися для вдосконалення системи
      управління, діяльності лабораторії та обслуговування замовників.`,
    '8-7': '8.7 Коригувальні дії (Варіант А)',
    '8-7-1': '8.7.1 Коли виникає невідповідність, лабораторія повинна:',
    '8-7-1-a': 'a) реагувати на невідповідність і, якщо застосовно:',
    '8-7-1-a-1': '- здійснювати дії для її контролювання та коригування;',
    '8-7-1-a-2': '- приймати до уваги наслідки;',
    '8-7-1-b': `b) оцінювати необхідність дій з усунення причини (причин) невідповідності з тим, щоб
      унеможливити її повторну появу шляхом:`,
    '8-7-1-b-1': '- розгляду та аналізування невідповідності;',
    '8-7-1-b-2': '- визначення причин невідповідності;',
    '8-7-1-b-3': '- визначення, чи існують або потенційно можливі подібні невідповідності;',
    '8-7-1-c': 'c) впровадити необхідні дії;',
    '8-7-1-d': 'd) проаналізувати результативність будь-яких впроваджених коригувальних дій;',
    '8-7-1-e': 'e) оновлювати інформацію щодо ризиків та можливостей, визначених під час планування, якщо необхідно;',
    '8-7-1-f': 'f) вносити зміни до системи управління, у разі необхідності.',
    '8-7-2': '8.7.2 Коригувальні дії повинні бути пропорційні наслідкам, що виникають через невідповідності.',
    '8-7-3': '8.7.3 Лабораторія повинна зберігати записи, як докази:',
    '8-7-3-a': 'a) характеру невідповідностей, причин (-и) та будь-яких наступних вжитих дій;',
    '8-7-3-b': 'b) результатів будь-якої коригувальної дії.',
    '8-8': '8.8 Внутрішні аудити (Варіант А)',
    '8-8-1': `8.8.1 Лабораторія повинна проводити внутрішні аудити через заплановані інтервали часу для отримання
      інформації про те, чи система управління:`,
    '8-8-1-a': 'a) відповідає:',
    '8-8-1-a-1': '- власним вимогам лабораторії до своєї системи управління, включаючи діяльність лабораторії;',
    '8-8-1-a-2': '- вимогам цього документу;',
    '8-8-1-b': 'b) результативно впроваджена та підтримується.',
    '8-8-2': '8.8.2 Лабораторія повинна:',
    '8-8-2-a': `a) планувати, розробляти, впроваджувати та підтримувати програму аудиту, включаючи частоту, методи,
      відповідальності, планування вимог та звітування, які повинні враховувати важливість відповідної діяльності
      лабораторії, зміни, що впливають на лабораторію, та результати попередніх аудитів;`,
    '8-8-2-b': 'b) визначити критерії аудиту та сферу кожного аудиту;',
    '8-8-2-c': 'c) забезпечити, щоб результати аудитів були повідомлені відповідному керівництву;',
    '8-8-2-d': 'd) здійснювати відповідні коригування та коригувальні дії без зайвої затримки;',
    '8-8-2-e': 'e) зберігати записи, як докази впровадження програми аудиту та результатів аудиту.',
    '8-9': '8.9 Аналізування з боку керівництва (Варіант А)',
    '8-9-1': `8.9.1 Керівництво лабораторії повинно аналізувати систему управління через заплановані інтервали часу
      'з тим, щоб забезпечити її постійну придатність, відповідність та результативність, включаючи заявлені
      політики та цілі, пов\'язані з виконанням цього документа.`,
    '8-9-2': `8.9.2 Вхідні дані для аналізування з боку керівництва повинні реєструватися та включати інформацію,
      що стосується наступного:`,
    '8-9-2-a': 'a) змін у внутрішніх та зовнішніх чинниках, які мають вплив на лабораторію;',
    '8-9-2-b': 'b) досягнення цілей;',
    '8-9-2-c': 'c) придатності політик та процедур;',
    '8-9-2-d': 'd) статусу виконання дій щодо попередніх аналізувань з боку керівництва;',
    '8-9-2-e': 'e) результатів нещодавніх внутрішніх аудитів;',
    '8-9-2-f': 'f) коригувальних дій;',
    '8-9-2-g': 'g) оцінок з боку зовнішніх органів;',
    '8-9-2-h': 'h) змін в об’ємах та видах робіт або в області діяльності лабораторії;',
    '8-9-2-i': 'i) зворотного зв’язку від замовника та персоналу;',
    '8-9-2-j': 'j) скарг;',
    '8-9-2-k': 'k) результативності будь-яких впроваджених вдосконалень;',
    '8-9-2-l': 'l) достатності ресурсів;',
    '8-9-2-m': 'm) результатів ідентифікації ризиків;',
    '8-9-2-n': 'n) результатів забезпечення достовірності результатів; та',
    '8-9-2-o': 'o) інших відповідних факторів, таких як моніторинг діяльності та навчання.',
    '8-9-3': `8.9.3 Вихідні дані аналізування з боку керівництва повинні відображати всі рішення та дії,
      що стосуються щонайменше:`,
    '8-9-3-a': 'a) результативності системи управління та її процесів;',
    '8-9-3-b': 'b) вдосконалення діяльності лабораторії, пов\'язаної з виконанням вимог цього документа;',
    '8-9-3-c': 'c) надання необхідних ресурсів;',
    '8-9-3-d': 'd) будь-якої потреби у змінах.'
  },

  evaluationTest: {
    evaluationTestTitle: 'Дані про оцінку методів ВЛ Ф-08.17.33',
    testMethodName: 'Назва методу випробування',
    testMethodTitle: 'Дані про оцінювання методу випробування',
    evaluationData: 'Дані оцінювання',
    methodName: 'Позначення та назва методу випробування відповідно до сфери акредитації',
    testName: 'Назва випробувань та (або) характеристик (параметрів), що визначаються відповідно до сфери акредитації',
    productObjectName: 'Назва об\'єкта (продукції, матеріалу, речовини і т.п.) відповідно до сфери акредитації',
    standardOrDeveloped: 'Стандартизований (офіційний) метод чи розроблений ВЛ',
    workingInstructions: 'Робоча інструкція по виконанню (за наявності, позначення, назва, дата затвердження)',
    standardized: 'Стандартизований',
    developed: 'Розроблений ВЛ',
    executor: `Виконавець (ці) випробування (посада, П.І.Б., уповноваження, дата). Мінімальний термін проведення
      випробовування (людино/година)`,
    usedEquipmentForTesting: `Устатковання, що застосовується для випробувань (назва, тип, номер; основні
      метрологічні характеристики, докази простежуваності: номер, дата свідоцтва про калібрування,
      назва компетентної організації чи лабораторії, що проводила калібрування)`,
    testLocation: 'Місце проведення випробування',
    methodsDataForEnsuring: `Способи та дані щодо забезпечення якості випробувань відповідно до плану
      (документовані докази – №, дата протоколу, звіту)`,
    participationInterlaboratoryComparisons: `Участь у міжлабораторних порівняннях або схемах (програмах)
      перевірки професійного рівня (провайдер*, назва схеми (програми)*, рік, дані про контрольний зразок,
      висновки відповідно до форми 11 Паспорту ВЛ). * У разі відсутності провайдера (схеми (програми)) назви
      усіх учасників`,
    methodVerificationData: `Дані верифікації методу (для  стандартизованих (офіційних) методів – посилання на звіт
      про верифікацію) або дані валідації методу (для нестандартизованих, модифікованих або розроблених  методів –
      (посилання на звіт про валідацію)`,
    addSection: 'Додати дільницю',
    numberSection: 'Номер дільниці',
    numberSectionTitle: 'Дільниця № {number}',
    addressSection: 'Адреса дільниці',
    successAddedNewSection: 'Дільницю додано'
  },

  documentsList: {
    documentsListTitle: 'Перелік документів Ф-08.17.03',
    documentsListSubtitle: `що додаються до заявки на акредитацію випробувальної лабораторії на відповідність
      вимогам ДСТУ EN ISO/IEC 17025:2019`,
    documentsListSubtitleExpansion: `що додаються до заявки на розширення сфери акредитації випробувальної лабораторії
      (ВЛ) на відповідність вимогам ДСТУ EN ISO/IEC 17025:2019`,
    availability: 'Наявність',
    note: 'Примітка',
    statement: 'Заявка на акредитацію Ф-08.00.02',
    statementExpansion: 'Заявка на розширення сфери (Ф 08.00.02)',
    legalEntity: `Належним чином засвідчена копія Статуту юридичної особи або іншого правовстановлюючого документу
      (прошита, пронумерована та скріплена печаткою, якщо відсутня печатка  - підписи засвідчуються нотаріально)`,
    regulationsLaboratory: 'Положення про лабораторію',
    unifiedStateRegister: `Належним чином засвідчена копія Витягу з Єдиного державного реєстру, до якого повинні бути
      внесені, зокрема такі відомості: повне та скорочене найменування юридичної особи, місцезнаходження юридичної
      особи, види діяльності, відомості про державну реєстрацію, дані про перебування юридичної особи в процесі
      провадження у справі про банкрутство, дані про юридичних осіб, правонаступником яких є зареєстрована юридична
      особа, дані про юридичних осіб-правонаступників: повне найменування та місцезнаходження юридичних
      осіб-правонаступників, їх ідентифікаційні коди, тощо`,
    taxpayer: `Належним чином засвідчена копія Свідоцтва про реєстрацію платника податку на додану вартість або
      'Витягу з Реєстру платників податку на додану вартість`,
    survey: 'Опитувальна анкета (Ф-08.17.15)',
    passport: 'Паспорт ВЛ (Ф-08.17.19)',
    passportExpansion: 'Паспорт ВЛ (Ф-08.17.19), доповнені або змінені форми',
    scopeAccreditation: `Належним чином оформлений проект "Сфери акредитації" (Ф-08.17.17) (прошитий, пронумерований,
      засвідчений підписом заявника, датою та печаткою заявника)`,
    scopeAccreditationExpansion: `Належним чином оформлений проект "Сфери акредитації" (Ф-08.17.17), який містить
      тільки сферу для розширення діяльності ВЛ (прошитий, пронумерований, засвідчений підписом заявника,
      датою та печаткою заявника)`,
    managementSystemDocumentation: `Документація системи управління відповідно до ДСТУ EN ISO/IEC 17025:2019
      (перелік документації, повний комплект процедур та інші).`,
    locationInfo: 'Дані про місцезнаходження приміщень заявника у місті (план/виписка/копія плану міста)',
    spacePlan: 'План приміщень ВЛ та суміжних приміщень з розташуванням обладнання',
    spacePlanExpansion: '(стосовно розширення сфери)',
    copiesDiplomas: `Копії дипломів або інших документів, що підтверджують кваліфікацію персоналу відповідно до
      Форми 6 Паспорту випробувальної лабораторії`,
    copiesDiplomasExpansion: `Копії документів, що підтверджують кваліфікацію персоналу, що залучається для
      проведення випробувань за методами, наведеними в сфері для розширення діяльності ВЛ`,
    newEquipmentExpansion: `Копії документів, що підтверджують факт придбання нового обладнання та ЗВТ,
      їх калібрування (за необхідністю)`,
    copiesOriginalProtocol: `Копії оригіналів протоколів випробувань або актів відбирання зразків за кожним
      з напрямків діяльності`,
    copiesOriginalProtocolExpansion: `Копії оригіналів протоколів випробувань за кожним з напрямків
      діяльності для розширення`,
    questionnaire: 'Опитувальний лист (Ф-08.17.20)',
    evaluation: 'Дані про оцінку методів випробування (Ф-08.17.33)',
    iAgree: 'Я ознайомився і підтверджую надану мною інформацію та надаю згоду',
    dataProcessingAgreement: 'На обробку персональних даних'
  },

  accreditationType: {
    type1: 'ДСТУ EN ISO/IEC 17025 (ВЛ)',
    type2: 'ДСТУ EN ISO/IEC 17065',
    type3: 'ДСТУ EN ISO/IEC 17025 (КЛ)',
    type4: 'ДСТУ EN ISO/IEC 17021-1',
    type5: 'ДСТУ EN ISO 15189',
    type6: 'ДСТУ EN ISO/IEC 17020',
    type7: 'ДСТУ EN ISO/IEC 17043',
    type8: 'ДСТУ EN ISO/IEC 17024',
    type9: 'ДСТУ ISO 14065'
  },
  authQR: 'Авторизація за домогою QR коду',
  authLogin: 'Авторизація за домогою логіну та пароля',
  qrGuide: {
    openAuthPage: 'Відкрийте сторінку авторизації',
    chooseAuthByQR: 'Оберіть тип авторизації по QR коду',
    takePermissionCamera: 'Підтвердіть доступ застосунку до камери',
    scanQR: 'Відскануйте QR код'
  },
  attentionKeyNotExist: 'Увага! Ключ підпису не знайдено. Завантажте на сторінці',
  cameraErrors: {
    NotAllowedError: 'Додатку заборонено доступ до камери',
    NotFoundError: 'Камера не знайдена',
    NotReadableError: 'Можливо, камера вже використовується',
    OverconstrainedError: 'Ви запросили фронтальну камеру, хоча її немає?',
    StreamApiNotSupportedError: 'Браузер не підтримує використання камері',
    qrInvalid: 'QR код не валідний, або срок дії закінчився'
  },
  measurementGasStage: {
    0: 'Прогрівання двигуна на обертах від 2000 до 2400 об/хв',
    1: 'Вимірювання на обертах від 700 до 900 об/хв',
    2: 'Вимірювання на обертах від 2000 до 2400 об/хв'
  },
  crankShaftSpeed: 'Частота обертання колінчатого валу',
  regime: 'Режим',
  inFact: 'Фактичне',
  resultMeasurement: 'Результати вимірювання вмісту',
  carboneMonoxide: 'Оксиду вуглецю',
  hydrocarbons: 'Вуглеводнів, млн.',
  hydrocarbonsNumbersOfCylinders: 'Вуглеводнів, млн. -1, для двигунів з числом циліндрів',
  maximumContent: 'Гранично допустимий вміст',
  upTo4: 'До 4 включно',
  moreThen4: 'Білше ніж 4',
  windshield: 'Вітрове скло',
  sample1: 'Замір 1',
  sample2: 'Замір 2',
  sample3: 'Замір 3',
  sample: 'Замір',
  avg: 'Середнє значення',
  minValue: 'Мінімальне значення',
  backWindow: 'Заднє скло',
  sideWindows1: 'Перші бокові стекла',
  sideWindows2: 'Другі бокові стекла',
  sideWindows3: 'Треті бокові стекла',
  sideWindows4: 'Четверті бокові стекла',
  sideWindows5: 'П`яті бокові стекла',
  sideWindows6: 'Шості бокові стекла',
  leftWindow: 'Ліве',
  rightWindow: 'Праве',
  pressure: 'Тиск',
  pressureHint: 'Тиск від 1 до 10 МПа',
  pressureError: 'У усіх коліс на одній осі має бути однаковий тиск',
  errorAmountTires: 'Не вся задана кількість коліс була розподілена по вісях',
  axis: 'Вісь',
  seatBelt: 'Ремінь безпеки',
  seatPosition: 'Тип сидіння до якого приналежить ремінь безпеки',
  beltCategory: 'Категорія ременя безпеки',
  seatBelts: 'Ремені безпеки',
  fulfillmentSpecialRequirements: 'Виконання спеціальних вимог',
  fillFormSeatBelts: 'Заповнити форму на основі першого ременя',
  notAppropriateValue: 'Не відповідне значення',
  errorAmountSeatBelts: 'Не вся кількість ременів була задана',
  addCertainAmountSeatBelts: 'Додати певну кількість однакових ременів',
  numberIdenticalBelts: 'Кількість однакових ременів які будуть додані ',
  doorLocation: 'Розташування дверей',
  axisWeight: 'Вага вісі',
  specificForce: 'Питома гальмівна сила',
  minSpecificForce: 'Питома гальмівна сила не менше {0}',
  triggeringTime: 'Час спрацьовування',
  irrgularityCoeff: 'Коеффіцієнт нерівномірності',
  hintIrrgularityCoeff: 'Коеффіцієнт нерівномірності не більше {0}',
  ovalityCoeffLeft: 'Коефіцієнт овальності ліве',
  ovalityCoeffRight: 'Коефіцієнт овальності праве',
  controlBrakeForce: 'Зусилля на органі керування',
  hintControlBrakeForce: 'Зусилля на органі керування не більше {0}',
  axisRGS: 'Вісь РГС',
  axisSGS: 'Вісь СГС',
  measurementMode: 'Режим вимірювань',
  maxValue: 'Максимальне значення',
  flashingFrequencyTurnSignal: 'Частота миготіння поворотника',
  setDecision: 'Виставити рішення',
  Yes: 'Так',
  No: 'Ні',
  'Not answered': 'Без відповіді',
  'Not use for this vehicle': 'Цей припис не стосується конструкції даного КТЗ',
  answer: 'Відповідь',
  allCompliance: 'Все відповідає вимогам',
  notAllCompliance: 'Не все відповідає вимогам',
  email: 'Електронна адреса',
  phone: 'Номер телефону',
  phonePrefix: '+380',
  phoneMaskPlaceholder: '(__) ___ __ __',
  phoneCodeCountry: 'Код країни',
  phoneHint: 'Приклад',
  setAllCompliance: 'Заповніть усі відповідності',
  downloadCompliance: 'Зачекайте завершення генерації відповідностей',
  errorDownloadCompliance: `Сталася помилка під час генерації відповідностей.
    Спробуйте повернутись до заявки через деякий час, або перезавантажте сторінку`,
  inspectionAxis: 'Огляд осей',
  inspectionSeatBelt: 'Огляд ременів безпеки',
  attachmentPointsSeatBelt: 'Кількість точок кріплення',
  inspectionWindows: 'Огляд вікон',
  inspectionHeadlights: 'Огляд фар',
  inspectionAxesGroup: 'Огляд груп осей',
  axesByGroup: 'Осі по групам',
  setCountAxesInGroup: 'Вкажіть к-сть осей в групі',
  notUseAxis: 'Невибрані осі',
  group: 'група',
  numberGroupsGreaterThanNumberAxesError:
    'Кількість груп осей не може бути більше за {countAxes}. Так як загальна кількість осей - {countAxes}',
  sumNumberAxesCannotBeGreaterThanNumberAxes:
    'Сума кількості осей не може бути більше за {countAxes}. Так як загальна кількість осей - {countAxes}',
  sumNumberAxesTooSmall: 'Не всі осі задіяні. Розподіліть всі {countAxes} осі по групам',
  generalNumberAxesInfo: 'Всього { countAxes } осей. Розподіл осей по групам',
  groupAxes: 'група осей',
  groupsAxes: 'Групи осей',
  groupAxesCount: 'Кількість груп осей',
  numberAxesInGroup: 'Номер осей в групі',

  deleteAxis: 'Видалити вісь',
  addedMaxTires: 'Максимальна кількість колес додана',
  marking: 'Маркування',
  marking2: 'Маркування друге',
  isMarkingDuplicate: 'Маркування відрізняється',
  addMarking: 'Додати маркування',
  deleteWindow: 'Видалити вікно',
  deleteSeatBelt: 'Видалити ремінь',
  firstSetAxlesAndTires: 'Спочатку треба додати вісі і колеса',
  firstSetAxis: 'Спочатку треба додати вісі',
  countAxesInGroup: 'Кількість осей в групі',
  countAxesGroups: 'Кількість груп осей',
  firstSetSeatBelts: 'Спочатку треба додати кількість місць для сидіння',
  uploadedFiles: 'Завантажено {numberFiles} файл(ів)',
  tireTreadHeight: 'Висота малюнку протектора шини',
  minMireTreadHeight: 'Мінімальна висота малюнку протектора шини {value}',
  statementInfo: 'Інформація по заяві',
  formEnter: 'Заповнено',
  formNotEnter: 'Не заповнено',
  randomMeasurementMode: 'Вимірювання у режимі довільних прискорень',
  smokeInFreeAcceleration: 'Проведення вимірювання димності в режимі вільних прискорень',
  numberMeasurement: 'Номер вимірювання',
  resultSmoke: 'Результати вимірювання показників димності',
  borderNaturalAmount: 'Гранично допустиме значення натурального показника поглинання',
  borderNaturalUpAmount: 'Гранично допустиме значення з урахуванням збільшення або зменшення Кдоп, м',
  forDSTU4276: 'відповідно до 5.2.7.1-5.2.7.2 ДСТУ 4276',
  distanceToNextAxis: 'Відстань до наступної осі',
  setSignInspection: 'Підписати протокол огляду',
  setSignDecision: 'Підписати рішення щодо видачі сертифікату',
  addCertificateNumber: {
    title: 'Призначне номер сертифікату',
    inputLabel: 'Вкажіть номер Сертифікату'
  },
  addInspectionProtocolNumber: {
    title: 'Призначте номер Протоколу огляду КТЗ',
    inputLabel: 'Вкажіть номер Протоколу огляду КТЗ'
  },
  addNoteForTypeCertificate: 'Залишити примітку до сертифікату',
  addNote: 'Залишити примітку',
  setSignCertificate: 'Підписати сертифікат та додаток до нього',
  awaitingSigningAuditorOOV: 'Очікує підписання Аудитором ООВ',
  certificateInfo: 'Інформація по сертифікату',
  gasType: 'Тип газу',
  distanceBetweenBalloonAndRoad: 'Дистанція між балоном та дорогою',
  selectionOfPollutantEmissionNorms: ' Вибір норм по викидам забруднювальних речовин',
  clientInfo: 'Інформація про клієнта',
  startStandAutomatically: 'Автоматичне вимірювання',
  signOut: 'Вийти',
  engineDesign: 'Наддув двигуна',
  engineWithoutSupercharging: 'Двигун без наддуву',
  superchargedEngine: 'Двигун з наддувом',
  parkingBrakeSystem: 'СГС (Стоянкова гальмівна система)',
  staticMassSGS: 'Вага СГС',
  value: 'Значення',
  legalEntity: 'Інформація про юридичну особу',
  trustedPerson: 'Оформлення за довіреністю',
  organizationalForm: 'Організаційна форма',
  legalAddress: 'Юридична адреса',
  EDRPOUcode: 'Код ЄДРПОУ',
  confidant: 'Довірена особа',
  ecologicalStandard: 'Екологічний стандарт',
  legalActForEuroRate: 'Нормативні акти для норми забруднюючих речовин',
  transportDangerousGood: 'Технічні приписи стосовно перевезення небезпечних вантажів',
  scannedCopyPowerAttorney: 'Скан копія довіреності',
  documentIdentityTrustee: 'Документ який підтверджує Довірену особу',
  infoTrustee: 'Інформація про довірену особу',
  passportType: 'Документ, що засвідчує особу',
  startCalibrating: 'Почато калібрування',
  identityDocument: 'Документ що посвідчує особу',
  educationDocument: 'Диплом про вищу освіту',
  raisingQualificationDocument: 'Документ підвищення кваліфікації',
  weatherTemperature: 'Температура',
  weatherPressure: 'Атмосферний тиск',
  weatherHumidity: 'Вологість',
  weatherWindSpeed: 'Швидкість вітру',
  laboratoryTemperature: 'Температура повітря усередені приміщення лабораторії',
  relativeHumidity: 'Відносна вологість повітря усередені приміщення лабораторії',
  typeWorkingBrakingSystem: 'Тип робочої гальмівної системи',
  antiBlockingSystem: 'Наявність Антиблокувальної системи (ABS)',
  inertiaBrakingSystem: 'Інерційна гальмівна система',
  RGSActivatedWithoutTheForceOfTheDriver: 'РГС спрацьовує без силового впливу водія',
  controlBrakeForceType: 'Тип зусилля на органі керування',
  presenceBrakeSystem: 'Цей КТЗ обладнано гальмівною системою?',
  warningWeatherConditions: 'Погодні умови не відповідають методології проведення вимірюваннь!',
  warningWeatherConditionsForResultMeasurement: `Під час проведення випробування погодні умови не відповідали
    методології проведення вимірюваннь!`,
  warningWeatherTemperature: `Для випробувань температура повітря на відкритому майданчику має бути в межах від 5 °C до 40 °C.<br />
    Поточна температура {0} °C`,
  warningWeatherWindSpeed: `Швидкість вітру з урахуванням поривів не повинна перевищувати 5 м/с.<br />
    Поточна швидкість {0} м/с`,
  employees: 'Співробітники',
  createAccount: {
    verificationTitle: 'Введіть особисті дані',
    title: 'Реєстрація облікового запису',
    subTitle: 'Оберіть що Ви хочете зареєструвати',
    updateAccount: 'Оновлення інформації облікового запису',
    accountToModeration: 'Обліковий запис на модерації',
    noAddedSignature: 'Додайте підпис або печатку',
    signatureRemoved: 'Підпис або печатку видалено',
    selectButtonOC: 'Орган Сертифікації (ОС)',
    selectButtonVL: 'Випробувальна лабораторія (ВЛ)',
    accountHasBeenUpdated: 'Обліковий запис успішно оновлено',
    errorStatisticDate: 'Кінцева дата повинна перевищувати попередню',
    certificatePrefixInformation: 'UA.',
    landlinePhone: 'Номер телефону стаціонарний',
    landlinePhonePlaceholder: '+38044 735 31 20',
    linkToWebResource: 'Посилання на веб-ресурс',
    auditor: {
      registrationСertificationBodyOC: 'Реєстрація "Органу сертификації (ОС)"',
      updateCertificationBodyOC: 'Оновлення інформації "Органу сертификації"',
      updatedCertificationBodyOC: 'Орган сертификації успішно оновлено',
      employeesСertificationBodyOC: 'Співробітники "Органу сертификації (ОС)"',
      informationAboutTheOrganization: 'Інформація про "Орган сертификації (ОС)"',
      сooperation: 'Співробітництво',
      nameOrganization: 'Назва організації',
      fullNameOrganization: 'Повна назва організації',
      shortFormOfTheNameOrganization: 'Скорочена назва організації',
      branchAddress: 'Адреса представництва',
      accreditationCertificateNumber: 'Номер атестату акредитації НААУ',
      MIUOrderNumber: 'Номер наказу яким уповноважено ООВ(Орган з сертифікації)',
      dateOfIssueMIUOrder: 'Дата реєстрації Наказу яким уповноважено ООВ(Орган з сертифікації)',
      dateRegistrationAccreditationCertificate: 'Дата реєстрації атестату акредитації',
      expirationDateForAccreditation: 'Термін закінчення дії акредитації',
      prefixInformation: 'Номер призначений ООВ (Органу з сертифікації) або згідно нотифікації ЄК ООН',
      notFilledToRequirements: 'Не всі пункти опитувального листа заповнені відповідно до вимоги при реєстрації ООВ',
      accountingOfBranches: 'Облік представництв',
      addBranch: 'Додати представництво',
      deleteBranch: 'Видалити представництво',
      updateBranch: 'Оновити представництво',
      branch: 'Представництво',
      responsiblePerson: 'ПІБ відповідальної особи',
      addEmployees: 'Додайте співробітників',
      addEmployee: 'Додати співробітника',
      role: 'Роль',
      employeeSuccessfullyAdded: 'Співробітника успішно додано',
      employeeUpdated: 'Співробітника успішно оновлено',
      errorEmployeeUpdated: 'Помилка оновлення інформації співробітника',
      employeeSuccessfullySaved: 'Співробітника успішно збережено',
      employeeError: 'Виникла помилка. Перевірте введені дані і спробуйте ще раз',
      employeeSuccessfullyDeleted: 'Співробітник успішно деактивований',
      employeeSuccessfullyRestore: 'Співробітник успішно активований',
      employeeHasBeenRemoved: 'Співробітник успішно видалений',
      laboratorySuccessfullyAdded: 'Лабораторію успішно додано',
      laboratoryUpdated: 'Лабораторію успішно оновлено',
      informationAboutTheLaboratory: 'Інформація про лабораторію',
      contractStartDate: 'Дата укладання договору про співпрацю',
      contractEndDate: 'Дата закінчення договору про співпрацю',
      contractList: 'Список договір',
      workersList: 'Список співробітників',
      contract: 'Співпраця з ВЛ',
      laboratories: 'Лабораторії',
      branchOffices: 'Дільниці',
      representation: 'Представництва',
      branchOfficesList: 'Список представництв',
      updateBranchOffices: 'Представництво сертифікаційного агентства успішно оновлена',
      successAddBranchOffices: 'Представництво сертифікаційного агентства успішно додано',
      successRemovedBranchOffices: 'Представництво сертифікаційного агентства видалено',
      documents: 'Документи',
      employeePosition: 'Посада',
      statistics: 'Статистика',
      statmentsTransferredToWork: 'Передано заявок на роботу',
      statmentsInProgress: 'Заявок в роботі',
      statmentsCompleted: 'Виконано заявок',
      filterBetweenDates: 'Фільтрувати між датами',
      toListEmployees: 'До списку співробітників',
      mainInfo: 'Головна інформація',
      isLegalEntity: 'Ви є юридичною особою - резидентом України незалежно від форми власності?',
      youAreAccreditedByLaw: `Ви акредитовані як орган з оцінки відповідності згідно із законодавством,
        а сфера його акредитації охоплює види продукції та документи, на відповідність яким проводиться
        оцінювання відповідності щодо індивідуального затвердження колісних транспортних засобів,
        партій частин та обладнання, стосовно яких ви заявляєте про свою компетентність?`,
      listVehicleCategory: 'Категорії КТЗ',
      doYouHaveEmployees: `Чи маєте ви не менш як двох працівників, які працюють на підприємстві, в установі,
        організації за трудовим договором на постійній основі, з відповідною профільною освітою та досвідом роботи
        у сфері оцінки відповідності колісних транспортних засобів не менш як один рік?`,
      reprocessingEmployees: 'Доопрацювання співробітників',
      employeePositionHeld: 'Займана посада в органі з оцінки відповідності',
      position: 'Посада',
      informationAboutEducation: 'Інформація про освіту',
      documentOfHigherEducation: 'Документ, що підтверждує здобуття вищої освіти (серія, номер)',
      dateOfIssueDiploma: 'Дата видачі документу, що підтверджує здобуття вищої освіти',
      nameEducationalInstitution: 'Найменування навчального закладу',
      specialtyInEducation: 'Спеціальність та кваліфікація',
      informationOnProfessionalDevelopment: 'Інформація про підвищення кваліфікації',
      fieldOfIncreaseQualification: 'Напрям підвищення кваліфікації',
      qualificationVerificationDocument: 'Документ, отриманий за результатами підвищення кваліфікації (серія, номер)',
      dateIssueQualificationVerificationDocument:
        'Дата видачі документу, отриманого за результатами підвищення кваліфікації',
      workExperience: 'Досвід виконання робіт з оцінки відповідності продукції, років',
      questionsAndDocuments: 'Питання та документи',
      doYouHaveLabs: `Чи маєте ви власні акредитовані випробувальні лабораторії для проведення
        випробувань колісних транспортних засобів в обсягах, передбачених законодавством для індивідуального
        затвердження колісних транспортних засобів, що були у користуванні, партій частин та обладнання,
        стосовно яких він заявляє про свою компетентність і які охоплені сферою акредитації органу з оцінки
        відповідності, та укладені договори із сторонніми акредитованими випробувальними лабораторіями для
        проведення видів випробувань продукції в межах відповідної сфери призначення,
        які не проводяться його власними лабораторіями?`,
      threeYearsOfWorkExperience: `Чи маєте ви досвід виконання робіт з оцінки відповідності продукції
        протягом трьох останніх років?`,
      dependenceOnTheCustomer: 'Чи не залежите ви від замовника робіт з оцінки відповідності?',
      insuranceContract: `Чи маєте ви страховий фонд або укладений договір страхування відповідальності
        перед третіми особами на час провадження діяльності призначеного органу із сертифікації колісних
        транспортних засобів?`,
      insurance: 'Страхування',
      typeInsurance: 'Тип страхування',
      sumInsuranceFund: 'Сума страхового фонду (грн)',
      addBankWithdrawal: 'Завантажте витяг з банку',
      addInsuranceContract: 'Завантажте договір страхування',
      insuranceContractNumber: '№ договору страхування відповідності',
      finalTermOfTheContract: 'Кінцевий строк дії договору',
      informationConfidentialityRequirements: `Чи підтверджуєте ви дотримання вимог щодо конфіденційності інформації, одержаної під час виконання своїх завдань, крім її надання у визначених законом випадках відповідним уповноваженим органам?`,
      doYouHaveAViolation: `Протягом трьох останніх років ви допускали порушення, які призводили до неправомірної видачі сертифікатів відповідності?`,
      atLeastTwoEmployees: `Вкажіть усіх чинних співробітників відповідно до Сфери акредитації,
        повинно бути не менше двох співробітників.`,
      uploadDocument: 'Завантажте документ',
      toRegistration: 'Зареєструватись',
      statementEmployeeStatus: 'Цей співробітник потребує облікового запису з доступом до програмного забезпечення?',
      employeeStatuses: {
        needInSystem: 'Створити обліковий запис',
        notNeedInSystem: 'Не створювати обліковий запис',
        createdInSystem: 'Створен в системі'
      },
      toListBranchOffices: 'До списку представництв',
      deleteBranchOffice: 'Ви дійсно бажаєте видалити представництво?',
      wantToDeleteAnEmployee: 'Ви дійсно бажаєте видалити співробітника?',
      wantToDeactivateAnEmployee: 'Ви дійсно бажаєте деактивувати співробітника?',
      wantToActivateAnEmployee: 'Ви дійсно бажаєте активувати співробітника?',
      employeeIsDeactivated: 'Співробітника деактивовано',
      employeeIsActivated: 'Співробітника активовано',
      deactivationAndActivation: 'Деактивація / Активація',
      addCooperationAgreement: 'Додати договiр на спiвробiтництво',
      wantToDeleteSignature: 'Ви дійсно бажаєте видалити підпис або печатку?',
      wantToDeleteEquipmentSet: 'Ви дійсно бажаєте видалити комплект обладнання - Лінія {lineNumber}?',
      phoneNumbers: 'Номери телефонів',
      updateInfoDocuments: 'Оновити інформацію',
      workers: {
        title: 'Співробітники',
        systemic: 'Системні',
        outOfSystem: 'Не системні',
        listNonSystemWorkers: 'Список не системних співробітників',
        listSystemWorkers: 'Список системних співробітників'
      }
    },
    vl: {
      stepperCreateVL: 'Створити ВЛ',
      stepperCreateBranch: 'Додати дільницю',
      stepperCreateContract: 'Додати договір з ОС',
      optional: 'Не обов\'язково',

      createVLTitle: 'Орган з оцінки відповідності (Випробувальна лабораторія)',

      vlName: 'Повна назва ВЛ',
      vlShortName: 'Скорочена назва ВЛ',
      EDRPOUcode: 'Код ЄДРПОУ',
      accreditationCertificateNumber: 'Номер атестату акредитації НААУ',
      expirationDateForAccreditation: 'Термін закінчення дії акредитації',

      createBranchTitle: 'Дільниці випробувальної лабораторії',
      addBranch: 'Додати дільницю',
      branchDeleted: 'Філія випробувальної лабораторії видалена',
      branchNumber: 'Номер дільниці',
      branchAddress: 'Адреса дільниці',
      branchCountLine: 'Кількість комплексів обладнання',
      branchCountLineHint: 'Не більше 20',
      branchCategories: 'Категорії КТЗ',
      numberMTI: 'Номер суб\'єкта ОТК',

      contractMenu: 'Співпраця з ОС',
      contractTitle: 'Співпраця з Органом з оцінки відповідності (Орган сертифікації)',
      contractFormTitle: 'Додати договір про співпрацю з ОС',
      organizationName: 'Назва організації',
      legalAddress: 'Юридична адреса',
      legalAddressVL: 'Юридична адреса ВЛ',
      nameDocument: 'Назва документу про співпрацю',
      contractStartDate: 'Дата укладання договору про співпрацю',
      contractEndDate: 'Дата закінчення договору про співпрацю',
      contractDate: 'Дата договору',
      contractEmpty: 'Договів про співпрацю відсутній',
      setEquipment: 'Матеріально-технічне забезпечення',
      viewBranchInfo: 'Філія',
      chooseWorkLine: 'Виберіть лінію для перегляду чи редагування МТЗ'
    },
    equipment: {
      model: 'Модель',
      passportNumber: 'Номер сертифіката про калібрування',
      serialNumber: 'Серійний номер',
      equipmentModel: 'Модель',
      dateLastCheck: 'Дата калібування',
      dateNextCheck: 'Дата наступного калібрування',
      line: 'Лінія {lineNumber}',
      equipmentDataEmpty: 'Дані не вказано.',
      addEquipmentData: 'Додати дані',
      deviceNeedsVerification: 'Пристрій потребує повірки',
      deviceWillNeedVerificationSoon: 'Пристрій незабаром потрібно перевірити',
    }
  },
  branch: {
    user: {
      title: 'Співробітники',
      addButton: 'Додати співробітника',
      formTitle: 'Інформація співробітника',
      lastName: 'Прізвище співробітника',
      firstName: 'Ім\'я співробітника',
      fio: 'ФІО',
      id: 'ID',
      middleName: 'По батькові',
      role: 'Функціональна роль',
      position: 'Посада',
      ipn: 'РНОКПП (ІПН)',
      serialPassport: 'Номер паспорта',
      email: 'Електронна адреса',
      password: 'Пароль',
      passport: 'Паспорт / РНОКПП (ІПН)',
      status: 'Статус',
      goToList: 'До списку співробітників',
      resetPassword: 'Скинути пароль',
      resetPasswordText: 'Ви дійсно бажаєте скинути пароль для користувача? Новий пароль прийде користувачу на' +
        ' пошту {email}',
      resetPasswordButton: 'Так, скинути пароль',
      passwordHasBeenReset: 'Пароль успішно скинуто',
      roleDescription: {
        sectionChiefLaboratory: 'Керівник дільниці лабораторії',
        sectionChiefLaboratoryText: ` - працівник лабораторії закріплений за визначеною дільницею, у кабінеті 
        має право заповнювати дані про матеріально-технічне забезпечення (МТЗ) дільниці, відправляти лінії
         дільниці на перевірку, додавати співробітників дільниці, переглядати інформацію про філію і її статистику. 
         Також підписує протокол огляду КТЗ, після підпису двох експертів лабораторії.`,
        expert: 'Експерт',
        expertText: ` - працівник лабораторії закріплений за визначеною дільницею, має право проводити огляд колісного
         транспортного засобу (КТЗ) для заяв обовʼязкового технічного контролю (ОТК) і сертифікації. Також підписує
          протокол огляду КТЗ (протокол огляду повинні підписати два експерти лабораторії).`,
        laboratoryManager: 'Менеджер лабораторії',
        laboratoryManagerText: ` - працівник лабораторії закріплений за визначеною дільницею, має право створювати 
        заявки для обовʼязкового технічного контролю (ОТК) і сертифікації. Також із цієї ролі виконується підписання
         заявки клієнтом (підпис на планшеті), зараховується оплата за проведення огляду, схвалюється/відхиляється
          заявка після підтвердження оплати.`
      }
    },
    laboratory: {
      title: 'Інформація по лабораторії',
      activeBranch: 'Активні дільниці ВЛ',
      moderationBranch: 'Дільниці на модерації',
      statementBranchTitle: 'Інформація по дільниці',
    },
    info: {
      title: 'Інформація по філії'
    }
  },
  statistic: {
    defaultTitle: 'Статистика',
    OCTitle: 'Статистика заявок по ОС',
    VLTitle: 'Статистика заявок по ВЛ',
    branchTitle: 'Статистика заявок по філії',
    statementsTransferredToWork: 'Передано заявок на роботу',
    allStatement: 'Всього сертифікатів',
    sentStatementToRegister: 'Передано до відкритого реєстру',
    statementsInProgress: 'Заявок в роботі',
    statementsCompleted: 'Виконано заявок',
    filterBetweenDates: 'Фільтрувати між датами',
    button: {
      oneMonth: '1 місяць',
      twoMonth: '2 місяці',
      threeMonth: '3 місяці',
      allTime: 'Весь час',
      currentYear: 'Поточний рік'
    },
    empty: 'Дані відсутні.',
    statementEmpty: 'Заявок не знайдено',
    statementLabel: 'заявок'
  },
  serial_number_photo: 'Фото серійного номеру прибора',

  contract: {
    title: 'Договори про співпрацю',
    titleForm: 'Додати договір про співпрацю',
    fileCaption: 'Договір про співпрацю',
    filter: 'Фільтр',
    filterButtonAll: 'Всі',
    setDecision: 'Прийняти рішення',
    contractNameHint: 'Договір, Контракт тощо',
    direction: 'Тип заявки',
    directionIn: 'Вхідна',
    directionOut: 'Вихідна',
    success: 'Договір успішно збережений',
    successUpdate: 'Угоду успішно оновлено',
    contractTerm: 'Термін дії угоди',
    needsExtension: 'Термін дії мине через {0} днів',
    createContractWithVl: 'Створити угоду з Випробувальною лабораторією',
    createContractWithOC: 'Створити угоду з Органом сертифікації',
    createContract: 'Створити угоду',
    updateContract: 'Оновити угоду',
    renewalContract: 'Оновлення угоди з: {0}',
    backToStatementsOfCooperation: 'До заяв на співпрацю',
    cooperationHasBeenApproved: 'Заява на співрпацю схвалена',
    cooperationHasBeenRejected: 'Заява на співрпацю відхилена'
  },

  extractFromTheRegisterEDRPOU: 'Витяг з реєстру ЄДРПОУ',
  accreditationCertificateNAAU: 'Атестат про акредитацію НААУ',
  spheresAccreditationProject: 'Сфера акредитації',
  appointmentOrderOfManager: 'Наказ про призначення керівника',
  orderMIU: 'Наказ МІУ',
  insurance: 'Страхування',
  cooperationAgreement: 'Договір про співробітництво',
  headFullName: 'Прізвище ім`я по батькові',
  passportVL: 'Паспорт ВЛ',
  passportVLBranch: 'Паспорт ВЛ для дільниці',
  sphereAccreditation: 'Сфери акредитації ВЛ',
  sphereAccreditationBranch: 'Сфери акредитації ВЛ для дільниці',
  legalDocumentsVL: 'Правовстановлюючі документи',
  dataMeasuringMethods: 'Дані про оцінку методів випробувань',
  textHintNormFirstNoiseMeasurement: 'Фоновий шум має бути меншим на 10 дБ(А) від шуму КТЗ',
  textHintNormNextNoiseMeasurement: `Відмінність від першого виміру не повинна перевищувати різницю в 2 дБ(А) і
    фоновий шум має бути меншим на 10 дБ(А) від шуму КТЗ`,
  textHintAverageNormNoiseMeasurement: 'Середнє значення не більше {0} дБ(А)',
  couplingDeviceWeight: 'Вага ТЗП',
  couplingDeviceMaxWeight: 'Допустима максимальна маса буксируючого причіпу',
  transferableNumber: 'Передатні числа',
  addTransmissibleNumbers: 'Додавання передатніх чисел',
  trailerMaxWeightWithBrakes: 'Максимальна маса причепа за наявності робочої системи гальмування',
  semiTrailerWeight: 'Максимальна маса Напівпричепа',
  maximumTrailerWeight: 'Максимальна маса причепа',
  trailerMaxWeightWithoutBrakes: 'За відсутності робочої системи гальмування',
  movableCouplingDeviceMaxWeight: 'З рухомим у вертикальній площині зчіпним пристроєм',
  staticCouplingDeviceMaxWeight: 'З нерухомим у вертикальній площині зчіпним пристроєм',
  ratioEnginePowerToWeight: 'Відношення максимальної потужності до маси КТЗ у спорядженому стані',
  availabilityNeutralizer: 'Наявність нейтралізатора',
  typeNeutralizerUsed: 'Тип використаного нейтралізатора',
  account: 'Обліковий запис',
  accountInfo: 'Інформація облікового запису',
  excessAirFactor: 'Коефіцієнт надлишку повітря',
  personalNumber: 'Персональний номер',
  issuedDepartment: 'Орган що видав',
  fillForm: 'Заповнити форму',
  setFormFromSampleVehicle: 'Форма заповнена згідно існуючого шаблону. Бажаєте перезаповнити форму?',
  //TODO: for testing profiles
  testFillForm: 'ТЕСТ ДЛЯ ФРОНТУ: Заповнити форму',
  'Car info with this vin not found': 'Інформацію по КТЗ з цим VIN кодом не знайдено!' +
    ' Спробуйте ще раз або просто продовжуйте створення заявки',
  carNotFoundKeepTyping: `Інформація по КТЗ з цим VIN кодом не знайдена, але все добре.
    Введіть всю необхідну інформацію і створіть заявку.`,
  vinCodeHint: 'VIN код: 9 - 17 символів',
  markingHeadlightHint: 'Кількість фар: 0. Маркування відсутнє.',
  vinCodeDifferent: 'VIN відрізняються',
  vinCodeCarcass: 'VIN код кузова',
  foundClients: 'Знайдені клієнти',
  registrationNumber: 'Реєстраційний номер',
  exceptionCodes: 'Коди невідповідності',
  explanation: {
    modalTitle: 'Пояснення'
  },
  informationLaboratoryPerformance: `<b>Для початку роботи Випробувальної лабораторії в системі - потрібно пройти
   процедуру перевірки матеріально-технічного забезпечення окремих ліній.</b><br>
   Для початку перевірки потрібно:<br>
   <ol>
    <li>Вказати обов'язкове МТЗ для кожної робочої лінії в кожній філії і відправити на перевірку до техпідтримки за допомогою кнопки <b>"Відправити лінію на перевірку"</b>;</li>
    <li>Відправити всю ВЛ для перевірки МТЗ, для цього натиснути кнопку <b>"Відправити МТЗ на перевірку"</b>.</li>
   </ol>`,
  informationLaboratoryModeration: `Матеріально-технічне забезпечення філій на огляді у технічної підтримки.<br>
  Зачекайте на прийняття рішення.`,
  moderationMTZTitleApprove: 'Лінія перевірена',
  moderationMTZTitleRefinement: 'Лінія на доопрацюванні',
  moderationMTZTitleFilling: 'Лінія очікує заповнення МТЗ',
  moderationMTZTitleModeration: 'Лінія на перевірці',
  moderationMTZTitleDefault: 'Робоча лінія',

  technicalControlStatuses: {
    statementMTIWaitClientSign: 'Заявка очікує підписання клієнтом',
    statementMTIWaitPayment: 'Очікує оплати',
    statementMTIWaitDecision: 'Очікує схвалення',
    statementReject: 'Відхилено',
    statementMTIWaitInspection: 'Очікує проходження ОТК',
    statementMTIInProgressInspection: 'Проходження ОТК',
    inspectionWitSignatureLabExpert: 'Очікує підписання лаборанта ВЛ',
    statementMTIWaitSecondExpertSignature: 'Очікує підписання другого лаборанта ВЛ',
    inspectionWitSignatureLabChief: 'Очікує підписання керівника дільниці ВЛ',
    inspectionMTIWaitChiefSignatureAct: 'Акт невідповідності очікує підпису керівника дільниці ВЛ',
    inspectionWaitComplianceCompleted: 'Очікує заповнення відповідностей до правових актів',
    inspectionWaitStand: 'Очікує проведення випробування',
    inspectionMTIWaitSignatureSecondExpert: 'Очікує підписання другого лаборанта ВЛ',
    inspectionMTIWaitChiefSignatureProtocol: 'Протокол технічного огляду очікує підпису керівника дільниці ВЛ',
    inspectionProcessMTIFinished: 'Процедуру ОТК завершено'
  },
  technicalControlInspection: {
    vinCode: 'VIN (№ рами)',
    vehicleCategory: 'Категорія КТЗ',
    specialPurpose: 'Спеціальне призначення КТЗ',
    loadCapacity: 'Вантажопідйомність',
    registrationNumber: 'Державний реєстраційний номер',
    isCorrectRegistrationNumber: 'Відповідність державному реєстраційному номеру',
    vehicleMileage: 'Показник одометра',
    previousVehicleMileage: 'Попередній показник одометра',
    hasTurbineOrCompressor: 'Наявність турбіни чи компресора',
    engineEuroRate: 'Екологічний рівень',
    productionYear: 'Рік виробництва',
    firstRegistrationDate: 'Дата першої реєстрації',
    governmentRegistrationDate: 'Дата державної реєстрації',
    conversionDocumentsInspection: 'Переобладнення',
    isNeededDetailInspection: 'Додаток 8 "Перевірка сили світла ПЗС"',
    btnRemark: 'Додати зауваження',
    textRemark: 'Невідповідності, що непередбачувані кодами невідповідності',
    thoughtsAndInterpretations: 'Думки та тлумачення',
    signatureInspectionMti: 'Підписати акт невідповідності',
    signatureProtocolMti: 'Підписати протокол технічного огляду',
    protocolMTI: 'Протокол технічного стану',
    nonComplianceAct: 'Акт невідповідності',
    protocolInspectionMTI: 'Протокол випробуваннь',
    informationInspectionMTI: 'Інформація по іспиту відповідностей ТС',
    conversion: {
      nameDocument: 'Назва документу',
      date: 'Дата',
      number: 'Номер документу',
      description: 'Суть переобладнання',
      addConversion: 'Додати документ',
      removeConversion: 'Видалити документ',
    },
    signNonComplianceAct: {
      success: 'Акт невідповідності успішно підписано',
      error: 'Акт невідповідності не підписано'
    },
    signProtocol: {
      success: 'Протокол технічного огляду успішно підписано',
      error: 'Протокол технічного огляду не підписано'
    }
  },
  identificationAct: {
    clientRefusedSign: 'Клієнт відмовився від підпису',
    decisionInfo: 'Інформація по акту ідентифікації',
    reason: 'Причина невідповідності',
    showFile: 'Показати докази',
    proofReasonDiscrepancy: 'Докази причини невідповідності',
  },
  downloadViewFile: 'Для того щоб переглянути файл - завантажте його',

  userEducation: {
    // HE - Higher Education
    // AT - Advanced Training
    titleHE: 'Інформація про освіту',
    titleAT: 'Інформація про підвищення кваліфікації',
    numberHE: 'Серія і номер документа про вищу освіту',
    numberAT: 'Серія і номер документа про підвищення кваліфікації',
    educationalInstitution: 'Найменування навчального закладу',
    issuedDateHE: 'Дата видачі документа про вищу освіту',
    issuedDateAT: 'Дата видачі документа про підвищення кваліфікації',
    speciality: 'Спеціальність'
  },

  search: {
    searchText: 'Пошук',
    searchDocumentType: 'Тип документа',
    documentType: {
      statement: 'Заява',
      inspection: 'Інспекція',
      certificate: 'Сертифікат'
    },
    globalSearchInfo: 'Телефон, e-mail, назва організації або VIN-код',
    statementForOTK: 'Реєстраційний номер КТЗ, ФІО власника, Назва організації',
    statementForCertificate: 'VIN код КТЗ, ФІО власника, Назва організації',
    searchHint: 'Введіть Телефон / E-mail / Організація / VIN',
    searchNumber: 'Номер документа',
    searchByUser: 'ПІБ клієнта або автора',
    searchLastName: 'Прізвище',
    searchFirstName: 'Ім\'я',
    searchMiddleName: 'По батькові',
    typeName: {
      client: 'Клієнт',
      author: 'Автор'
    },
    date: {
      searchBetweenDates: 'Шукати документ між датами',
      searchDate: 'Шукати документ по даті',
      byCreatedDate: 'По даті створення',
      byFinishedDate: 'По даті закінчення',
      exactDate: 'Точна дата'
    },
    toSearch: 'Шукати',
    toClear: 'Очистити',

    result: {
      searchResult: 'Результати пошуку',
      resultCount: 'знайдено {count} результатів',

      statements_for_certifications: '{suffix}Заяви на сертифікацію',
      vehicle_inspections: '{suffix}Інспекція',
      vehicle_certificates: '{suffix}Сертифікати',

      setQuerySearch: 'Вкажіть параметри для пошуку',
      forSuccessSearch: 'Для вдалого пошуку',
      chooseDocType: 'виберіть типи документів які Вас цікавлять',
      otherParams: 'та по якому критерію шукати',

      loadMore: 'Показати ще {count}',
      shown: 'Відображено {count} з {countTotal}',

      statement: 'Заява',
      inspection: 'Картка огляду',
      certificate: 'Сертифікат',

      ktz: 'КТЗ',
      fullNameClient: 'Клієнт',
      fullNameAuthor: 'Автор',
      collapse: 'Згорнути результати',
      expand: 'Розгорнути результати'
    }
  },
  techSupport: {
    title: 'Технічна підтримка',
    subtitle: 'Звернення у формі',
    textLabel: 'Опис звернення',
    textPlaceholder: 'Якщо у Вас виникли труднощі з роботою в системі, будь ласка, заповніть форму звернення.' +
      ' Опишіть проблему якомога детальніше, щоб ми могли швидко Вам допомогти.',
    statementCertificationLabel: 'Номер заявки (якщо таку було створено раніше)',
    errorUrlLabel: 'Посилання на сторінку, де відбулась потреба звернення',
    statusLabel: 'Статус звернення',
    additionalEmailLabel: 'Додатковий e-mail',
    inquirySuccess: 'Ваше звернення успішно відправлене. Очікуйте на відповідь',
    inquiryError: 'Помилка відправки звернення',
    number: 'Номер звернення',
    createAt: 'Дата звернення',
    inquirySent: 'Звернення відправлено',
    inquiryErrorStatement: 'Заявка з номером {certification} відсутня',
    inquiryErrorText: 'Текст звернення не може бути пустим',
    buttonLabel: 'Підтримка',
    buttonChatLabel: 'Чат підтримки',
    buttonFormLabel: 'Форма зв\'язку'
  },
  notification: {
    title: 'Сповіщення',
    readAll: 'Позначити всі як прочитані',
    empty: 'Немає нових сповіщень'
  },
  standSensor: {
    effortLeft: 'Сенсор зусилля лівий',
    effortRight: 'Сенсор зусилля правий',
    performanceIndicator: 'Індикатор роботи',
    presenceSensorLeft: 'Індикатор наявності лівий',
    presenceSensorRight: 'Індикатор наявності правий',
    readyIndicator: 'Індикатор готовності',
    sensorDrive: 'Привід роликів',
    sensorHandbrake: 'Сенсор ручника',
    sensorPedal: 'Сенсор педалі',
    speedSensorLeft: 'Сенсор обертів лівий',
    speedSensorRight: 'Сенсор обертів правий',
    weight: 'Сенсор Ваги',
    status: {
      startAndWait: 'Запустіть тест та очікуйте відповіді',
      status: 'Статус',
      testingFailed: 'Тестування пройдене не вдало',
      testingPassed: 'Тестування пройдене'
    },
    title: {
      startTestAgain: 'Ви можете провести повторне тестування вибраної вісі, результат буде оновлено.',
      startTestInfoText: 'Переконайтесь, що обидва колеса правильно поставлені на стенд.',
      sureRemoveStand: 'Ви впевнені що хочете видалити стенд з центру тестування?',
      sureRemoveCarMark: 'Ви впевнені що хочете видалити марку?',
      sureRemoveCarModel: 'Ви впевнені що хочете видалити модель?',
      sureRemoveTypeVehicle: 'Ви впевнені що хочете видалити ТЗ?',
      sureRemoveColor: 'Ви впевнені що хочете видалити колір?',
      sureRemoveFuel: 'Ви впевнені що хочете видалити тип палива?',
      sureRemoveVersion: 'Ви впевнені що хочете видалити версію?',
      testingCenterStands: 'Стенди прив`язані до центру тестування',
      testingStandSensor: 'Тестування сенсорів стенду',
      vehicleInfoText: 'Якщо по номеру шасі транспортного засобу інформація була у базі - форма буде заповнена.',
      warningSensor: 'ОБЕРЕЖНО! Запуск двигунів роликів',
      startScales: 'Навантажте сенсор ваги, задайте значення, запустіть тест та очікуйте на результат',
      startBrake: 'Навантажте сенсор тормозного зусилля, задайте значення, запустіть тест та очікуйте на результат',
      getSpeedShaft: 'Надайте обертів валу швидкості, запустіть тест та очікуйте на результат',
      turnSpeedShaft: 'Навантажте сенсор наявності, запустіть тест та очікуйте на результат'
    },
  },
  sensorTesting: 'Тестування сенсорів',
  addAllCheckbox: 'Додати усі відмітки',
  removeAllCheckbox: 'Зняти усі відмітки',
  measurementModeRound: 'Цільова частота обертання',
  resultEmpty: 'Результат відсутній',
  warningMeasurement: 'Обережно, проводиться вимірювання, дотримуйтесь техніки безпеки',
  errorMeasurement: 'Помилка, пристрій не відповідає, спробуйте ще раз або зверніться за допомогою',
  noiseMeasurement: {
    instruction: 'РЕКОМЕНДАЦІЇ ЩОДО ПРОВЕДЕННЯ ВИПРОБУВАНЬ',
    description: [
      'Поверхня випробувального майданчика має мати міцне суцільне покриття без снігу, високої трави, рихлої землі чи золи.',
      'Не допускається проведення вимір у невідповідних погодних умовах.',
      // eslint-disable-next-line vue/max-len
      'Метеорологічна станція встановлюється поблизу випробувального майданчика, поза зоною вимір на висоті 1,2 ± 0,02 м. Для початку вимір повинні виконуватися такі умови:',
      'Температура навколишнього повітря знаходиться у межах від 5° до 40 °C.',
      'Швидкість вітру на висоті встановлення мікрофону не перевищує 5 м/с',
      // eslint-disable-next-line vue/max-len
      'Мікрофон повинен бути розашований згідно схеми наведеної у Додатку 3 схеми 3а - 3d до правила ЄЕК ООН 52-01. По-висоті мікрофон розташовують на рівні контрольної точки, але не нижче 0.2 м від землі для вихлопних труб горизонтального розташування, та на висоті 0,5 м ± 0,01 м нижче контрольної точки для вихлопних труб вертикального розташування .',
      'Між мікрофоном та джерелом звуку не має бути ніяких перешкод, що можуть негативно вплинути на результати вимірювань'
    ]
  },
  wrongField: {
    title: 'Доопрацювання заявки',
    subtitle: 'Деякі дані не відповідають вимогам. Виправте помилки та надішліть заявку знову.',
    subtitleBranch: 'Деякі дані представництв не відповідають вимогам. Виправте помилки та надішліть заявку знову.',
    subtitleFile: 'Файли не відповідають вимогам. Виправте помилки та надішліть заявку знову.',
    labelField: 'Поле',
    labelComment: 'Коментар',
    labelFile: 'Файл',
    comment: 'Коментар: {comment}',
    fieldName: {
      author: 'ПІБ директора',
      director_passport_serial: 'Паспортні дані (номер серія) Директора',
      director_passport_inn: 'РНОКПП (ІПН) Директора',
      name: 'Повна назва організації',
      short_name: 'Скорочена назва організації',
      EDPROU: 'Код ЄДРПОУ',
      code: 'Номер призначений ООВ (Органу з сертифікації) або згідно нотифікації ЄК ООН',
      phone_numbers: 'Номери телефонів',
      landline_phone: 'Телефон стаціонарний',
      email: 'Електронна поштова адреса',
      web_resource_link: 'Посилання на веб-ресурс',
      order_number: 'Номер наказу МІУ',
      order_date: 'Дата наказу МІУ',
      accreditation_certificate_number: 'Номер атестату акредитації НААУ',
      accreditation_certificate_date_start: 'Дата початку дії акредитації НААУ',
      accreditation_certificate_date_end: 'Дата закінчення дії акредитації НААУ',
      address: 'Адреса',
      allow_categories: 'Категорії КТЗ',
      accreditationCertificateNAAU: 'Атестат про акредитацію НААУ',
      insurance: 'Страхування',
      insurance_fields: 'Страхування',
      orderMIU: 'Наказ МІУ',
      spheresAccreditationProject: 'Проект "Сфери акредитації"',
      extractFromTheRegisterEDRPOU: 'Витяг з реєстру ЄДРПОУ',
      appointmentOrderOfManager: 'Наказ про призначення керівника',
      passport: 'Паспорт директора',
      itn: 'РНОКПП (ІПН)',
      date_last_revision: 'Дата останньої перевірки',
      date_next_revision: 'Дата наступної перевірки',
      director_first_name: 'Ім\'я',
      director_last_name: 'Прізвище',
      director_middle_name: 'По батькові',
      director_date_birth: 'Дата народження',
      director_email: 'Електронна адреса',
      head_full_name: 'Прізвище ім`я по батькові',
      phone_number: 'Номер телефону',

      first_name: 'Ім\'я',
      last_name: 'Прізвище',
      middle_name: 'По батькові',
      serial: 'Номер паспорта',
      inn: 'РНОКПП (ІПН)',
      position: 'Займана посада в органі з оцінки відповідності',
      experience_years: 'Досвід виконання робіт з оцінки відповідності продукції, років',
      education_document_number: 'Документ, що підтверждує здобуття вищої освіти (серія, номер)',
      educational_institution: 'Найменування навчального закладу',
      education_document_issued_date: 'Дата видачі документу, що підтверджує здобуття вищої освіти',
      specialization: 'Спеціальність та кваліфікація',
      direction_raising_qualification: 'Напрям підвищення кваліфікації',
      raising_qualification_document_number: 'Документ, отриманий за результатами підвищення кваліфікації (серія, номер)',
      raising_qualification_date: 'Дата видачі документу, отриманого за результатами підвищення кваліфікації',
      educationDocument: 'Диплом про вищу освіту',
      raisingQualificationDocument: 'Документ підвищення кваліфікації',
      identityDocument: 'Документ що посвідчує особу',

      legalDocumentsVL: 'Правовстановлюючі документи',
      passportVL: 'Паспорт ВЛ',
      sphereAccreditation: 'Сфери акредитації ВЛ',
      number: 'Кількість комплексів обладнання',
      dataMeasuringMethods: 'Дані про оцінку методів випробувань'
    },
    employeeHasWrongField: 'У співробітника {name} є невірні дані.<br>Натисніть на редагування щоб виправити.',
    branchHasWrongField: 'У дільниці {name} є невірні дані.<br>Натисніть на редагування щоб виправити.',
    wrongInfoVL: 'Доопрацювання заявки на реєстрацію ООВ. Деякі дані вказано невірно. Будь ласка, виправте їх та ' +
      'надішліть заявку на перевірку.',
    successInfoVL: 'Всі невірні дані виправлено. Заявку на реєстрацію ООВ можна надіслати на перевірку.',
    wrongOrganizationVL: 'Дані в Органі з оцінки відповідності',
    wrongBranchVL: 'Дані в дільниці випробувальної лабораторії',
    emptyWrongDataVL: 'По ООВ зауваження відсутні',
    emptyWrongDataBranch: 'По дільницям зауваження відсутні',
    emptyWrongEmployee: 'Співробітники відредаговані. Ви перейшли до наступного кроку'
  },
  autoSave: {
    autoSaveAfter: 'Автозбереження через {time} сек',
    saving: 'Збереження..',
    saved: 'Збережено'
  },
  chooseFIle: 'Виберіть файл(и)',
  or: 'або',
  dragAndDrop: 'Перетягніть файл сюди',
  isFilesSizeInvalid: 'Розмір файлу не повинен перевищувати {size} МБ',
  isFileNameLengthInvalid: 'Довжина імені файлу більше ніж 100 знаків. Змініть назву файлу',
  equipmentIsBusy: 'Прилад "{equipment}" зараз зайнятий користувачем "{name}". Виберіть інший прилад або звільніть його',
  equipmentIsBusyLabel: 'Прилад зайнятий',
  ruleBase: {
    title: 'Нормативна база',
    titleDocument: 'Нормативні документи',
    certificationType: {
      label: 'Тип сертифікату',
      labelKTZ: 'Категорія КТЗ',
      completedKTZ: 'Завершеного КТЗ',
      stepCompletedKTZ: 'Поетапно завершеного КТЗ',
      individualCompletedKTZ: 'Індивідуальне затвердження КТЗ'
    },
    settingHint: 'Виберіть Тип сертифікату і Категорію КТЗ для відображення нормативнтих документів',
    card: {
      ruleName: 'Нормативний документ',
      ruleNumber: 'Правило нормативного документу',
      createRuleBase: 'Новий технічний припис',
      editRuleBase: 'Змінити номер правила'
    },
    gridView: 'Вигляд'
  },
  attachFile: 'Додати файл',
  startCertificateNumber: 'Початковий номер сертифікату відповідності',
  startCertificateNumberAreYouSure: 'Після збереження початкового номера сертифікату {number} подальщі зміни в' +
    ' нумерації можливі лише за звернення до ТехПідтримки',
  dateInspect: 'Дата огляду',
  indicatorAmendmentResult: 'Показник поправки результатів вимірювання стосовно фонового шума',
  rejectReason: 'Причина відхилення',
  statementRejected: 'Заява відхилена',
  authoritiesCertificate: 'Орган з сертифікації',
  registerStandardUkraine: 'Відкритий реєстр з стандартизації України',
  titleCardRegisterStandardUkraine: 'Інтеграція з Відкритим реєстром Сертифікатів',
  dateCreatedKey: 'Дата створення ключа',
  labelFieldApiKey: 'API-ключ для передачі Сертифікатів до Відкритого реєстра з стандартизації України',
  titleUpdateApiKey: 'Оновлення API-ключа',
  apiKeySuccessUpdated: 'API-ключ успішно оновленний',
  apiKeyNotFound: 'API-ключ не знайдено',
  statisticTitleCard: 'Статистика передачі Сертифікатів до відкритого реєстру України',
  setDateReview: 'Призначити дату огляду ТЗ',
  dateReview: 'Дата огляду',
  comment: 'Коментар',
  dateReviewSet: 'Дата огляду ТЗ призначена',
  completeStatementCertificate: 'Оформити заявку на сертифікацію',
  completeStatementTechnicalCertificate: 'Оформити заявку на ОТК',
  changePassword: {
    title: 'Змінити пароль',
    currentPassword: 'Поточний пароль',
    newPassword: 'Новий пароль',
    confirmNewPassword: 'Підтвердіть новий пароль',
    updatePassword: 'Оновити пароль',

    This_password_is_too_common: 'Новий пароль надто поширений',
    This_password_is_entirely_numeric: 'Новий пароль складається тільки з цифр',
    Old_and_new_passwords_are_the_same: 'Старий і новий паролі співпадають. Вкажіть новий пароль відмінний від старого',
    Incorrect_password: 'Поточний пароль невірний',
    Incorrect_email_or_password: 'Невірний логін або пароль',
    successChangePassword: 'Пароль успішно змінено',
    passwordNotChanged: 'Пароль не змінено',
    authForgot: 'Забули пароль?',
    The_token_is_not_Valid_or_Expired: 'Час на виконання зміни паролю вичерпано. Повторіть процедуру зміни паролю',
    Not_found: 'Користувача з таким email не знайдено',
  },
  forgotPassword: {
    title: 'Відновлення паролю',
    button: 'Відновити пароль',
    sentEmail: 'На вказану електронну пошту надіслано лист з інструкціями по відновленню паролю',
    successChangePassword: 'Пароль успішно змінено. Застосовуйте новий пароль для входу в систему',
  },
  sendCertificateToUAS: {
    btnSendCertificateToUAS: 'Опублікувати у відкритому реєстрі сертифікатів',
    successSendCertificateToUAS: `Сертифкат опублікований у відкритому реєстрі зі стандартизації України`
  },
  openInNewWindow:"Відкрити у новому вікні",
  goToStatement: 'Перейти до заяви',
  devices: 'пристроїв',
  on: 'на',
  page: 'сторінці',
  pages: 'сторінок',
  statements: 'заяв',
  workers: 'співробітників',
  record: 'запис',
  finalizationInspection: {
    modalSendForFinalization: {
      btnOpenModal: 'Зауваження на доопрацювання',
      title: 'Внесення змін у огляді КТЗ',
      remark: 'Внести зауваження до Протоколу',
      btnSendToFinalization: 'Відправити на доопрацювання',
      btnReadTheRemark: 'Ознайомитися з зауваженнями'
    }
  },
  driveAssistance: {
    btnOpenModal: 'Допомога при виїзді',
    titleModal: 'Увімкнути допомогу при виїзді?',
    typesAxles: {
      title: 'Допомога при виїзді для осі',
      driveAxis: 'Рушійні ось',
      controlledAxis: 'Керуючі ось',
    },
    statuses: {
      waiting: 'Очікування стабільної швидкості для заїзду',
      assisting: 'Початок допомоги виїзду',
      ready: 'Виїзд завершено'
    },
    btnStopDriveAssistance: 'Зупинити стенд'
  },
  "indicateNonCompliance":"Зазначити не відповідності",
  "noteIndicateNonCompliance":"Залишити примітку до невідповідностей",
  "waitingModeration": "Очікує модерацію техпідтримки"
}
